// THIS FILE IS AUTO-GENERATED BY scripts/src/commands/generateAddressCountries.ts.

import { registerCountry } from 'lib-address'

import type { CountryData } from 'lib-address/dist/types'

const addressCountries = [
    {
        id: 'data/AC',
        key: 'AC',
        name: 'ASCENSION ISLAND',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: 'ASCN 1ZZ',
        zipex: 'ASCN 1ZZ',
    },
    {
        id: 'data/AD',
        key: 'AD',
        name: 'ANDORRA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: 'AD[1-7]0\\d',
        zipex: 'AD100,AD501,AD700',
        sub_regions: [
            {
                key: '07',
                name: {
                    default: 'Andorra la Vella',
                },
                zip: 'AD50[01]',
            },
            {
                key: '02',
                name: {
                    default: 'Canillo',
                },
                zip: 'AD10[01]',
            },
            {
                key: '03',
                name: {
                    default: 'Encamp',
                },
                zip: 'AD20[01]',
            },
            {
                key: '08',
                name: {
                    default: 'Escaldes-Engordany',
                },
                zip: 'AD70[01]',
            },
            {
                key: '04',
                name: {
                    default: 'La Massana',
                },
                zip: 'AD40[01]',
            },
            {
                key: '05',
                name: {
                    default: 'Ordino',
                },
                zip: 'AD30[01]',
            },
            {
                key: '06',
                name: {
                    default: 'Sant Julià de Lòria',
                },
                zip: 'AD60[01]',
            },
        ],
    },
    {
        id: 'data/AE',
        key: 'AE',
        name: 'UNITED ARAB EMIRATES',
        fmt: '%N%n%O%n%A%n%S',
        lfmt: '%N%n%O%n%A%n%S',
        require: 'AS',
        sub_regions: [
            {
                key: 'AZ',
                name: {
                    default: 'أبو ظبي',
                    latin: 'Abu Dhabi',
                },
            },
            {
                key: 'SH',
                name: {
                    default: 'الشارقة',
                    latin: 'Sharjah',
                },
            },
            {
                key: 'FU',
                name: {
                    default: 'الفجيرة',
                    latin: 'Fujairah',
                },
            },
            {
                key: 'UQ',
                name: {
                    default: 'ام القيوين',
                    latin: 'Umm Al Quwain',
                },
            },
            {
                key: 'DU',
                name: {
                    default: 'دبي',
                    latin: 'Dubai',
                },
            },
            {
                key: 'RK',
                name: {
                    default: 'رأس الخيمة',
                    latin: 'Ras al Khaimah',
                },
            },
            {
                key: 'AJ',
                name: {
                    default: 'عجمان',
                    latin: 'Ajman',
                },
            },
        ],
    },
    {
        id: 'data/AF',
        key: 'AF',
        name: 'AFGHANISTAN',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: '\\d{4}',
        zipex: '1001,2601,3801',
    },
    {
        id: 'data/AG',
        key: 'AG',
        name: 'ANTIGUA AND BARBUDA',
        require: 'A',
    },
    {
        id: 'data/AI',
        key: 'AI',
        name: 'ANGUILLA',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: '(?:AI-)?2640',
        zipex: '2640',
    },
    {
        id: 'data/AL',
        key: 'AL',
        name: 'ALBANIA',
        fmt: '%N%n%O%n%A%n%Z%n%C',
        zip: '\\d{4}',
        zipex: '1001,1017,3501',
    },
    {
        id: 'data/AM',
        key: 'AM',
        name: 'ARMENIA',
        fmt: '%N%n%O%n%A%n%Z%n%C%n%S',
        lfmt: '%N%n%O%n%A%n%Z%n%C%n%S',
        zip: '(?:37)?\\d{4}',
        zipex: '375010,0002,0010',
        sub_regions: [
            {
                key: 'AG',
                name: {
                    default: 'Արագածոտն',
                    latin: 'Aragatsotn',
                },
                zip: '0[2-5]',
            },
            {
                key: 'AR',
                name: {
                    default: 'Արարատ',
                    latin: 'Ararat',
                },
                zip: '0[6-8]',
            },
            {
                key: 'AV',
                name: {
                    default: 'Արմավիր',
                    latin: 'Armavir',
                },
                zip: '09|1[01]',
            },
            {
                key: 'GR',
                name: {
                    default: 'Գեղարքունիք',
                    latin: 'Gegharkunik',
                },
                zip: '1[2-6]',
            },
            {
                key: 'ER',
                name: {
                    default: 'Երևան',
                    latin: 'Yerevan',
                },
                zip: '00',
            },
            {
                key: 'LO',
                name: {
                    default: 'Լոռի',
                    latin: 'Lori',
                },
                zip: '1[7-9]|2[01]',
            },
            {
                key: 'KT',
                name: {
                    default: 'Կոտայք',
                    latin: 'Kotayk',
                },
                zip: '2[2-5]',
            },
            {
                key: 'SH',
                name: {
                    default: 'Շիրակ',
                    latin: 'Shirak',
                },
                zip: '2[6-9]|3[01]',
            },
            {
                key: 'SU',
                name: {
                    default: 'Սյունիք',
                    latin: 'Syunik',
                },
                zip: '3[2-5]',
            },
            {
                key: 'VD',
                name: {
                    default: 'Վայոց ձոր',
                    latin: 'Vayots Dzor',
                },
                zip: '3[6-8]',
            },
            {
                key: 'TV',
                name: {
                    default: 'Տավուշ',
                    latin: 'Tavush',
                },
                zip: '39|4[0-2]',
            },
        ],
    },
    {
        id: 'data/AO',
        key: 'AO',
        name: 'ANGOLA',
    },
    {
        id: 'data/AQ',
        key: 'AQ',
        name: 'ANTARCTICA',
    },
    {
        id: 'data/AR',
        key: 'AR',
        name: 'ARGENTINA',
        fmt: '%N%n%O%n%A%n%Z %C%n%S',
        zip: '((?:[A-HJ-NP-Z])?\\d{4})([A-Z]{3})?',
        zipex: 'C1070AAM,C1000WAM,B1000TBU,X5187XAB',
        upper: 'ACZ',
        sub_regions: [
            {
                key: 'B',
                name: {
                    default: 'Buenos Aires',
                },
                zip: 'B?[1-36-8]',
            },
            {
                key: 'K',
                name: {
                    default: 'Catamarca',
                },
                zip: 'K?[45]',
            },
            {
                key: 'H',
                name: {
                    default: 'Chaco',
                },
                zip: 'H?3',
            },
            {
                key: 'U',
                name: {
                    default: 'Chubut',
                },
                zip: 'U?[89]',
            },
            {
                key: 'C',
                name: {
                    default: 'Ciudad Autónoma de Buenos Aires',
                },
                zip: 'C?1',
            },
            {
                key: 'X',
                name: {
                    default: 'Córdoba',
                },
                zip: 'X?[235-8]',
            },
            {
                key: 'W',
                name: {
                    default: 'Corrientes',
                },
                zip: 'W?3',
            },
            {
                key: 'E',
                name: {
                    default: 'Entre Ríos',
                },
                zip: 'E?[1-3]',
            },
            {
                key: 'P',
                name: {
                    default: 'Formosa',
                },
                zip: 'P?[37]',
            },
            {
                key: 'Y',
                name: {
                    default: 'Jujuy',
                },
                zip: 'Y?4',
            },
            {
                key: 'L',
                name: {
                    default: 'La Pampa',
                },
                zip: 'L?[3568]',
            },
            {
                key: 'F',
                name: {
                    default: 'La Rioja',
                },
                zip: 'F?5',
            },
            {
                key: 'M',
                name: {
                    default: 'Mendoza',
                },
                zip: 'M?[56]',
            },
            {
                key: 'N',
                name: {
                    default: 'Misiones',
                },
                zip: 'N?3',
            },
            {
                key: 'Q',
                name: {
                    default: 'Neuquén',
                },
                zip: 'Q?[38]',
            },
            {
                key: 'R',
                name: {
                    default: 'Río Negro',
                },
                zip: 'R?[89]',
            },
            {
                key: 'A',
                name: {
                    default: 'Salta',
                },
                zip: 'A?[34]',
            },
            {
                key: 'J',
                name: {
                    default: 'San Juan',
                },
                zip: 'J?5',
            },
            {
                key: 'D',
                name: {
                    default: 'San Luis',
                },
                zip: 'D?[4-6]',
            },
            {
                key: 'Z',
                name: {
                    default: 'Santa Cruz',
                },
                zip: 'Z?[89]',
            },
            {
                key: 'S',
                name: {
                    default: 'Santa Fe',
                },
                zip: 'S?[2368]',
            },
            {
                key: 'G',
                name: {
                    default: 'Santiago del Estero',
                },
                zip: 'G?[2-5]',
            },
            {
                key: 'V',
                name: {
                    default: 'Tierra del Fuego',
                },
                zip: 'V?9',
            },
            {
                key: 'T',
                name: {
                    default: 'Tucumán',
                },
                zip: 'T?[45]',
            },
        ],
    },
    {
        id: 'data/AS',
        key: 'AS',
        name: 'AMERICAN SAMOA',
        fmt: '%N%n%O%n%A%n%C %S %Z',
        zip: '(96799)(?:[ \\-](\\d{4}))?',
        zipex: '96799',
        upper: 'ACNOS',
        require: 'ACSZ',
    },
    {
        id: 'data/AT',
        key: 'AT',
        name: 'AUSTRIA',
        fmt: '%O%n%N%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '1010,3741',
        require: 'ACZ',
    },
    {
        id: 'data/AU',
        key: 'AU',
        name: 'AUSTRALIA',
        fmt: '%O%n%N%n%A%n%C %S %Z',
        zip: '\\d{4}',
        zipex: '2060,3171,6430,4000,4006,3001',
        upper: 'CS',
        require: 'ACSZ',
        sub_regions: [
            {
                key: 'ACT',
                name: {
                    default: 'Australian Capital Territory',
                },
                zip: '29|2540|260|261[0-8]|02|2620',
            },
            {
                key: 'JBT',
                name: {
                    default: 'Jervis Bay Territory',
                },
                zip: '2540',
            },
            {
                key: 'NSW',
                name: {
                    default: 'New South Wales',
                },
                zip: '1|2[0-57-8]|26[2-9]|261[189]|3500|358[56]|3644|3707',
            },
            {
                key: 'NT',
                name: {
                    default: 'Northern Territory',
                },
                zip: '0[89]',
            },
            {
                key: 'QLD',
                name: {
                    default: 'Queensland',
                },
                zip: '[49]',
            },
            {
                key: 'SA',
                name: {
                    default: 'South Australia',
                },
                zip: '5|0872',
            },
            {
                key: 'TAS',
                name: {
                    default: 'Tasmania',
                },
                zip: '7',
            },
            {
                key: 'VIC',
                name: {
                    default: 'Victoria',
                },
                zip: '[38]',
            },
            {
                key: 'WA',
                name: {
                    default: 'Western Australia',
                },
                zip: '6|0872',
            },
        ],
    },
    {
        id: 'data/AW',
        key: 'AW',
        name: 'ARUBA',
    },
    {
        id: 'data/AX',
        key: 'AX',
        name: 'FINLAND',
        fmt: '%O%n%N%n%A%nAX-%Z %C%nÅLAND',
        zip: '22\\d{3}',
        zipex: '22150,22550,22240,22710,22270,22730,22430',
        require: 'ACZ',
    },
    {
        id: 'data/AZ',
        key: 'AZ',
        name: 'AZERBAIJAN',
        fmt: '%N%n%O%n%A%nAZ %Z %C',
        zip: '\\d{4}',
        zipex: '1000',
    },
    {
        id: 'data/BA',
        key: 'BA',
        name: 'BOSNIA AND HERZEGOVINA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '71000',
    },
    {
        id: 'data/BB',
        key: 'BB',
        name: 'BARBADOS',
        fmt: '%N%n%O%n%A%n%C, %S %Z',
        zip: 'BB\\d{5}',
        zipex: 'BB23026,BB22025',
    },
    {
        id: 'data/BD',
        key: 'BD',
        name: 'BANGLADESH',
        fmt: '%N%n%O%n%A%n%C - %Z',
        zip: '\\d{4}',
        zipex: '1340,1000',
    },
    {
        id: 'data/BE',
        key: 'BE',
        name: 'BELGIUM',
        fmt: '%O%n%N%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '4000,1000',
        require: 'ACZ',
    },
    {
        id: 'data/BF',
        key: 'BF',
        name: 'BURKINA FASO',
        fmt: '%N%n%O%n%A%n%C %X',
    },
    {
        id: 'data/BG',
        key: 'BG',
        name: 'BULGARIA (REP.)',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '1000,1700',
    },
    {
        id: 'data/BH',
        key: 'BH',
        name: 'BAHRAIN',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '(?:^|\\b)(?:1[0-2]|[1-9])\\d{2}(?:$|\\b)',
        zipex: '317',
    },
    {
        id: 'data/BI',
        key: 'BI',
        name: 'BURUNDI',
    },
    {
        id: 'data/BJ',
        key: 'BJ',
        name: 'BENIN',
        upper: 'AC',
    },
    {
        id: 'data/BL',
        key: 'BL',
        name: 'SAINT BARTHELEMY',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '9[78][01]\\d{2}',
        zipex: '97100',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/BM',
        key: 'BM',
        name: 'BERMUDA',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '[A-Z]{2} ?[A-Z0-9]{2}',
        zipex: 'FL 07,HM GX,HM 12',
    },
    {
        id: 'data/BN',
        key: 'BN',
        name: 'BRUNEI DARUSSALAM',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '[A-Z]{2} ?\\d{4}',
        zipex: 'BT2328,KA1131,BA1511',
    },
    {
        id: 'data/BO',
        key: 'BO',
        name: 'BOLIVIA',
        upper: 'AC',
    },
    {
        id: 'data/BQ',
        key: 'BQ',
        name: 'BONAIRE, SINT EUSTATIUS, AND SABA',
    },
    {
        id: 'data/BR',
        key: 'BR',
        name: 'BRAZIL',
        fmt: '%O%n%N%n%A%n%D%n%C-%S%n%Z',
        zip: '\\d{5}-?\\d{3}',
        zipex: '40301-110,70002-900',
        upper: 'CS',
        require: 'ASCZ',
        sub_regions: [
            {
                key: 'AC',
                name: {
                    default: 'Acre',
                },
                zip: '699',
            },
            {
                key: 'AL',
                name: {
                    default: 'Alagoas',
                },
                zip: '57',
            },
            {
                key: 'AP',
                name: {
                    default: 'Amapá',
                },
                zip: '689',
            },
            {
                key: 'AM',
                name: {
                    default: 'Amazonas',
                },
                zip: '69[0-24-8]',
            },
            {
                key: 'BA',
                name: {
                    default: 'Bahia',
                },
                zip: '4[0-8]',
            },
            {
                key: 'CE',
                name: {
                    default: 'Ceará',
                },
                zip: '6[0-3]',
            },
            {
                key: 'DF',
                name: {
                    default: 'Distrito Federal',
                },
                zip: '7[0-1]|72[0-7]|73[0-6]',
            },
            {
                key: 'ES',
                name: {
                    default: 'Espírito Santo',
                },
                zip: '29',
            },
            {
                key: 'GO',
                name: {
                    default: 'Goiás',
                },
                zip: '72[89]|73[7-9]|7[4-6]',
            },
            {
                key: 'MA',
                name: {
                    default: 'Maranhão',
                },
                zip: '65',
            },
            {
                key: 'MT',
                name: {
                    default: 'Mato Grosso',
                },
                zip: '78[0-8]',
            },
            {
                key: 'MS',
                name: {
                    default: 'Mato Grosso do Sul',
                },
                zip: '79',
            },
            {
                key: 'MG',
                name: {
                    default: 'Minas Gerais',
                },
                zip: '3',
            },
            {
                key: 'PA',
                name: {
                    default: 'Pará',
                },
                zip: '6[6-7]|68[0-8]',
            },
            {
                key: 'PB',
                name: {
                    default: 'Paraíba',
                },
                zip: '58',
            },
            {
                key: 'PR',
                name: {
                    default: 'Paraná',
                },
                zip: '8[0-7]',
            },
            {
                key: 'PE',
                name: {
                    default: 'Pernambuco',
                },
                zip: '5[0-6]',
            },
            {
                key: 'PI',
                name: {
                    default: 'Piauí',
                },
                zip: '64',
            },
            {
                key: 'RJ',
                name: {
                    default: 'Rio de Janeiro',
                },
                zip: '2[0-8]',
            },
            {
                key: 'RN',
                name: {
                    default: 'Rio Grande do Norte',
                },
                zip: '59',
            },
            {
                key: 'RS',
                name: {
                    default: 'Rio Grande do Sul',
                },
                zip: '9',
            },
            {
                key: 'RO',
                name: {
                    default: 'Rondônia',
                },
                zip: '76[89]|789',
            },
            {
                key: 'RR',
                name: {
                    default: 'Roraima',
                },
                zip: '693',
            },
            {
                key: 'SC',
                name: {
                    default: 'Santa Catarina',
                },
                zip: '8[89]',
            },
            {
                key: 'SP',
                name: {
                    default: 'São Paulo',
                },
                zip: '[01][1-9]',
            },
            {
                key: 'SE',
                name: {
                    default: 'Sergipe',
                },
                zip: '49',
            },
            {
                key: 'TO',
                name: {
                    default: 'Tocantins',
                },
                zip: '77',
            },
        ],
    },
    {
        id: 'data/BS',
        key: 'BS',
        name: 'BAHAMAS',
        fmt: '%N%n%O%n%A%n%C, %S',
        sub_regions: [
            {
                key: 'Abaco',
                name: {
                    default: 'Abaco Islands',
                },
            },
            {
                key: 'AK',
                name: {
                    default: 'Acklins',
                },
            },
            {
                key: 'Andros',
                name: {
                    default: 'Andros Island',
                },
            },
            {
                key: 'BY',
                name: {
                    default: 'Berry Islands',
                },
            },
            {
                key: 'BI',
                name: {
                    default: 'Bimini',
                },
            },
            {
                key: 'CI',
                name: {
                    default: 'Cat Island',
                },
            },
            {
                key: 'Crooked Island',
                name: {
                    default: 'Crooked Island',
                },
            },
            {
                key: 'Eleuthera',
                name: {
                    default: 'Eleuthera',
                },
            },
            {
                key: 'EX',
                name: {
                    default: 'Exuma and Cays',
                },
            },
            {
                key: 'Grand Bahama',
                name: {
                    default: 'Grand Bahama',
                },
            },
            {
                key: 'HI',
                name: {
                    default: 'Harbour Island',
                },
            },
            {
                key: 'IN',
                name: {
                    default: 'Inagua',
                },
            },
            {
                key: 'LI',
                name: {
                    default: 'Long Island',
                },
            },
            {
                key: 'MG',
                name: {
                    default: 'Mayaguana',
                },
            },
            {
                key: 'N.P.',
                name: {
                    default: 'New Providence',
                },
            },
            {
                key: 'RI',
                name: {
                    default: 'Ragged Island',
                },
            },
            {
                key: 'RC',
                name: {
                    default: 'Rum Cay',
                },
            },
            {
                key: 'SS',
                name: {
                    default: 'San Salvador',
                },
            },
            {
                key: 'SW',
                name: {
                    default: 'Spanish Wells',
                },
            },
        ],
    },
    {
        id: 'data/BT',
        key: 'BT',
        name: 'BHUTAN',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '\\d{5}',
        zipex: '11001,31101,35003',
    },
    {
        id: 'data/BV',
        key: 'BV',
        name: 'BOUVET ISLAND',
    },
    {
        id: 'data/BW',
        key: 'BW',
        name: 'BOTSWANA',
    },
    {
        id: 'data/BY',
        key: 'BY',
        name: 'BELARUS',
        fmt: '%O%n%N%n%A%n%Z, %C%n%S',
        zip: '\\d{6}',
        zipex: '223016,225860,220050',
    },
    {
        id: 'data/BZ',
        key: 'BZ',
        name: 'BELIZE',
    },
    {
        id: 'data/CA',
        key: 'CA',
        name: 'CANADA',
        fmt: '%N%n%O%n%A%n%C %S %Z',
        zip: '[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d',
        zipex: 'H3Z 2Y7,V8X 3X4,T0L 1K0,T0H 1A0,K1A 0B1',
        upper: 'ACNOSZ',
        require: 'ACSZ',
        sub_regions: [
            {
                key: 'AB',
                name: {
                    default: 'Alberta',
                    fr: 'Alberta',
                },
                zip: 'T',
            },
            {
                key: 'BC',
                name: {
                    default: 'British Columbia',
                    fr: 'Colombie-Britannique',
                },
                zip: 'V',
            },
            {
                key: 'MB',
                name: {
                    default: 'Manitoba',
                    fr: 'Manitoba',
                },
                zip: 'R',
            },
            {
                key: 'NB',
                name: {
                    default: 'New Brunswick',
                    fr: 'Nouveau-Brunswick',
                },
                zip: 'E',
            },
            {
                key: 'NL',
                name: {
                    default: 'Newfoundland and Labrador',
                    fr: 'Terre-Neuve-et-Labrador',
                },
                zip: 'A',
            },
            {
                key: 'NT',
                name: {
                    default: 'Northwest Territories',
                    fr: 'Territoires du Nord-Ouest',
                },
                zip: 'X0E|X0G|X1A',
            },
            {
                key: 'NS',
                name: {
                    default: 'Nova Scotia',
                    fr: 'Nouvelle-Écosse',
                },
                zip: 'B',
            },
            {
                key: 'NU',
                name: {
                    default: 'Nunavut',
                    fr: 'Nunavut',
                },
                zip: 'X0A|X0B|X0C',
            },
            {
                key: 'ON',
                name: {
                    default: 'Ontario',
                    fr: 'Ontario',
                },
                zip: 'K|L|M|N|P',
            },
            {
                key: 'PE',
                name: {
                    default: 'Prince Edward Island',
                    fr: 'Île-du-Prince-Édouard',
                },
                zip: 'C',
            },
            {
                key: 'QC',
                name: {
                    default: 'Quebec',
                    fr: 'Québec',
                },
                zip: 'G|H|J|K1A',
            },
            {
                key: 'SK',
                name: {
                    default: 'Saskatchewan',
                    fr: 'Saskatchewan',
                },
                zip: 'S|R8A',
            },
            {
                key: 'YT',
                name: {
                    default: 'Yukon',
                    fr: 'Yukon',
                },
                zip: 'Y',
            },
        ],
    },
    {
        id: 'data/CC',
        key: 'CC',
        name: 'COCOS (KEELING) ISLANDS',
        fmt: '%O%n%N%n%A%n%C %S %Z',
        zip: '6799',
        zipex: '6799',
        upper: 'CS',
    },
    {
        id: 'data/CD',
        key: 'CD',
        name: 'CONGO (DEM. REP.)',
    },
    {
        id: 'data/CF',
        key: 'CF',
        name: 'CENTRAL AFRICAN REPUBLIC',
    },
    {
        id: 'data/CG',
        key: 'CG',
        name: 'CONGO (REP.)',
    },
    {
        id: 'data/CH',
        key: 'CH',
        name: 'SWITZERLAND',
        fmt: '%O%n%N%n%A%nCH-%Z %C',
        zip: '\\d{4}',
        zipex: '2544,1211,1556,3030',
        upper: '',
        require: 'ACZ',
    },
    {
        id: 'data/CI',
        key: 'CI',
        name: 'COTE D\'IVOIRE',
        fmt: '%N%n%O%n%X %A %C %X',
    },
    {
        id: 'data/CK',
        key: 'CK',
        name: 'COOK ISLANDS',
    },
    {
        id: 'data/CL',
        key: 'CL',
        name: 'CHILE',
        fmt: '%N%n%O%n%A%n%Z %C%n%S',
        zip: '\\d{7}',
        zipex: '8340457,8720019,1230000,8329100',
        sub_regions: [
            {
                key: 'AN',
                name: {
                    default: 'Antofagasta',
                },
            },
            {
                key: 'AR',
                name: {
                    default: 'Araucanía',
                },
            },
            {
                key: 'AP',
                name: {
                    default: 'Arica y Parinacota',
                },
            },
            {
                key: 'AT',
                name: {
                    default: 'Atacama',
                },
            },
            {
                key: 'AI',
                name: {
                    default: 'Aysén del General Carlos Ibáñez del Campo',
                },
            },
            {
                key: 'BI',
                name: {
                    default: 'Biobío',
                },
            },
            {
                key: 'CO',
                name: {
                    default: 'Coquimbo',
                },
            },
            {
                key: 'LI',
                name: {
                    default: 'Libertador General Bernardo O\'Higgins',
                },
            },
            {
                key: 'LL',
                name: {
                    default: 'Los Lagos',
                },
            },
            {
                key: 'LR',
                name: {
                    default: 'Los Ríos',
                },
            },
            {
                key: 'MA',
                name: {
                    default: 'Magallanes y de la Antártica Chilena',
                },
            },
            {
                key: 'ML',
                name: {
                    default: 'Maule',
                },
            },
            {
                key: 'RM',
                name: {
                    default: 'Metropolitana de Santiago',
                },
            },
            {
                key: 'NB',
                name: {
                    default: 'Ñuble',
                },
            },
            {
                key: 'TA',
                name: {
                    default: 'Tarapacá',
                },
            },
            {
                key: 'VS',
                name: {
                    default: 'Valparaíso',
                },
            },
        ],
    },
    {
        id: 'data/CM',
        key: 'CM',
        name: 'CAMEROON',
    },
    {
        id: 'data/CN',
        key: 'CN',
        name: 'CHINA',
        fmt: '%Z%n%S%C%D%n%A%n%O%n%N',
        lfmt: '%N%n%O%n%A%n%D%n%C%n%S, %Z',
        zip: '\\d{6}',
        zipex: '266033,317204,100096,100808',
        upper: 'S',
        require: 'ACSZ',
        sub_regions: [
            {
                key: '34',
                name: {
                    default: '安徽省',
                    latin: 'Anhui Sheng',
                },
            },
            {
                key: '92',
                name: {
                    default: '澳门',
                    latin: 'Macau',
                },
            },
            {
                key: '11',
                name: {
                    default: '北京市',
                    latin: 'Beijing Shi',
                },
            },
            {
                key: '50',
                name: {
                    default: '重庆市',
                    latin: 'Chongqing Shi',
                },
            },
            {
                key: '35',
                name: {
                    default: '福建省',
                    latin: 'Fujian Sheng',
                },
            },
            {
                key: '62',
                name: {
                    default: '甘肃省',
                    latin: 'Gansu Sheng',
                },
            },
            {
                key: '44',
                name: {
                    default: '广东省',
                    latin: 'Guangdong Sheng',
                },
            },
            {
                key: '45',
                name: {
                    default: '广西',
                    latin: 'Guangxi Zhuangzuzizhiqu',
                },
            },
            {
                key: '52',
                name: {
                    default: '贵州省',
                    latin: 'Guizhou Sheng',
                },
            },
            {
                key: '46',
                name: {
                    default: '海南省',
                    latin: 'Hainan Sheng',
                },
            },
            {
                key: '13',
                name: {
                    default: '河北省',
                    latin: 'Hebei Sheng',
                },
            },
            {
                key: '41',
                name: {
                    default: '河南省',
                    latin: 'Henan Sheng',
                },
            },
            {
                key: '23',
                name: {
                    default: '黑龙江省',
                    latin: 'Heilongjiang Sheng',
                },
            },
            {
                key: '42',
                name: {
                    default: '湖北省',
                    latin: 'Hubei Sheng',
                },
            },
            {
                key: '43',
                name: {
                    default: '湖南省',
                    latin: 'Hunan Sheng',
                },
            },
            {
                key: '22',
                name: {
                    default: '吉林省',
                    latin: 'Jilin Sheng',
                },
            },
            {
                key: '32',
                name: {
                    default: '江苏省',
                    latin: 'Jiangsu Sheng',
                },
            },
            {
                key: '36',
                name: {
                    default: '江西省',
                    latin: 'Jiangxi Sheng',
                },
            },
            {
                key: '21',
                name: {
                    default: '辽宁省',
                    latin: 'Liaoning Sheng',
                },
            },
            {
                key: '15',
                name: {
                    default: '内蒙古',
                    latin: 'Neimenggu Zizhiqu',
                },
            },
            {
                key: '64',
                name: {
                    default: '宁夏',
                    latin: 'Ningxia Huizuzizhiqu',
                },
            },
            {
                key: '63',
                name: {
                    default: '青海省',
                    latin: 'Qinghai Sheng',
                },
            },
            {
                key: '37',
                name: {
                    default: '山东省',
                    latin: 'Shandong Sheng',
                },
            },
            {
                key: '14',
                name: {
                    default: '山西省',
                    latin: 'Shanxi Sheng',
                },
            },
            {
                key: '61',
                name: {
                    default: '陕西省',
                    latin: 'Shaanxi Sheng',
                },
            },
            {
                key: '31',
                name: {
                    default: '上海市',
                    latin: 'Shanghai Shi',
                },
            },
            {
                key: '51',
                name: {
                    default: '四川省',
                    latin: 'Sichuan Sheng',
                },
            },
            {
                key: '71',
                name: {
                    default: '台湾',
                    latin: 'Taiwan',
                },
            },
            {
                key: '12',
                name: {
                    default: '天津市',
                    latin: 'Tianjin Shi',
                },
            },
            {
                key: '54',
                name: {
                    default: '西藏',
                    latin: 'Xizang Zizhiqu',
                },
            },
            {
                key: '91',
                name: {
                    default: '香港',
                    latin: 'Hong Kong',
                },
            },
            {
                key: '65',
                name: {
                    default: '新疆',
                    latin: 'Xinjiang Weiwuerzizhiqu',
                },
            },
            {
                key: '53',
                name: {
                    default: '云南省',
                    latin: 'Yunnan Sheng',
                },
            },
            {
                key: '33',
                name: {
                    default: '浙江省',
                    latin: 'Zhejiang Sheng',
                },
            },
        ],
    },
    {
        id: 'data/CO',
        key: 'CO',
        name: 'COLOMBIA',
        fmt: '%N%n%O%n%A%n%D%n%C, %S, %Z',
        zip: '\\d{6}',
        zipex: '111221,130001,760011',
        require: 'AS',
        sub_regions: [
            {
                key: 'AMA',
                name: {
                    default: 'Amazonas',
                },
            },
            {
                key: 'ANT',
                name: {
                    default: 'Antioquia',
                },
            },
            {
                key: 'ARA',
                name: {
                    default: 'Arauca',
                },
            },
            {
                key: 'ATL',
                name: {
                    default: 'Atlántico',
                },
            },
            {
                key: 'DC',
                name: {
                    default: 'Bogotá',
                },
            },
            {
                key: 'BOL',
                name: {
                    default: 'Bolívar',
                },
            },
            {
                key: 'BOY',
                name: {
                    default: 'Boyacá',
                },
            },
            {
                key: 'CAL',
                name: {
                    default: 'Caldas',
                },
            },
            {
                key: 'CAQ',
                name: {
                    default: 'Caquetá',
                },
            },
            {
                key: 'CAS',
                name: {
                    default: 'Casanare',
                },
            },
            {
                key: 'CAU',
                name: {
                    default: 'Cauca',
                },
            },
            {
                key: 'CES',
                name: {
                    default: 'Cesar',
                },
            },
            {
                key: 'CHO',
                name: {
                    default: 'Chocó',
                },
            },
            {
                key: 'COR',
                name: {
                    default: 'Córdoba',
                },
            },
            {
                key: 'CUN',
                name: {
                    default: 'Cundinamarca',
                },
            },
            {
                key: 'GUA',
                name: {
                    default: 'Guainía',
                },
            },
            {
                key: 'GUV',
                name: {
                    default: 'Guaviare',
                },
            },
            {
                key: 'HUI',
                name: {
                    default: 'Huila',
                },
            },
            {
                key: 'LAG',
                name: {
                    default: 'La Guajira',
                },
            },
            {
                key: 'MAG',
                name: {
                    default: 'Magdalena',
                },
            },
            {
                key: 'MET',
                name: {
                    default: 'Meta',
                },
            },
            {
                key: 'NAR',
                name: {
                    default: 'Nariño',
                },
            },
            {
                key: 'NSA',
                name: {
                    default: 'Norte de Santander',
                },
            },
            {
                key: 'PUT',
                name: {
                    default: 'Putumayo',
                },
            },
            {
                key: 'QUI',
                name: {
                    default: 'Quindío',
                },
            },
            {
                key: 'RIS',
                name: {
                    default: 'Risaralda',
                },
            },
            {
                key: 'SAP',
                name: {
                    default: 'San Andrés y Providencia',
                },
            },
            {
                key: 'SAN',
                name: {
                    default: 'Santander',
                },
            },
            {
                key: 'SUC',
                name: {
                    default: 'Sucre',
                },
            },
            {
                key: 'TOL',
                name: {
                    default: 'Tolima',
                },
            },
            {
                key: 'VAC',
                name: {
                    default: 'Valle del Cauca',
                },
            },
            {
                key: 'VAU',
                name: {
                    default: 'Vaupés',
                },
            },
            {
                key: 'VID',
                name: {
                    default: 'Vichada',
                },
            },
        ],
    },
    {
        id: 'data/CR',
        key: 'CR',
        name: 'COSTA RICA',
        fmt: '%N%n%O%n%A%n%S, %C%n%Z',
        zip: '\\d{4,5}|\\d{3}-\\d{4}',
        zipex: '1000,2010,1001',
        require: 'ACS',
    },
    {
        id: 'data/CU',
        key: 'CU',
        name: 'CUBA',
        fmt: '%N%n%O%n%A%n%C %S%n%Z',
        zip: '\\d{5}',
        zipex: '10700',
        sub_regions: [
            {
                key: '15',
                name: {
                    default: 'Artemisa',
                },
            },
            {
                key: '09',
                name: {
                    default: 'Camagüey',
                },
            },
            {
                key: '08',
                name: {
                    default: 'Ciego de Ávila',
                },
            },
            {
                key: '06',
                name: {
                    default: 'Cienfuegos',
                },
            },
            {
                key: '12',
                name: {
                    default: 'Granma',
                },
            },
            {
                key: '14',
                name: {
                    default: 'Guantánamo',
                },
            },
            {
                key: '11',
                name: {
                    default: 'Holguín',
                },
            },
            {
                key: '99',
                name: {
                    default: 'Isla de la Juventud',
                },
            },
            {
                key: '03',
                name: {
                    default: 'La Habana',
                },
            },
            {
                key: '10',
                name: {
                    default: 'Las Tunas',
                },
            },
            {
                key: '04',
                name: {
                    default: 'Matanzas',
                },
            },
            {
                key: '16',
                name: {
                    default: 'Mayabeque',
                },
            },
            {
                key: '01',
                name: {
                    default: 'Pinar del Río',
                },
            },
            {
                key: '07',
                name: {
                    default: 'Sancti Spíritus',
                },
            },
            {
                key: '13',
                name: {
                    default: 'Santiago de Cuba',
                },
            },
            {
                key: '05',
                name: {
                    default: 'Villa Clara',
                },
            },
        ],
    },
    {
        id: 'data/CV',
        key: 'CV',
        name: 'CAPE VERDE',
        fmt: '%N%n%O%n%A%n%Z %C%n%S',
        zip: '\\d{4}',
        zipex: '7600',
        sub_regions: [
            {
                key: 'BV',
                name: {
                    default: 'Boa Vista',
                },
            },
            {
                key: 'BR',
                name: {
                    default: 'Brava',
                },
            },
            {
                key: 'Fogo',
                name: {
                    default: 'Fogo',
                },
            },
            {
                key: 'MA',
                name: {
                    default: 'Maio',
                },
            },
            {
                key: 'SL',
                name: {
                    default: 'Sal',
                },
            },
            {
                key: 'Santiago',
                name: {
                    default: 'Santiago',
                },
            },
            {
                key: 'Santo Antão',
                name: {
                    default: 'Santo Antão',
                },
            },
            {
                key: 'São Nicolau',
                name: {
                    default: 'São Nicolau',
                },
            },
            {
                key: 'SV',
                name: {
                    default: 'São Vicente',
                },
            },
        ],
    },
    {
        id: 'data/CW',
        key: 'CW',
        name: 'CURACAO',
    },
    {
        id: 'data/CX',
        key: 'CX',
        name: 'CHRISTMAS ISLAND',
        fmt: '%O%n%N%n%A%n%C %S %Z',
        zip: '6798',
        zipex: '6798',
        upper: 'CS',
    },
    {
        id: 'data/CY',
        key: 'CY',
        name: 'CYPRUS',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '2008,3304,1900',
    },
    {
        id: 'data/CZ',
        key: 'CZ',
        name: 'CZECH REP.',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{3} ?\\d{2}',
        zipex: '100 00,251 66,530 87,110 00,225 99',
        require: 'ACZ',
    },
    {
        id: 'data/DE',
        key: 'DE',
        name: 'GERMANY',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '26133,53225',
        require: 'ACZ',
    },
    {
        id: 'data/DJ',
        key: 'DJ',
        name: 'DJIBOUTI',
    },
    {
        id: 'data/DK',
        key: 'DK',
        name: 'DENMARK',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '8660,1566',
        require: 'ACZ',
    },
    {
        id: 'data/DM',
        key: 'DM',
        name: 'DOMINICA',
    },
    {
        id: 'data/DO',
        key: 'DO',
        name: 'DOMINICAN REP.',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '11903,10101',
    },
    {
        id: 'data/DZ',
        key: 'DZ',
        name: 'ALGERIA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '40304,16027',
    },
    {
        id: 'data/EC',
        key: 'EC',
        name: 'ECUADOR',
        fmt: '%N%n%O%n%A%n%Z%n%C',
        zip: '\\d{6}',
        zipex: '090105,092301',
        upper: 'CZ',
    },
    {
        id: 'data/EE',
        key: 'EE',
        name: 'ESTONIA',
        fmt: '%N%n%O%n%A%n%Z %C %S',
        zip: '\\d{5}',
        zipex: '69501,11212',
        require: 'ACZ',
    },
    {
        id: 'data/EG',
        key: 'EG',
        name: 'EGYPT',
        fmt: '%N%n%O%n%A%n%C%n%S%n%Z',
        lfmt: '%N%n%O%n%A%n%C%n%S%n%Z',
        zip: '\\d{5}',
        zipex: '12411,11599',
        sub_regions: [
            {
                key: 'ASN',
                name: {
                    default: 'أسوان',
                    latin: 'Aswan Governorate',
                },
                zip: '81',
            },
            {
                key: 'AST',
                name: {
                    default: 'أسيوط',
                    latin: 'Asyut Governorate',
                },
                zip: '71',
            },
            {
                key: 'ALX',
                name: {
                    default: 'الإسكندرية',
                    latin: 'Alexandria Governorate',
                },
                zip: '2[13]',
            },
            {
                key: 'IS',
                name: {
                    default: 'الإسماعيلية',
                    latin: 'Ismailia Governorate',
                },
                zip: '41',
            },
            {
                key: 'LX',
                name: {
                    default: 'الأقصر',
                    latin: 'Luxor Governorate',
                },
                zip: '85',
            },
            {
                key: 'BA',
                name: {
                    default: 'البحر الأحمر',
                    latin: 'Red Sea Governorate',
                },
                zip: '84',
            },
            {
                key: 'BH',
                name: {
                    default: 'البحيرة',
                    latin: 'El Beheira Governorate',
                },
                zip: '22',
            },
            {
                key: 'GZ',
                name: {
                    default: 'الجيزة',
                    latin: 'Giza Governorate',
                },
                zip: '12',
            },
            {
                key: 'DK',
                name: {
                    default: 'الدقهلية',
                    latin: 'Dakahlia Governorate',
                },
                zip: '35',
            },
            {
                key: 'SUZ',
                name: {
                    default: 'السويس',
                    latin: 'Suez Governorate',
                },
                zip: '43',
            },
            {
                key: 'SHR',
                name: {
                    default: 'الشرقية',
                    latin: 'Ash Sharqia Governorate',
                },
                zip: '44',
            },
            {
                key: 'GH',
                name: {
                    default: 'الغربية',
                    latin: 'Gharbia Governorate',
                },
                zip: '31',
            },
            {
                key: 'FYM',
                name: {
                    default: 'الفيوم',
                    latin: 'Faiyum Governorate',
                },
                zip: '63',
            },
            {
                key: 'C',
                name: {
                    default: 'القاهرة',
                    latin: 'Cairo Governorate',
                },
                zip: '11',
            },
            {
                key: 'KB',
                name: {
                    default: 'القليوبية',
                    latin: 'Qalyubia Governorate',
                },
                zip: '13',
            },
            {
                key: 'MNF',
                name: {
                    default: 'المنوفية',
                    latin: 'Menofia Governorate',
                },
                zip: '32',
            },
            {
                key: 'MN',
                name: {
                    default: 'المنيا',
                    latin: 'Menia Governorate',
                },
                zip: '61',
            },
            {
                key: 'WAD',
                name: {
                    default: 'الوادي الجديد',
                    latin: 'New Valley Governorate',
                },
                zip: '72',
            },
            {
                key: 'BNS',
                name: {
                    default: 'بني سويف',
                    latin: 'Beni Suef Governorate',
                },
                zip: '62',
            },
            {
                key: 'PTS',
                name: {
                    default: 'بورسعيد',
                    latin: 'Port Said Governorate',
                },
                zip: '42',
            },
            {
                key: 'JS',
                name: {
                    default: 'جنوب سيناء',
                    latin: 'South Sinai Governorate',
                },
                zip: '46',
            },
            {
                key: 'DT',
                name: {
                    default: 'دمياط',
                    latin: 'Damietta Governorate',
                },
                zip: '34',
            },
            {
                key: 'SHG',
                name: {
                    default: 'سوهاج',
                    latin: 'Sohag Governorate',
                },
                zip: '82',
            },
            {
                key: 'SIN',
                name: {
                    default: 'شمال سيناء',
                    latin: 'North Sinai Governorate',
                },
                zip: '45',
            },
            {
                key: 'KN',
                name: {
                    default: 'قنا',
                    latin: 'Qena Governorate',
                },
                zip: '83',
            },
            {
                key: 'KFS',
                name: {
                    default: 'كفر الشيخ',
                    latin: 'Kafr El Sheikh Governorate',
                },
                zip: '33',
            },
            {
                key: 'MT',
                name: {
                    default: 'مطروح',
                    latin: 'Matrouh Governorate',
                },
                zip: '51',
            },
        ],
    },
    {
        id: 'data/EH',
        key: 'EH',
        name: 'WESTERN SAHARA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '70000,72000',
    },
    {
        id: 'data/ER',
        key: 'ER',
        name: 'ERITREA',
    },
    {
        id: 'data/ES',
        key: 'ES',
        name: 'SPAIN',
        fmt: '%N%n%O%n%A%n%Z %C %S',
        zip: '\\d{5}',
        zipex: '28039,28300,28070',
        upper: 'CS',
        require: 'ACSZ',
        sub_regions: [
            {
                key: 'VI',
                name: {
                    default: 'Álava',
                    ca: 'Araba',
                    gl: 'Álava',
                    eu: 'Araba',
                },
                zip: '01',
            },
            {
                key: 'AB',
                name: {
                    default: 'Albacete',
                    ca: 'Albacete',
                    gl: 'Albacete',
                    eu: 'Albacete',
                },
                zip: '02',
            },
            {
                key: 'A',
                name: {
                    default: 'Alicante',
                    ca: 'Alacant',
                    gl: 'Alacant',
                    eu: 'Alacant',
                },
                zip: '03',
            },
            {
                key: 'AL',
                name: {
                    default: 'Almería',
                    ca: 'Almeria',
                    gl: 'Almería',
                    eu: 'Almería',
                },
                zip: '04',
            },
            {
                key: 'O',
                name: {
                    default: 'Asturias',
                    ca: 'Asturias',
                    gl: 'Asturias',
                    eu: 'Asturias',
                },
                zip: '33',
            },
            {
                key: 'AV',
                name: {
                    default: 'Ávila',
                    ca: 'Àvila',
                    gl: 'Ávila',
                    eu: 'Ávila',
                },
                zip: '05',
            },
            {
                key: 'BA',
                name: {
                    default: 'Badajoz',
                    ca: 'Badajoz',
                    gl: 'Badaxoz',
                    eu: 'Badajoz',
                },
                zip: '06',
            },
            {
                key: 'B',
                name: {
                    default: 'Barcelona',
                    ca: 'Barcelona',
                    gl: 'Barcelona',
                    eu: 'Barcelona',
                },
                zip: '08',
            },
            {
                key: 'BU',
                name: {
                    default: 'Burgos',
                    ca: 'Burgos',
                    gl: 'Burgos',
                    eu: 'Burgos',
                },
                zip: '09',
            },
            {
                key: 'CC',
                name: {
                    default: 'Cáceres',
                    ca: 'Cáceres',
                    gl: 'Cáceres',
                    eu: 'Cáceres',
                },
                zip: '10',
            },
            {
                key: 'CA',
                name: {
                    default: 'Cádiz',
                    ca: 'Cadis',
                    gl: 'Cádiz',
                    eu: 'Cádiz',
                },
                zip: '11',
            },
            {
                key: 'S',
                name: {
                    default: 'Cantabria',
                    ca: 'Cantabria',
                    gl: 'Cantabria',
                    eu: 'Cantabria',
                },
                zip: '39',
            },
            {
                key: 'CS',
                name: {
                    default: 'Castellón',
                    ca: 'Castelló',
                    gl: 'Castelló',
                    eu: 'Castelló',
                },
                zip: '12',
            },
            {
                key: 'CE',
                name: {
                    default: 'Ceuta',
                    ca: 'Ceuta',
                    gl: 'Ceuta',
                    eu: 'Ceuta',
                },
                zip: '51',
            },
            {
                key: 'CR',
                name: {
                    default: 'Ciudad Real',
                    ca: 'Ciudad Real',
                    gl: 'Cidade Real',
                    eu: 'Ciudad Real',
                },
                zip: '13',
            },
            {
                key: 'CO',
                name: {
                    default: 'Córdoba',
                    ca: 'Córdoba',
                    gl: 'Córdoba',
                    eu: 'Kordoba',
                },
                zip: '14',
            },
            {
                key: 'CU',
                name: {
                    default: 'Cuenca',
                    ca: 'Cuenca',
                    gl: 'Cuenca',
                    eu: 'Cuenca',
                },
                zip: '16',
            },
            {
                key: 'GI',
                name: {
                    default: 'Girona',
                    ca: 'Girona',
                    gl: 'Xirona',
                    eu: 'Girona',
                },
                zip: '17',
            },
            {
                key: 'GR',
                name: {
                    default: 'Granada',
                    ca: 'Granada',
                    gl: 'Granada',
                    eu: 'Granada',
                },
                zip: '18',
            },
            {
                key: 'GU',
                name: {
                    default: 'Guadalajara',
                    ca: 'Guadalajara',
                    gl: 'Guadalajara',
                    eu: 'Guadalajara',
                },
                zip: '19',
            },
            {
                key: 'SS',
                name: {
                    default: 'Guipúzcoa',
                    ca: 'Guipúscoa',
                    gl: 'Guipúscoa',
                    eu: 'Gipuzkoa',
                },
                zip: '20',
            },
            {
                key: 'H',
                name: {
                    default: 'Huelva',
                    ca: 'Huelva',
                    gl: 'Huelva',
                    eu: 'Huelva',
                },
                zip: '21',
            },
            {
                key: 'HU',
                name: {
                    default: 'Huesca',
                    ca: 'Huesca',
                    gl: 'Huesca',
                    eu: 'Huesca',
                },
                zip: '22',
            },
            {
                key: 'PM',
                name: {
                    default: 'Islas Baleares',
                    ca: 'Illes Balears',
                    gl: 'Illas Baleares',
                    eu: 'Illes Balears',
                },
                zip: '07',
            },
            {
                key: 'J',
                name: {
                    default: 'Jaén',
                    ca: 'Jaén',
                    gl: 'Xaén',
                    eu: 'Jaén',
                },
                zip: '23',
            },
            {
                key: 'C',
                name: {
                    default: 'La Coruña',
                    ca: 'La Corunya',
                    gl: 'A Coruña',
                    eu: 'Coruña',
                },
                zip: '15',
            },
            {
                key: 'LO',
                name: {
                    default: 'La Rioja',
                    ca: 'La Rioja',
                    gl: 'La Rioja',
                    eu: 'La Rioja',
                },
                zip: '26',
            },
            {
                key: 'GC',
                name: {
                    default: 'Las Palmas',
                    ca: 'Las Palmas',
                    gl: 'As Palmas',
                    eu: 'Las Palmas',
                },
                zip: '35',
            },
            {
                key: 'LE',
                name: {
                    default: 'León',
                    ca: 'León',
                    gl: 'León',
                    eu: 'León',
                },
                zip: '24',
            },
            {
                key: 'L',
                name: {
                    default: 'Lérida',
                    ca: 'Lleida',
                    gl: 'Lleida',
                    eu: 'Lleida',
                },
                zip: '25',
            },
            {
                key: 'LU',
                name: {
                    default: 'Lugo',
                    ca: 'Lugo',
                    gl: 'Lugo',
                    eu: 'Lugo',
                },
                zip: '27',
            },
            {
                key: 'M',
                name: {
                    default: 'Madrid',
                    ca: 'Madrid',
                    gl: 'Madrid',
                    eu: 'Madrid',
                },
                zip: '28',
            },
            {
                key: 'MA',
                name: {
                    default: 'Málaga',
                    ca: 'Málaga',
                    gl: 'Málaga',
                    eu: 'Málaga',
                },
                zip: '29',
            },
            {
                key: 'ML',
                name: {
                    default: 'Melilla',
                    ca: 'Melilla',
                    gl: 'Melilla',
                    eu: 'Melilla',
                },
                zip: '52',
            },
            {
                key: 'MU',
                name: {
                    default: 'Murcia',
                    ca: 'Murcia',
                    gl: 'Murcia',
                    eu: 'Murtzia',
                },
                zip: '30',
            },
            {
                key: 'NA',
                name: {
                    default: 'Navarra',
                    ca: 'Navarra',
                    gl: 'Navarra',
                    eu: 'Nafarroa',
                },
                zip: '31',
            },
            {
                key: 'OR',
                name: {
                    default: 'Ourense',
                    ca: 'Ourense',
                    gl: 'Ourense',
                    eu: 'Ourense',
                },
                zip: '32',
            },
            {
                key: 'P',
                name: {
                    default: 'Palencia',
                    ca: 'Palencia',
                    gl: 'Palencia',
                    eu: 'Palentzia',
                },
                zip: '34',
            },
            {
                key: 'PO',
                name: {
                    default: 'Pontevedra',
                    ca: 'Pontevedra',
                    gl: 'Pontevedra',
                    eu: 'Pontevedra',
                },
                zip: '36',
            },
            {
                key: 'SA',
                name: {
                    default: 'Salamanca',
                    ca: 'Salamanca',
                    gl: 'Salamanca',
                    eu: 'Salamanca',
                },
                zip: '37',
            },
            {
                key: 'TF',
                name: {
                    default: 'Santa Cruz de Tenerife',
                    ca: 'Santa Cruz de Tenerife',
                    gl: 'Santa Cruz de Tenerife',
                    eu: 'Santa Cruz Tenerifekoa',
                },
                zip: '38',
            },
            {
                key: 'SG',
                name: {
                    default: 'Segovia',
                    ca: 'Segovia',
                    gl: 'Segovia',
                    eu: 'Segovia',
                },
                zip: '40',
            },
            {
                key: 'SE',
                name: {
                    default: 'Sevilla',
                    ca: 'Sevilla',
                    gl: 'Sevilla',
                    eu: 'Sevilla',
                },
                zip: '41',
            },
            {
                key: 'SO',
                name: {
                    default: 'Soria',
                    ca: 'Soria',
                    gl: 'Soria',
                    eu: 'Soria',
                },
                zip: '26127|42',
            },
            {
                key: 'T',
                name: {
                    default: 'Tarragona',
                    ca: 'Tarragona',
                    gl: 'Tarragona',
                    eu: 'Tarragona',
                },
                zip: '43',
            },
            {
                key: 'TE',
                name: {
                    default: 'Teruel',
                    ca: 'Teruel',
                    gl: 'Teruel',
                    eu: 'Teruel',
                },
                zip: '44',
            },
            {
                key: 'TO',
                name: {
                    default: 'Toledo',
                    ca: 'Toledo',
                    gl: 'Toledo',
                    eu: 'Toledo',
                },
                zip: '45',
            },
            {
                key: 'V',
                name: {
                    default: 'Valencia',
                    ca: 'València',
                    gl: 'Valencia',
                    eu: 'Valentzia',
                },
                zip: '46',
            },
            {
                key: 'VA',
                name: {
                    default: 'Valladolid',
                    ca: 'Valladolid',
                    gl: 'Valladolid',
                    eu: 'Valladolid',
                },
                zip: '47',
            },
            {
                key: 'BI',
                name: {
                    default: 'Vizcaya',
                    ca: 'Bizkaia',
                    gl: 'Biscaia',
                    eu: 'Bizkaia',
                },
                zip: '48',
            },
            {
                key: 'ZA',
                name: {
                    default: 'Zamora',
                    ca: 'Zamora',
                    gl: 'Zamora',
                    eu: 'Zamora',
                },
                zip: '49',
            },
            {
                key: 'Z',
                name: {
                    default: 'Zaragoza',
                    ca: 'Zaragoza',
                    gl: 'Zaragoza',
                    eu: 'Zaragoza',
                },
                zip: '50',
            },
        ],
    },
    {
        id: 'data/ET',
        key: 'ET',
        name: 'ETHIOPIA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '1000',
    },
    {
        id: 'data/FI',
        key: 'FI',
        name: 'FINLAND',
        fmt: '%O%n%N%n%A%nFI-%Z %C',
        zip: '\\d{5}',
        zipex: '00550,00011',
        require: 'ACZ',
    },
    {
        id: 'data/FJ',
        key: 'FJ',
        name: 'FIJI',
    },
    {
        id: 'data/FK',
        key: 'FK',
        name: 'FALKLAND ISLANDS (MALVINAS)',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: 'FIQQ 1ZZ',
        zipex: 'FIQQ 1ZZ',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/FM',
        key: 'FM',
        name: 'MICRONESIA (Federated State of)',
        fmt: '%N%n%O%n%A%n%C %S %Z',
        zip: '(9694[1-4])(?:[ \\-](\\d{4}))?',
        zipex: '96941,96944',
        upper: 'ACNOS',
        require: 'ACSZ',
    },
    {
        id: 'data/FO',
        key: 'FO',
        name: 'FAROE ISLANDS',
        fmt: '%N%n%O%n%A%nFO%Z %C',
        zip: '\\d{3}',
        zipex: '100',
    },
    {
        id: 'data/FR',
        key: 'FR',
        name: 'FRANCE',
        fmt: '%O%n%N%n%A%n%Z %C',
        zip: '\\d{2} ?\\d{3}',
        zipex: '33380,34092,33506',
        upper: 'CX',
        require: 'ACZ',
    },
    {
        id: 'data/GA',
        key: 'GA',
        name: 'GABON',
    },
    {
        id: 'data/GB',
        key: 'GB',
        name: 'UNITED KINGDOM',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: 'GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BF|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\\d{1,4}',
        zipex: 'EC1Y 8SY,GIR 0AA,M2 5BQ,M34 4AB,CR0 2YR,DN16 9AA,W1A 4ZZ,EC1A 1HQ,OX14 4PG,BS18 8HF,NR25 7HG,RH6 0NP,BH23 6AA,B6 5BA,SO23 9AP,PO1 3AX,BFPO 61',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/GD',
        key: 'GD',
        name: 'GRENADA (WEST INDIES)',
    },
    {
        id: 'data/GE',
        key: 'GE',
        name: 'GEORGIA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '0101',
    },
    {
        id: 'data/GF',
        key: 'GF',
        name: 'FRENCH GUIANA',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '9[78]3\\d{2}',
        zipex: '97300',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/GG',
        key: 'GG',
        name: 'CHANNEL ISLANDS',
        fmt: '%N%n%O%n%A%n%C%nGUERNSEY%n%Z',
        zip: 'GY\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}',
        zipex: 'GY1 1AA,GY2 2BT',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/GH',
        key: 'GH',
        name: 'GHANA',
    },
    {
        id: 'data/GI',
        key: 'GI',
        name: 'GIBRALTAR',
        fmt: '%N%n%O%n%A%nGIBRALTAR%n%Z',
        zip: 'GX11 1AA',
        zipex: 'GX11 1AA',
        require: 'A',
    },
    {
        id: 'data/GL',
        key: 'GL',
        name: 'GREENLAND',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '39\\d{2}',
        zipex: '3900,3950,3911',
        require: 'ACZ',
    },
    {
        id: 'data/GM',
        key: 'GM',
        name: 'GAMBIA',
    },
    {
        id: 'data/GN',
        key: 'GN',
        name: 'GUINEA',
        fmt: '%N%n%O%n%Z %A %C',
        zip: '\\d{3}',
        zipex: '001,200,100',
    },
    {
        id: 'data/GP',
        key: 'GP',
        name: 'GUADELOUPE',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '9[78][01]\\d{2}',
        zipex: '97100',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/GQ',
        key: 'GQ',
        name: 'EQUATORIAL GUINEA',
    },
    {
        id: 'data/GR',
        key: 'GR',
        name: 'GREECE',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{3} ?\\d{2}',
        zipex: '151 24,151 10,101 88',
        require: 'ACZ',
    },
    {
        id: 'data/GS',
        key: 'GS',
        name: 'SOUTH GEORGIA',
        fmt: '%N%n%O%n%A%n%n%C%n%Z',
        zip: 'SIQQ 1ZZ',
        zipex: 'SIQQ 1ZZ',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/GT',
        key: 'GT',
        name: 'GUATEMALA',
        fmt: '%N%n%O%n%A%n%Z- %C',
        zip: '\\d{5}',
        zipex: '09001,01501',
    },
    {
        id: 'data/GU',
        key: 'GU',
        name: 'GUAM',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '(969(?:[12]\\d|3[12]))(?:[ \\-](\\d{4}))?',
        zipex: '96910,96931',
        upper: 'ACNO',
        require: 'ACZ',
    },
    {
        id: 'data/GW',
        key: 'GW',
        name: 'GUINEA-BISSAU',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '1000,1011',
    },
    {
        id: 'data/GY',
        key: 'GY',
        name: 'GUYANA',
    },
    {
        id: 'data/HK',
        key: 'HK',
        name: 'HONG KONG',
        fmt: '%S%n%C%n%A%n%O%n%N',
        lfmt: '%N%n%O%n%A%n%C%n%S',
        upper: 'S',
        require: 'AS',
        sub_regions: [
            {
                key: 'Kowloon',
                name: {
                    default: '九龍',
                },
            },
            {
                key: 'Hong Kong Island',
                name: {
                    default: '香港島',
                },
            },
            {
                key: 'New Territories',
                name: {
                    default: '新界',
                },
            },
        ],
    },
    {
        id: 'data/HM',
        key: 'HM',
        name: 'HEARD AND MCDONALD ISLANDS',
        fmt: '%O%n%N%n%A%n%C %S %Z',
        zip: '\\d{4}',
        zipex: '7050',
        upper: 'CS',
    },
    {
        id: 'data/HN',
        key: 'HN',
        name: 'HONDURAS',
        fmt: '%N%n%O%n%A%n%C, %S%n%Z',
        zip: '\\d{5}',
        zipex: '31301',
        require: 'ACS',
    },
    {
        id: 'data/HR',
        key: 'HR',
        name: 'CROATIA',
        fmt: '%N%n%O%n%A%nHR-%Z %C',
        zip: '\\d{5}',
        zipex: '10000,21001,10002',
    },
    {
        id: 'data/HT',
        key: 'HT',
        name: 'HAITI',
        fmt: '%N%n%O%n%A%nHT%Z %C',
        zip: '\\d{4}',
        zipex: '6120,5310,6110,8510',
    },
    {
        id: 'data/HU',
        key: 'HU',
        name: 'HUNGARY (Rep.)',
        fmt: '%N%n%O%n%C%n%A%n%Z',
        zip: '\\d{4}',
        zipex: '1037,2380,1540',
        upper: 'ACNO',
        require: 'ACZ',
    },
    {
        id: 'data/ID',
        key: 'ID',
        name: 'INDONESIA',
        fmt: '%N%n%O%n%A%n%C%n%S %Z',
        zip: '\\d{5}',
        zipex: '40115',
        require: 'AS',
        sub_regions: [
            {
                key: 'AC',
                name: {
                    default: 'Aceh',
                    latin: 'Aceh',
                },
            },
            {
                key: 'BA',
                name: {
                    default: 'Bali',
                    latin: 'Bali',
                },
            },
            {
                key: 'BT',
                name: {
                    default: 'Banten',
                    latin: 'Banten',
                },
            },
            {
                key: 'BE',
                name: {
                    default: 'Bengkulu',
                    latin: 'Bengkulu',
                },
            },
            {
                key: 'YO',
                name: {
                    default: 'Daerah Istimewa Yogyakarta',
                    latin: 'Special Region of Yogyakarta',
                },
            },
            {
                key: 'JK',
                name: {
                    default: 'DKI Jakarta',
                    latin: 'Jakarta',
                },
            },
            {
                key: 'GO',
                name: {
                    default: 'Gorontalo',
                    latin: 'Gorontalo',
                },
            },
            {
                key: 'JA',
                name: {
                    default: 'Jambi',
                    latin: 'Jambi',
                },
            },
            {
                key: 'JB',
                name: {
                    default: 'Jawa Barat',
                    latin: 'West Java',
                },
            },
            {
                key: 'JT',
                name: {
                    default: 'Jawa Tengah',
                    latin: 'Central Java',
                },
            },
            {
                key: 'JI',
                name: {
                    default: 'Jawa Timur',
                    latin: 'East Java',
                },
            },
            {
                key: 'KB',
                name: {
                    default: 'Kalimantan Barat',
                    latin: 'West Kalimantan',
                },
            },
            {
                key: 'KS',
                name: {
                    default: 'Kalimantan Selatan',
                    latin: 'South Kalimantan',
                },
            },
            {
                key: 'KT',
                name: {
                    default: 'Kalimantan Tengah',
                    latin: 'Central Kalimantan',
                },
            },
            {
                key: 'KI',
                name: {
                    default: 'Kalimantan Timur',
                    latin: 'East Kalimantan',
                },
            },
            {
                key: 'KU',
                name: {
                    default: 'Kalimantan Utara',
                    latin: 'North Kalimantan',
                },
            },
            {
                key: 'BB',
                name: {
                    default: 'Kepulauan Bangka Belitung',
                    latin: 'Bangka Belitung Islands',
                },
            },
            {
                key: 'KR',
                name: {
                    default: 'Kepulauan Riau',
                    latin: 'Riau Islands',
                },
            },
            {
                key: 'LA',
                name: {
                    default: 'Lampung',
                    latin: 'Lampung',
                },
            },
            {
                key: 'MA',
                name: {
                    default: 'Maluku',
                    latin: 'Maluku',
                },
            },
            {
                key: 'MU',
                name: {
                    default: 'Maluku Utara',
                    latin: 'North Maluku',
                },
            },
            {
                key: 'NB',
                name: {
                    default: 'Nusa Tenggara Barat',
                    latin: 'West Nusa Tenggara',
                },
            },
            {
                key: 'NT',
                name: {
                    default: 'Nusa Tenggara Timur',
                    latin: 'East Nusa Tenggara',
                },
            },
            {
                key: 'PA',
                name: {
                    default: 'Papua',
                    latin: 'Papua',
                },
            },
            {
                key: 'PB',
                name: {
                    default: 'Papua Barat',
                    latin: 'West Papua',
                },
            },
            {
                key: 'RI',
                name: {
                    default: 'Riau',
                    latin: 'Riau',
                },
            },
            {
                key: 'SR',
                name: {
                    default: 'Sulawesi Barat',
                    latin: 'West Sulawesi',
                },
            },
            {
                key: 'SN',
                name: {
                    default: 'Sulawesi Selatan',
                    latin: 'South Sulawesi',
                },
            },
            {
                key: 'ST',
                name: {
                    default: 'Sulawesi Tengah',
                    latin: 'Central Sulawesi',
                },
            },
            {
                key: 'SG',
                name: {
                    default: 'Sulawesi Tenggara',
                    latin: 'South East Sulawesi',
                },
            },
            {
                key: 'SA',
                name: {
                    default: 'Sulawesi Utara',
                    latin: 'North Sulawesi',
                },
            },
            {
                key: 'SB',
                name: {
                    default: 'Sumatera Barat',
                    latin: 'West Sumatra',
                },
            },
            {
                key: 'SS',
                name: {
                    default: 'Sumatera Selatan',
                    latin: 'South Sumatra',
                },
            },
            {
                key: 'SU',
                name: {
                    default: 'Sumatera Utara',
                    latin: 'North Sumatra',
                },
            },
        ],
    },
    {
        id: 'data/IE',
        key: 'IE',
        name: 'IRELAND',
        fmt: '%N%n%O%n%A%n%D%n%C%n%S%n%Z',
        zip: '[\\dA-Z]{3} ?[\\dA-Z]{4}',
        zipex: 'A65 F4E2',
        sub_regions: [
            {
                key: 'CW',
                name: {
                    default: 'Co. Carlow',
                },
            },
            {
                key: 'CN',
                name: {
                    default: 'Co. Cavan',
                },
            },
            {
                key: 'CE',
                name: {
                    default: 'Co. Clare',
                },
            },
            {
                key: 'CO',
                name: {
                    default: 'Co. Cork',
                },
            },
            {
                key: 'DL',
                name: {
                    default: 'Co. Donegal',
                },
            },
            {
                key: 'D',
                name: {
                    default: 'Co. Dublin',
                },
            },
            {
                key: 'G',
                name: {
                    default: 'Co. Galway',
                },
            },
            {
                key: 'KY',
                name: {
                    default: 'Co. Kerry',
                },
            },
            {
                key: 'KE',
                name: {
                    default: 'Co. Kildare',
                },
            },
            {
                key: 'KK',
                name: {
                    default: 'Co. Kilkenny',
                },
            },
            {
                key: 'LS',
                name: {
                    default: 'Co. Laois',
                },
            },
            {
                key: 'LM',
                name: {
                    default: 'Co. Leitrim',
                },
            },
            {
                key: 'LK',
                name: {
                    default: 'Co. Limerick',
                },
            },
            {
                key: 'LD',
                name: {
                    default: 'Co. Longford',
                },
            },
            {
                key: 'LH',
                name: {
                    default: 'Co. Louth',
                },
            },
            {
                key: 'MO',
                name: {
                    default: 'Co. Mayo',
                },
            },
            {
                key: 'MH',
                name: {
                    default: 'Co. Meath',
                },
            },
            {
                key: 'MN',
                name: {
                    default: 'Co. Monaghan',
                },
            },
            {
                key: 'OY',
                name: {
                    default: 'Co. Offaly',
                },
            },
            {
                key: 'RN',
                name: {
                    default: 'Co. Roscommon',
                },
            },
            {
                key: 'SO',
                name: {
                    default: 'Co. Sligo',
                },
            },
            {
                key: 'TA',
                name: {
                    default: 'Co. Tipperary',
                },
            },
            {
                key: 'WD',
                name: {
                    default: 'Co. Waterford',
                },
            },
            {
                key: 'WH',
                name: {
                    default: 'Co. Westmeath',
                },
            },
            {
                key: 'WX',
                name: {
                    default: 'Co. Wexford',
                },
            },
            {
                key: 'WW',
                name: {
                    default: 'Co. Wicklow',
                },
            },
        ],
    },
    {
        id: 'data/IL',
        key: 'IL',
        name: 'ISRAEL',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '\\d{5}(?:\\d{2})?',
        zipex: '9614303',
    },
    {
        id: 'data/IM',
        key: 'IM',
        name: 'ISLE OF MAN',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: 'IM\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}',
        zipex: 'IM2 1AA,IM99 1PS',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/IN',
        key: 'IN',
        name: 'INDIA',
        fmt: '%N%n%O%n%A%n%C %Z%n%S',
        zip: '\\d{6}',
        zipex: '110034,110001',
        require: 'ACSZ',
        sub_regions: [
            {
                key: 'AN',
                name: {
                    default: 'Andaman & Nicobar',
                },
                zip: '744',
            },
            {
                key: 'AP',
                name: {
                    default: 'Andhra Pradesh',
                    hi: 'आंध्र प्रदेश',
                },
                zip: '5[0-3]',
            },
            {
                key: 'AR',
                name: {
                    default: 'Arunachal Pradesh',
                    hi: 'अरुणाचल प्रदेश',
                },
                zip: '79[0-2]',
            },
            {
                key: 'AS',
                name: {
                    default: 'Assam',
                    hi: 'असम',
                },
                zip: '78',
            },
            {
                key: 'BR',
                name: {
                    default: 'Bihar',
                    hi: 'बिहार',
                },
                zip: '8[0-5]',
            },
            {
                key: 'CH',
                name: {
                    default: 'Chandigarh',
                    hi: 'चंडीगढ़',
                },
                zip: '16|1440[3-9]',
            },
            {
                key: 'CT',
                name: {
                    default: 'Chhattisgarh',
                    hi: 'छत्तीसगढ़',
                },
                zip: '49',
            },
            {
                key: 'DH',
                name: {
                    default: 'Dadra & Nagar Haveli & Daman & Diu',
                },
                zip: '396|362',
            },
            {
                key: 'DL',
                name: {
                    default: 'Delhi',
                    hi: 'दिल्ली',
                },
                zip: '11',
            },
            {
                key: 'GA',
                name: {
                    default: 'Goa',
                    hi: 'गोआ',
                },
                zip: '403',
            },
            {
                key: 'GJ',
                name: {
                    default: 'Gujarat',
                    hi: 'गुजरात',
                },
                zip: '3[6-9]',
            },
            {
                key: 'HR',
                name: {
                    default: 'Haryana',
                    hi: 'हरियाणा',
                },
                zip: '1[23]',
            },
            {
                key: 'HP',
                name: {
                    default: 'Himachal Pradesh',
                    hi: 'हिमाचल प्रदेश',
                },
                zip: '17',
            },
            {
                key: 'JK',
                name: {
                    default: 'Jammu & Kashmir',
                },
                zip: '1[89]',
            },
            {
                key: 'JH',
                name: {
                    default: 'Jharkhand',
                    hi: 'झारखण्ड',
                },
                zip: '81[4-9]|82|83[0-5]',
            },
            {
                key: 'KA',
                name: {
                    default: 'Karnataka',
                    hi: 'कर्नाटक',
                },
                zip: '5[4-9]|53[7-9]',
            },
            {
                key: 'KL',
                name: {
                    default: 'Kerala',
                    hi: 'केरल',
                },
                zip: '6[7-9]|6010|607008|777',
            },
            {
                key: 'LA',
                name: {
                    default: 'Ladakh',
                    hi: 'लद्दाख़',
                },
                zip: '194',
            },
            {
                key: 'LD',
                name: {
                    default: 'Lakshadweep',
                    hi: 'लक्षद्वीप',
                },
                zip: '682',
            },
            {
                key: 'MP',
                name: {
                    default: 'Madhya Pradesh',
                    hi: 'मध्य प्रदेश',
                },
                zip: '4[5-8]|490',
            },
            {
                key: 'MH',
                name: {
                    default: 'Maharashtra',
                    hi: 'महाराष्ट्र',
                },
                zip: '4[0-4]',
            },
            {
                key: 'MN',
                name: {
                    default: 'Manipur',
                    hi: 'मणिपुर',
                },
                zip: '79[56]',
            },
            {
                key: 'ML',
                name: {
                    default: 'Meghalaya',
                    hi: 'मेघालय',
                },
                zip: '79[34]',
            },
            {
                key: 'MZ',
                name: {
                    default: 'Mizoram',
                    hi: 'मिजोरम',
                },
                zip: '796',
            },
            {
                key: 'NL',
                name: {
                    default: 'Nagaland',
                    hi: 'नागालैंड',
                },
                zip: '79[78]',
            },
            {
                key: 'OR',
                name: {
                    default: 'Odisha',
                    hi: 'ओड़िशा',
                },
                zip: '7[5-7]',
            },
            {
                key: 'PY',
                name: {
                    default: 'Puducherry',
                    hi: 'पांडिचेरी',
                },
                zip: '60[579]',
            },
            {
                key: 'PB',
                name: {
                    default: 'Punjab',
                    hi: 'पंजाब',
                },
                zip: '1[456]',
            },
            {
                key: 'RJ',
                name: {
                    default: 'Rajasthan',
                    hi: 'राजस्थान',
                },
                zip: '3[0-4]',
            },
            {
                key: 'SK',
                name: {
                    default: 'Sikkim',
                    hi: 'सिक्किम',
                },
                zip: '737|750',
            },
            {
                key: 'TN',
                name: {
                    default: 'Tamil Nadu',
                    hi: 'तमिल नाडु',
                },
                zip: '6[0-6]|536',
            },
            {
                key: 'TG',
                name: {
                    default: 'Telangana',
                    hi: 'तेलंगाना',
                },
                zip: '5[0-3]',
            },
            {
                key: 'TR',
                name: {
                    default: 'Tripura',
                    hi: 'त्रिपुरा',
                },
                zip: '799',
            },
            {
                key: 'UP',
                name: {
                    default: 'Uttar Pradesh',
                    hi: 'उत्तर प्रदेश',
                },
                zip: '2[0-35-8]|24[0-7]|26[12]',
            },
            {
                key: 'UT',
                name: {
                    default: 'Uttarakhand',
                    hi: 'उत्तराखण्ड',
                },
                zip: '24[46-9]|254|26[23]',
            },
            {
                key: 'WB',
                name: {
                    default: 'West Bengal',
                    hi: 'पश्चिम बंगाल',
                },
                zip: '7[0-4]',
            },
        ],
    },
    {
        id: 'data/IO',
        key: 'IO',
        name: 'BRITISH INDIAN OCEAN TERRITORY',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: 'BBND 1ZZ',
        zipex: 'BBND 1ZZ',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/IQ',
        key: 'IQ',
        name: 'IRAQ',
        fmt: '%O%n%N%n%A%n%C, %S%n%Z',
        zip: '\\d{5}',
        zipex: '31001',
        upper: 'CS',
        require: 'ACS',
    },
    {
        id: 'data/IR',
        key: 'IR',
        name: 'IRAN',
        fmt: '%O%n%N%n%S%n%C, %D%n%A%n%Z',
        zip: '\\d{5}-?\\d{5}',
        zipex: '11936-12345',
        sub_regions: [
            {
                key: '03',
                name: {
                    default: 'استان آذربایجان شرقی',
                    latin: 'East Azerbaijan Province',
                },
            },
            {
                key: '04',
                name: {
                    default: 'استان آذربایجان غربی',
                    latin: 'West Azerbaijan Province',
                },
            },
            {
                key: '24',
                name: {
                    default: 'استان اردبیل',
                    latin: 'Ardabil Province',
                },
            },
            {
                key: '10',
                name: {
                    default: 'استان اصفهان',
                    latin: 'Isfahan Province',
                },
            },
            {
                key: '30',
                name: {
                    default: 'استان البرز',
                    latin: 'Alborz Province',
                },
            },
            {
                key: '16',
                name: {
                    default: 'استان ایلام',
                    latin: 'Ilam Province',
                },
            },
            {
                key: '18',
                name: {
                    default: 'استان بوشهر',
                    latin: 'Bushehr Province',
                },
            },
            {
                key: '23',
                name: {
                    default: 'استان تهران',
                    latin: 'Tehran Province',
                },
            },
            {
                key: '14',
                name: {
                    default: 'استان چهارمحال و بختیاری',
                    latin: 'Chaharmahal and Bakhtiari Province',
                },
            },
            {
                key: '29',
                name: {
                    default: 'استان خراسان جنوبی',
                    latin: 'South Khorasan Province',
                },
            },
            {
                key: '09',
                name: {
                    default: 'استان خراسان رضوی',
                    latin: 'Razavi Khorasan Province',
                },
            },
            {
                key: '28',
                name: {
                    default: 'استان خراسان شمالی',
                    latin: 'North Khorasan Province',
                },
            },
            {
                key: '06',
                name: {
                    default: 'استان خوزستان',
                    latin: 'Khuzestan Province',
                },
            },
            {
                key: '19',
                name: {
                    default: 'استان زنجان',
                    latin: 'Zanjan Province',
                },
            },
            {
                key: '20',
                name: {
                    default: 'استان سمنان',
                    latin: 'Semnan Province',
                },
            },
            {
                key: '11',
                name: {
                    default: 'استان سیستان و بلوچستان',
                    latin: 'Sistan and Baluchestan Province',
                },
            },
            {
                key: '07',
                name: {
                    default: 'استان فارس',
                    latin: 'Fars Province',
                },
            },
            {
                key: '26',
                name: {
                    default: 'استان قزوین',
                    latin: 'Qazvin Province',
                },
            },
            {
                key: '25',
                name: {
                    default: 'استان قم',
                    latin: 'Qom Province',
                },
            },
            {
                key: '12',
                name: {
                    default: 'استان کردستان',
                    latin: 'Kurdistan Province',
                },
            },
            {
                key: '08',
                name: {
                    default: 'استان کرمان',
                    latin: 'Kerman Province',
                },
            },
            {
                key: '05',
                name: {
                    default: 'استان کرمانشاه',
                    latin: 'Kermanshah Province',
                },
            },
            {
                key: '17',
                name: {
                    default: 'استان کهگیلویه و بویراحمد',
                    latin: 'Kohgiluyeh and Boyer-Ahmad Province',
                },
            },
            {
                key: '27',
                name: {
                    default: 'استان گلستان',
                    latin: 'Golestan Province',
                },
            },
            {
                key: '01',
                name: {
                    default: 'استان گیلان',
                    latin: 'Gilan Province',
                },
            },
            {
                key: '15',
                name: {
                    default: 'استان لرستان',
                    latin: 'Lorestan Province',
                },
            },
            {
                key: '02',
                name: {
                    default: 'استان مازندران',
                    latin: 'Mazandaran Province',
                },
            },
            {
                key: '00',
                name: {
                    default: 'استان مرکزی',
                    latin: 'Markazi Province',
                },
            },
            {
                key: '22',
                name: {
                    default: 'استان هرمزگان',
                    latin: 'Hormozgan Province',
                },
            },
            {
                key: '13',
                name: {
                    default: 'استان همدان',
                    latin: 'Hamadan Province',
                },
            },
            {
                key: '21',
                name: {
                    default: 'استان یزد',
                    latin: 'Yazd Province',
                },
            },
        ],
    },
    {
        id: 'data/IS',
        key: 'IS',
        name: 'ICELAND',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{3}',
        zipex: '320,121,220,110',
    },
    {
        id: 'data/IT',
        key: 'IT',
        name: 'ITALY',
        fmt: '%N%n%O%n%A%n%Z %C %S',
        zip: '\\d{5}',
        zipex: '00144,47037,39049',
        upper: 'CS',
        require: 'ACSZ',
        sub_regions: [
            {
                key: 'AG',
                name: {
                    default: 'Agrigento',
                },
                zip: '92',
            },
            {
                key: 'AL',
                name: {
                    default: 'Alessandria',
                },
                zip: '15',
            },
            {
                key: 'AN',
                name: {
                    default: 'Ancona',
                },
                zip: '60',
            },
            {
                key: 'AO',
                name: {
                    default: 'Aosta',
                },
                zip: '11',
            },
            {
                key: 'AR',
                name: {
                    default: 'Arezzo',
                },
                zip: '52',
            },
            {
                key: 'AP',
                name: {
                    default: 'Ascoli Piceno',
                },
                zip: '63',
            },
            {
                key: 'AT',
                name: {
                    default: 'Asti',
                },
                zip: '14',
            },
            {
                key: 'AV',
                name: {
                    default: 'Avellino',
                },
                zip: '83',
            },
            {
                key: 'BA',
                name: {
                    default: 'Bari',
                },
                zip: '70',
            },
            {
                key: 'BT',
                name: {
                    default: 'Barletta-Andria-Trani',
                },
                zip: '76[01]',
            },
            {
                key: 'BL',
                name: {
                    default: 'Belluno',
                },
                zip: '32',
            },
            {
                key: 'BN',
                name: {
                    default: 'Benevento',
                },
                zip: '82',
            },
            {
                key: 'BG',
                name: {
                    default: 'Bergamo',
                },
                zip: '24',
            },
            {
                key: 'BI',
                name: {
                    default: 'Biella',
                },
                zip: '13[89]',
            },
            {
                key: 'BO',
                name: {
                    default: 'Bologna',
                },
                zip: '40',
            },
            {
                key: 'BZ',
                name: {
                    default: 'Bolzano',
                },
                zip: '39',
            },
            {
                key: 'BS',
                name: {
                    default: 'Brescia',
                },
                zip: '25',
            },
            {
                key: 'BR',
                name: {
                    default: 'Brindisi',
                },
                zip: '72',
            },
            {
                key: 'CA',
                name: {
                    default: 'Cagliari',
                },
                zip: '0912[1-9]|0913[0-4]|0901[0289]|0902[03468]|0903[0234]|0904|0803[035]|08043',
            },
            {
                key: 'CL',
                name: {
                    default: 'Caltanissetta',
                },
                zip: '93',
            },
            {
                key: 'CB',
                name: {
                    default: 'Campobasso',
                },
                zip: '860[1-4]|86100',
            },
            {
                key: 'CE',
                name: {
                    default: 'Caserta',
                },
                zip: '81',
            },
            {
                key: 'CT',
                name: {
                    default: 'Catania',
                },
                zip: '95',
            },
            {
                key: 'CZ',
                name: {
                    default: 'Catanzaro',
                },
                zip: '88[01]',
            },
            {
                key: 'CH',
                name: {
                    default: 'Chieti',
                },
                zip: '66',
            },
            {
                key: 'CO',
                name: {
                    default: 'Como',
                },
                zip: '22',
            },
            {
                key: 'CS',
                name: {
                    default: 'Cosenza',
                },
                zip: '87',
            },
            {
                key: 'CR',
                name: {
                    default: 'Cremona',
                },
                zip: '26[01]',
            },
            {
                key: 'KR',
                name: {
                    default: 'Crotone',
                },
                zip: '88[89]',
            },
            {
                key: 'CN',
                name: {
                    default: 'Cuneo',
                },
                zip: '12|18025',
            },
            {
                key: 'EN',
                name: {
                    default: 'Enna',
                },
                zip: '94',
            },
            {
                key: 'FM',
                name: {
                    default: 'Fermo',
                },
                zip: '638|63900',
            },
            {
                key: 'FE',
                name: {
                    default: 'Ferrara',
                },
                zip: '44',
            },
            {
                key: 'FI',
                name: {
                    default: 'Firenze',
                },
                zip: '50',
            },
            {
                key: 'FG',
                name: {
                    default: 'Foggia',
                },
                zip: '71',
            },
            {
                key: 'FC',
                name: {
                    default: 'Forlì-Cesena',
                },
                zip: '47[015]',
            },
            {
                key: 'FR',
                name: {
                    default: 'Frosinone',
                },
                zip: '03',
            },
            {
                key: 'GE',
                name: {
                    default: 'Genova',
                },
                zip: '16',
            },
            {
                key: 'GO',
                name: {
                    default: 'Gorizia',
                },
                zip: '34[01]7',
            },
            {
                key: 'GR',
                name: {
                    default: 'Grosseto',
                },
                zip: '58',
            },
            {
                key: 'IM',
                name: {
                    default: 'Imperia',
                },
                zip: '18',
            },
            {
                key: 'IS',
                name: {
                    default: 'Isernia',
                },
                zip: '860[7-9]|86170',
            },
            {
                key: 'AQ',
                name: {
                    default: 'L\'Aquila',
                },
                zip: '67',
            },
            {
                key: 'SP',
                name: {
                    default: 'La Spezia',
                },
                zip: '19',
            },
            {
                key: 'LT',
                name: {
                    default: 'Latina',
                },
                zip: '04',
            },
            {
                key: 'LE',
                name: {
                    default: 'Lecce',
                },
                zip: '73',
            },
            {
                key: 'LC',
                name: {
                    default: 'Lecco',
                },
                zip: '23[89]',
            },
            {
                key: 'LI',
                name: {
                    default: 'Livorno',
                },
                zip: '57',
            },
            {
                key: 'LO',
                name: {
                    default: 'Lodi',
                },
                zip: '26[89]',
            },
            {
                key: 'LU',
                name: {
                    default: 'Lucca',
                },
                zip: '55',
            },
            {
                key: 'MC',
                name: {
                    default: 'Macerata',
                },
                zip: '62',
            },
            {
                key: 'MN',
                name: {
                    default: 'Mantova',
                },
                zip: '46',
            },
            {
                key: 'MS',
                name: {
                    default: 'Massa-Carrara',
                },
                zip: '54',
            },
            {
                key: 'MT',
                name: {
                    default: 'Matera',
                },
                zip: '75',
            },
            {
                key: 'ME',
                name: {
                    default: 'Messina',
                },
                zip: '98',
            },
            {
                key: 'MI',
                name: {
                    default: 'Milano',
                },
                zip: '20',
            },
            {
                key: 'MO',
                name: {
                    default: 'Modena',
                },
                zip: '41',
            },
            {
                key: 'MB',
                name: {
                    default: 'Monza e Brianza',
                },
                zip: '208|20900',
            },
            {
                key: 'NA',
                name: {
                    default: 'Napoli',
                },
                zip: '80',
            },
            {
                key: 'NO',
                name: {
                    default: 'Novara',
                },
                zip: '28[01]',
            },
            {
                key: 'NU',
                name: {
                    default: 'Nuoro',
                },
                zip: '080[1-4]|08100',
            },
            {
                key: 'OR',
                name: {
                    default: 'Oristano',
                },
                zip: '090[7-9]|09170|0801[039]|0803[04]',
            },
            {
                key: 'PD',
                name: {
                    default: 'Padova',
                },
                zip: '35',
            },
            {
                key: 'PA',
                name: {
                    default: 'Palermo',
                },
                zip: '90',
            },
            {
                key: 'PR',
                name: {
                    default: 'Parma',
                },
                zip: '43',
            },
            {
                key: 'PV',
                name: {
                    default: 'Pavia',
                },
                zip: '27',
            },
            {
                key: 'PG',
                name: {
                    default: 'Perugia',
                },
                zip: '06',
            },
            {
                key: 'PU',
                name: {
                    default: 'Pesaro e Urbino',
                },
                zip: '61',
            },
            {
                key: 'PE',
                name: {
                    default: 'Pescara',
                },
                zip: '65',
            },
            {
                key: 'PC',
                name: {
                    default: 'Piacenza',
                },
                zip: '29',
            },
            {
                key: 'PI',
                name: {
                    default: 'Pisa',
                },
                zip: '56',
            },
            {
                key: 'PT',
                name: {
                    default: 'Pistoia',
                },
                zip: '51',
            },
            {
                key: 'PN',
                name: {
                    default: 'Pordenone',
                },
                zip: '330[7-9]|33170',
            },
            {
                key: 'PZ',
                name: {
                    default: 'Potenza',
                },
                zip: '85',
            },
            {
                key: 'PO',
                name: {
                    default: 'Prato',
                },
                zip: '59',
            },
            {
                key: 'RG',
                name: {
                    default: 'Ragusa',
                },
                zip: '97',
            },
            {
                key: 'RA',
                name: {
                    default: 'Ravenna',
                },
                zip: '48',
            },
            {
                key: 'RC',
                name: {
                    default: 'Reggio Calabria',
                },
                zip: '89[01]',
            },
            {
                key: 'RE',
                name: {
                    default: 'Reggio Emilia',
                },
                zip: '42',
            },
            {
                key: 'RI',
                name: {
                    default: 'Rieti',
                },
                zip: '02',
            },
            {
                key: 'RN',
                name: {
                    default: 'Rimini',
                },
                zip: '47[89]',
            },
            {
                key: 'RM',
                name: {
                    default: 'Roma',
                },
                zip: '00',
            },
            {
                key: 'RO',
                name: {
                    default: 'Rovigo',
                },
                zip: '45',
            },
            {
                key: 'SA',
                name: {
                    default: 'Salerno',
                },
                zip: '84',
            },
            {
                key: 'SS',
                name: {
                    default: 'Sassari',
                },
                zip: '07[01]|08020',
            },
            {
                key: 'SV',
                name: {
                    default: 'Savona',
                },
                zip: '17|12071',
            },
            {
                key: 'SI',
                name: {
                    default: 'Siena',
                },
                zip: '53',
            },
            {
                key: 'SR',
                name: {
                    default: 'Siracusa',
                },
                zip: '96',
            },
            {
                key: 'SO',
                name: {
                    default: 'Sondrio',
                },
                zip: '23[01]',
            },
            {
                key: 'SU',
                name: {
                    default: 'Sud Sardegna',
                },
                zip: '090[1-5][0-9]|0906[0-6]|080[1-4]',
            },
            {
                key: 'TA',
                name: {
                    default: 'Taranto',
                },
                zip: '74',
            },
            {
                key: 'TE',
                name: {
                    default: 'Teramo',
                },
                zip: '64',
            },
            {
                key: 'TR',
                name: {
                    default: 'Terni',
                },
                zip: '05',
            },
            {
                key: 'TO',
                name: {
                    default: 'Torino',
                },
                zip: '10',
            },
            {
                key: 'TP',
                name: {
                    default: 'Trapani',
                },
                zip: '91',
            },
            {
                key: 'TN',
                name: {
                    default: 'Trento',
                },
                zip: '38',
            },
            {
                key: 'TV',
                name: {
                    default: 'Treviso',
                },
                zip: '31',
            },
            {
                key: 'TS',
                name: {
                    default: 'Trieste',
                },
                zip: '3401|341[0-689]|34062',
            },
            {
                key: 'UD',
                name: {
                    default: 'Udine',
                },
                zip: '330[1-5]|33100',
            },
            {
                key: 'VA',
                name: {
                    default: 'Varese',
                },
                zip: '21',
            },
            {
                key: 'VE',
                name: {
                    default: 'Venezia',
                },
                zip: '30',
            },
            {
                key: 'VB',
                name: {
                    default: 'Verbano-Cusio-Ossola',
                },
                zip: '28[89]',
            },
            {
                key: 'VC',
                name: {
                    default: 'Vercelli',
                },
                zip: '13[01]',
            },
            {
                key: 'VR',
                name: {
                    default: 'Verona',
                },
                zip: '37',
            },
            {
                key: 'VV',
                name: {
                    default: 'Vibo Valentia',
                },
                zip: '89[89]',
            },
            {
                key: 'VI',
                name: {
                    default: 'Vicenza',
                },
                zip: '36',
            },
            {
                key: 'VT',
                name: {
                    default: 'Viterbo',
                },
                zip: '01',
            },
        ],
    },
    {
        id: 'data/JE',
        key: 'JE',
        name: 'CHANNEL ISLANDS',
        fmt: '%N%n%O%n%A%n%C%nJERSEY%n%Z',
        zip: 'JE\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}',
        zipex: 'JE1 1AA,JE2 2BT',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/JM',
        key: 'JM',
        name: 'JAMAICA',
        fmt: '%N%n%O%n%A%n%C%n%S %X',
        require: 'ACS',
        sub_regions: [
            {
                key: '13',
                name: {
                    default: 'Clarendon',
                },
            },
            {
                key: '09',
                name: {
                    default: 'Hanover',
                },
            },
            {
                key: '01',
                name: {
                    default: 'Kingston',
                },
            },
            {
                key: '12',
                name: {
                    default: 'Manchester',
                },
            },
            {
                key: '04',
                name: {
                    default: 'Portland',
                },
            },
            {
                key: '02',
                name: {
                    default: 'St. Andrew',
                },
            },
            {
                key: '06',
                name: {
                    default: 'St. Ann',
                },
            },
            {
                key: '14',
                name: {
                    default: 'St. Catherine',
                },
            },
            {
                key: '11',
                name: {
                    default: 'St. Elizabeth',
                },
            },
            {
                key: '08',
                name: {
                    default: 'St. James',
                },
            },
            {
                key: '05',
                name: {
                    default: 'St. Mary',
                },
            },
            {
                key: '03',
                name: {
                    default: 'St. Thomas',
                },
            },
            {
                key: '07',
                name: {
                    default: 'Trelawny',
                },
            },
            {
                key: '10',
                name: {
                    default: 'Westmoreland',
                },
            },
        ],
    },
    {
        id: 'data/JO',
        key: 'JO',
        name: 'JORDAN',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '\\d{5}',
        zipex: '11937,11190',
    },
    {
        id: 'data/JP',
        key: 'JP',
        name: 'JAPAN',
        fmt: '〒%Z%n%S%n%A%n%O%n%N',
        lfmt: '%N%n%O%n%A, %S%n%Z',
        zip: '\\d{3}-?\\d{4}',
        zipex: '154-0023,350-1106,951-8073,112-0001,208-0032,231-0012',
        upper: 'S',
        require: 'ASZ',
        sub_regions: [
            {
                key: '01',
                name: {
                    default: '北海道',
                    latin: 'Hokkaido',
                },
                zip: '0[4-9]|00[1-7]',
            },
            {
                key: '02',
                name: {
                    default: '青森県',
                    latin: 'Aomori',
                },
                zip: '03|018',
            },
            {
                key: '03',
                name: {
                    default: '岩手県',
                    latin: 'Iwate',
                },
                zip: '02',
            },
            {
                key: '04',
                name: {
                    default: '宮城県',
                    latin: 'Miyagi',
                },
                zip: '98',
            },
            {
                key: '05',
                name: {
                    default: '秋田県',
                    latin: 'Akita',
                },
                zip: '01',
            },
            {
                key: '06',
                name: {
                    default: '山形県',
                    latin: 'Yamagata',
                },
                zip: '99',
            },
            {
                key: '07',
                name: {
                    default: '福島県',
                    latin: 'Fukushima',
                },
                zip: '9[67]',
            },
            {
                key: '08',
                name: {
                    default: '茨城県',
                    latin: 'Ibaraki',
                },
                zip: '3[01]',
            },
            {
                key: '09',
                name: {
                    default: '栃木県',
                    latin: 'Tochigi',
                },
                zip: '32|311|349',
            },
            {
                key: '10',
                name: {
                    default: '群馬県',
                    latin: 'Gunma',
                },
                zip: '37|38[49]',
            },
            {
                key: '11',
                name: {
                    default: '埼玉県',
                    latin: 'Saitama',
                },
                zip: '3[3-6]',
            },
            {
                key: '12',
                name: {
                    default: '千葉県',
                    latin: 'Chiba',
                },
                zip: '2[6-9]',
            },
            {
                key: '13',
                name: {
                    default: '東京都',
                    latin: 'Tokyo',
                },
                zip: '1[0-8]|19[0-8]|20',
            },
            {
                key: '14',
                name: {
                    default: '神奈川県',
                    latin: 'Kanagawa',
                },
                zip: '2[1-5]|199',
            },
            {
                key: '15',
                name: {
                    default: '新潟県',
                    latin: 'Niigata',
                },
                zip: '9[45]|389',
            },
            {
                key: '16',
                name: {
                    default: '富山県',
                    latin: 'Toyama',
                },
                zip: '93',
            },
            {
                key: '17',
                name: {
                    default: '石川県',
                    latin: 'Ishikawa',
                },
                zip: '92|939',
            },
            {
                key: '18',
                name: {
                    default: '福井県',
                    latin: 'Fukui',
                },
                zip: '91|922',
            },
            {
                key: '19',
                name: {
                    default: '山梨県',
                    latin: 'Yamanashi',
                },
                zip: '40',
            },
            {
                key: '20',
                name: {
                    default: '長野県',
                    latin: 'Nagano',
                },
                zip: '3[89]|949',
            },
            {
                key: '21',
                name: {
                    default: '岐阜県',
                    latin: 'Gifu',
                },
                zip: '50',
            },
            {
                key: '22',
                name: {
                    default: '静岡県',
                    latin: 'Shizuoka',
                },
                zip: '4[1-9]',
            },
            {
                key: '23',
                name: {
                    default: '愛知県',
                    latin: 'Aichi',
                },
                zip: '4[4-9]|431',
            },
            {
                key: '24',
                name: {
                    default: '三重県',
                    latin: 'Mie',
                },
                zip: '51|498|647',
            },
            {
                key: '25',
                name: {
                    default: '滋賀県',
                    latin: 'Shiga',
                },
                zip: '52',
            },
            {
                key: '26',
                name: {
                    default: '京都府',
                    latin: 'Kyoto',
                },
                zip: '6[0-2]|520',
            },
            {
                key: '27',
                name: {
                    default: '大阪府',
                    latin: 'Osaka',
                },
                zip: '5[3-9]|618|630',
            },
            {
                key: '28',
                name: {
                    default: '兵庫県',
                    latin: 'Hyogo',
                },
                zip: '6[5-7]|563',
            },
            {
                key: '29',
                name: {
                    default: '奈良県',
                    latin: 'Nara',
                },
                zip: '63|64[78]',
            },
            {
                key: '30',
                name: {
                    default: '和歌山県',
                    latin: 'Wakayama',
                },
                zip: '64|519',
            },
            {
                key: '31',
                name: {
                    default: '鳥取県',
                    latin: 'Tottori',
                },
                zip: '68',
            },
            {
                key: '32',
                name: {
                    default: '島根県',
                    latin: 'Shimane',
                },
                zip: '69|68[45]',
            },
            {
                key: '33',
                name: {
                    default: '岡山県',
                    latin: 'Okayama',
                },
                zip: '7[01]',
            },
            {
                key: '34',
                name: {
                    default: '広島県',
                    latin: 'Hiroshima',
                },
                zip: '7[23]',
            },
            {
                key: '35',
                name: {
                    default: '山口県',
                    latin: 'Yamaguchi',
                },
                zip: '7[45]',
            },
            {
                key: '36',
                name: {
                    default: '徳島県',
                    latin: 'Tokushima',
                },
                zip: '77',
            },
            {
                key: '37',
                name: {
                    default: '香川県',
                    latin: 'Kagawa',
                },
                zip: '76',
            },
            {
                key: '38',
                name: {
                    default: '愛媛県',
                    latin: 'Ehime',
                },
                zip: '79',
            },
            {
                key: '39',
                name: {
                    default: '高知県',
                    latin: 'Kochi',
                },
                zip: '78',
            },
            {
                key: '40',
                name: {
                    default: '福岡県',
                    latin: 'Fukuoka',
                },
                zip: '8[0-3]|871',
            },
            {
                key: '41',
                name: {
                    default: '佐賀県',
                    latin: 'Saga',
                },
                zip: '84',
            },
            {
                key: '42',
                name: {
                    default: '長崎県',
                    latin: 'Nagasaki',
                },
                zip: '85|81[17]|848',
            },
            {
                key: '43',
                name: {
                    default: '熊本県',
                    latin: 'Kumamoto',
                },
                zip: '86',
            },
            {
                key: '44',
                name: {
                    default: '大分県',
                    latin: 'Oita',
                },
                zip: '87|839',
            },
            {
                key: '45',
                name: {
                    default: '宮崎県',
                    latin: 'Miyazaki',
                },
                zip: '88',
            },
            {
                key: '46',
                name: {
                    default: '鹿児島県',
                    latin: 'Kagoshima',
                },
                zip: '89',
            },
            {
                key: '47',
                name: {
                    default: '沖縄県',
                    latin: 'Okinawa',
                },
                zip: '90',
            },
        ],
    },
    {
        id: 'data/KE',
        key: 'KE',
        name: 'KENYA',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: '\\d{5}',
        zipex: '20100,00100',
    },
    {
        id: 'data/KG',
        key: 'KG',
        name: 'KYRGYZSTAN',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{6}',
        zipex: '720001',
    },
    {
        id: 'data/KH',
        key: 'KH',
        name: 'CAMBODIA',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '\\d{5,6}',
        zipex: '120101,120108',
    },
    {
        id: 'data/KI',
        key: 'KI',
        name: 'KIRIBATI',
        fmt: '%N%n%O%n%A%n%S%n%C',
        upper: 'ACNOS',
    },
    {
        id: 'data/KM',
        key: 'KM',
        name: 'COMOROS',
        upper: 'AC',
    },
    {
        id: 'data/KN',
        key: 'KN',
        name: 'SAINT KITTS AND NEVIS',
        fmt: '%N%n%O%n%A%n%C, %S',
        require: 'ACS',
        sub_regions: [
            {
                key: 'N',
                name: {
                    default: 'Nevis',
                },
            },
            {
                key: 'K',
                name: {
                    default: 'St. Kitts',
                },
            },
        ],
    },
    {
        id: 'data/KP',
        key: 'KP',
        name: 'NORTH KOREA',
        fmt: '%Z%n%S%n%C%n%A%n%O%n%N',
        lfmt: '%N%n%O%n%A%n%C%n%S, %Z',
        sub_regions: [
            {
                key: '07',
                name: {
                    default: '강원도',
                    latin: 'Kangwon',
                },
            },
            {
                key: '13',
                name: {
                    default: '라선 특별시',
                    latin: 'Rason',
                },
            },
            {
                key: '10',
                name: {
                    default: '량강도',
                    latin: 'Ryanggang',
                },
            },
            {
                key: '04',
                name: {
                    default: '자강도',
                    latin: 'Chagang',
                },
            },
            {
                key: '02',
                name: {
                    default: '평안 남도',
                    latin: 'South Pyongan',
                },
            },
            {
                key: '03',
                name: {
                    default: '평안 북도',
                    latin: 'North Pyongan',
                },
            },
            {
                key: '01',
                name: {
                    default: '평양 직할시',
                    latin: 'Pyongyang',
                },
            },
            {
                key: '08',
                name: {
                    default: '함경 남도',
                    latin: 'South Hamgyong',
                },
            },
            {
                key: '09',
                name: {
                    default: '함경 북도',
                    latin: 'North Hamgyong',
                },
            },
            {
                key: '05',
                name: {
                    default: '황해남도',
                    latin: 'South Hwanghae',
                },
            },
            {
                key: '06',
                name: {
                    default: '황해북도',
                    latin: 'North Hwanghae',
                },
            },
        ],
    },
    {
        id: 'data/KR',
        key: 'KR',
        name: 'SOUTH KOREA',
        fmt: '%S %C%D%n%A%n%O%n%N%n%Z',
        lfmt: '%N%n%O%n%A%n%D%n%C%n%S%n%Z',
        zip: '\\d{5}',
        zipex: '03051',
        upper: 'Z',
        require: 'ACSZ',
        sub_regions: [
            {
                key: '42',
                name: {
                    default: '강원',
                    latin: 'Gangwon-do',
                },
                zip: '2[456]\\d{2}',
            },
            {
                key: '41',
                name: {
                    default: '경기',
                    latin: 'Gyeonggi-do',
                },
                zip: '1[0-8]\\d{2}',
            },
            {
                key: '48',
                name: {
                    default: '경남',
                    latin: 'Gyeongsangnam-do',
                },
                zip: '5[0-3]\\d{2}',
            },
            {
                key: '47',
                name: {
                    default: '경북',
                    latin: 'Gyeongsangbuk-do',
                },
                zip: '(?:3[6-9]|40)\\d{2}',
            },
            {
                key: '29',
                name: {
                    default: '광주',
                    latin: 'Gwangju',
                },
                zip: '6[12]\\d{2}',
            },
            {
                key: '27',
                name: {
                    default: '대구',
                    latin: 'Daegu',
                },
                zip: '4[123]\\d{2}',
            },
            {
                key: '30',
                name: {
                    default: '대전',
                    latin: 'Daejeon',
                },
                zip: '3[45]\\d{2}',
            },
            {
                key: '26',
                name: {
                    default: '부산',
                    latin: 'Busan',
                },
                zip: '4[6-9]\\d{2}',
            },
            {
                key: '11',
                name: {
                    default: '서울',
                    latin: 'Seoul',
                },
                zip: '0[1-8]\\d{2}',
            },
            {
                key: '50',
                name: {
                    default: '세종',
                    latin: 'Sejong',
                },
                zip: '30[01]\\d',
            },
            {
                key: '31',
                name: {
                    default: '울산',
                    latin: 'Ulsan',
                },
                zip: '4[45]\\d{2}',
            },
            {
                key: '28',
                name: {
                    default: '인천',
                    latin: 'Incheon',
                },
                zip: '2[1-3]\\d{2}',
            },
            {
                key: '46',
                name: {
                    default: '전남',
                    latin: 'Jeollanam-do',
                },
                zip: '5[7-9]\\d{2}',
            },
            {
                key: '45',
                name: {
                    default: '전북',
                    latin: 'Jeollabuk-do',
                },
                zip: '5[4-6]\\d{2}',
            },
            {
                key: '49',
                name: {
                    default: '제주',
                    latin: 'Jeju-do',
                },
                zip: '63[0-356]\\d',
            },
            {
                key: '44',
                name: {
                    default: '충남',
                    latin: 'Chungcheongnam-do',
                },
                zip: '3[1-3]\\d{2}',
            },
            {
                key: '43',
                name: {
                    default: '충북',
                    latin: 'Chungcheongbuk-do',
                },
                zip: '2[789]\\d{2}',
            },
        ],
    },
    {
        id: 'data/KW',
        key: 'KW',
        name: 'KUWAIT',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '54541,54551,54404,13009',
    },
    {
        id: 'data/KY',
        key: 'KY',
        name: 'CAYMAN ISLANDS',
        fmt: '%N%n%O%n%A%n%S %Z',
        zip: 'KY\\d-\\d{4}',
        zipex: 'KY1-1100,KY1-1702,KY2-2101',
        require: 'AS',
        sub_regions: [
            {
                key: 'Cayman Brac',
                name: {
                    default: 'Cayman Brac',
                },
            },
            {
                key: 'Grand Cayman',
                name: {
                    default: 'Grand Cayman',
                },
            },
            {
                key: 'Little Cayman',
                name: {
                    default: 'Little Cayman',
                },
            },
        ],
    },
    {
        id: 'data/KZ',
        key: 'KZ',
        name: 'KAZAKHSTAN',
        fmt: '%Z%n%S%n%C%n%A%n%O%n%N',
        zip: '\\d{6}',
        zipex: '040900,050012',
    },
    {
        id: 'data/LA',
        key: 'LA',
        name: 'LAO (PEOPLE\'S DEM. REP.)',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '01160,01000',
    },
    {
        id: 'data/LB',
        key: 'LB',
        name: 'LEBANON',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '(?:\\d{4})(?: ?(?:\\d{4}))?',
        zipex: '2038 3054,1107 2810,1000',
    },
    {
        id: 'data/LC',
        key: 'LC',
        name: 'SAINT LUCIA',
    },
    {
        id: 'data/LI',
        key: 'LI',
        name: 'LIECHTENSTEIN',
        fmt: '%O%n%N%n%A%nFL-%Z %C',
        zip: '948[5-9]|949[0-8]',
        zipex: '9496,9491,9490,9485',
        require: 'ACZ',
    },
    {
        id: 'data/LK',
        key: 'LK',
        name: 'SRI LANKA',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: '\\d{5}',
        zipex: '20000,00100',
    },
    {
        id: 'data/LR',
        key: 'LR',
        name: 'LIBERIA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '1000',
    },
    {
        id: 'data/LS',
        key: 'LS',
        name: 'LESOTHO',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '\\d{3}',
        zipex: '100',
    },
    {
        id: 'data/LT',
        key: 'LT',
        name: 'LITHUANIA',
        fmt: '%O%n%N%n%A%nLT-%Z %C %S',
        zip: '\\d{5}',
        zipex: '04340,03500',
        require: 'ACZ',
    },
    {
        id: 'data/LU',
        key: 'LU',
        name: 'LUXEMBOURG',
        fmt: '%O%n%N%n%A%nL-%Z %C',
        zip: '\\d{4}',
        zipex: '4750,2998',
        require: 'ACZ',
    },
    {
        id: 'data/LV',
        key: 'LV',
        name: 'LATVIA',
        fmt: '%N%n%O%n%A%n%S%n%C, %Z',
        zip: 'LV-\\d{4}',
        zipex: 'LV-1073,LV-1000',
        require: 'ACZ',
    },
    {
        id: 'data/LY',
        key: 'LY',
        name: 'LIBYA',
    },
    {
        id: 'data/MA',
        key: 'MA',
        name: 'MOROCCO',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '53000,10000,20050,16052',
    },
    {
        id: 'data/MC',
        key: 'MC',
        name: 'MONACO',
        fmt: '%N%n%O%n%A%nMC-%Z %C %X',
        zip: '980\\d{2}',
        zipex: '98000,98020,98011,98001',
    },
    {
        id: 'data/MD',
        key: 'MD',
        name: 'Rep. MOLDOVA',
        fmt: '%N%n%O%n%A%nMD-%Z %C',
        zip: '\\d{4}',
        zipex: '2012,2019',
    },
    {
        id: 'data/ME',
        key: 'ME',
        name: 'MONTENEGRO',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '8\\d{4}',
        zipex: '81257,81258,81217,84314,85366',
    },
    {
        id: 'data/MF',
        key: 'MF',
        name: 'SAINT MARTIN',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '9[78][01]\\d{2}',
        zipex: '97100',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/MG',
        key: 'MG',
        name: 'MADAGASCAR',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{3}',
        zipex: '501,101',
    },
    {
        id: 'data/MH',
        key: 'MH',
        name: 'MARSHALL ISLANDS',
        fmt: '%N%n%O%n%A%n%C %S %Z',
        zip: '(969[67]\\d)(?:[ \\-](\\d{4}))?',
        zipex: '96960,96970',
        upper: 'ACNOS',
        require: 'ACSZ',
    },
    {
        id: 'data/MK',
        key: 'MK',
        name: 'MACEDONIA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '1314,1321,1443,1062',
    },
    {
        id: 'data/ML',
        key: 'ML',
        name: 'MALI',
    },
    {
        id: 'data/MM',
        key: 'MM',
        name: 'MYANMAR',
        fmt: '%N%n%O%n%A%n%C, %Z',
        zip: '\\d{5}',
        zipex: '11181',
    },
    {
        id: 'data/MN',
        key: 'MN',
        name: 'MONGOLIA',
        fmt: '%N%n%O%n%A%n%C%n%S %Z',
        zip: '\\d{5}',
        zipex: '65030,65270',
    },
    {
        id: 'data/MO',
        key: 'MO',
        name: 'MACAO',
        fmt: '%A%n%O%n%N',
        lfmt: '%N%n%O%n%A',
        require: 'A',
    },
    {
        id: 'data/MP',
        key: 'MP',
        name: 'NORTHERN MARIANA ISLANDS',
        fmt: '%N%n%O%n%A%n%C %S %Z',
        zip: '(9695[012])(?:[ \\-](\\d{4}))?',
        zipex: '96950,96951,96952',
        upper: 'ACNOS',
        require: 'ACSZ',
    },
    {
        id: 'data/MQ',
        key: 'MQ',
        name: 'MARTINIQUE',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '9[78]2\\d{2}',
        zipex: '97220',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/MR',
        key: 'MR',
        name: 'MAURITANIA',
        upper: 'AC',
    },
    {
        id: 'data/MS',
        key: 'MS',
        name: 'MONTSERRAT',
    },
    {
        id: 'data/MT',
        key: 'MT',
        name: 'MALTA',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '[A-Z]{3} ?\\d{2,4}',
        zipex: 'NXR 01,ZTN 05,GPO 01,BZN 1130,SPB 6031,VCT 1753',
        upper: 'CZ',
    },
    {
        id: 'data/MU',
        key: 'MU',
        name: 'MAURITIUS',
        fmt: '%N%n%O%n%A%n%Z%n%C',
        zip: '\\d{3}(?:\\d{2}|[A-Z]{2}\\d{3})',
        zipex: '42602',
        upper: 'CZ',
    },
    {
        id: 'data/MV',
        key: 'MV',
        name: 'MALDIVES',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '\\d{5}',
        zipex: '20026',
    },
    {
        id: 'data/MW',
        key: 'MW',
        name: 'MALAWI',
        fmt: '%N%n%O%n%A%n%C %X',
    },
    {
        id: 'data/MX',
        key: 'MX',
        name: 'MEXICO',
        fmt: '%N%n%O%n%A%n%D%n%Z %C, %S',
        zip: '\\d{5}',
        zipex: '02860,77520,06082',
        upper: 'CSZ',
        require: 'ACSZ',
        sub_regions: [
            {
                key: 'AGU',
                name: {
                    default: 'Aguascalientes',
                },
                zip: '20',
            },
            {
                key: 'BCN',
                name: {
                    default: 'Baja California',
                },
                zip: '2[12]',
            },
            {
                key: 'BCS',
                name: {
                    default: 'Baja California Sur',
                },
                zip: '23',
            },
            {
                key: 'CAM',
                name: {
                    default: 'Campeche',
                },
                zip: '24',
            },
            {
                key: 'CHP',
                name: {
                    default: 'Chiapas',
                },
                zip: '29|30',
            },
            {
                key: 'CHH',
                name: {
                    default: 'Chihuahua',
                },
                zip: '3[1-3]',
            },
            {
                key: 'CMX',
                name: {
                    default: 'Ciudad de México',
                },
                zip: '0|1[0-6]',
            },
            {
                key: 'COA',
                name: {
                    default: 'Coahuila de Zaragoza',
                },
                zip: '2[5-7]',
            },
            {
                key: 'COL',
                name: {
                    default: 'Colima',
                },
                zip: '28',
            },
            {
                key: 'DUR',
                name: {
                    default: 'Durango',
                },
                zip: '3[45]',
            },
            {
                key: 'MEX',
                name: {
                    default: 'Estado de México',
                },
                zip: '5[0-7]',
            },
            {
                key: 'GUA',
                name: {
                    default: 'Guanajuato',
                },
                zip: '3[6-8]',
            },
            {
                key: 'GRO',
                name: {
                    default: 'Guerrero',
                },
                zip: '39|4[01]',
            },
            {
                key: 'HID',
                name: {
                    default: 'Hidalgo',
                },
                zip: '4[23]',
            },
            {
                key: 'JAL',
                name: {
                    default: 'Jalisco',
                },
                zip: '4[4-9]',
            },
            {
                key: 'MIC',
                name: {
                    default: 'Michoacán',
                },
                zip: '5[89]|6[01]',
            },
            {
                key: 'MOR',
                name: {
                    default: 'Morelos',
                },
                zip: '62',
            },
            {
                key: 'NAY',
                name: {
                    default: 'Nayarit',
                },
                zip: '63',
            },
            {
                key: 'NLE',
                name: {
                    default: 'Nuevo León',
                },
                zip: '6[4-7]',
            },
            {
                key: 'OAX',
                name: {
                    default: 'Oaxaca',
                },
                zip: '6[89]|7[01]',
            },
            {
                key: 'PUE',
                name: {
                    default: 'Puebla',
                },
                zip: '7[2-5]',
            },
            {
                key: 'QUE',
                name: {
                    default: 'Querétaro',
                },
                zip: '76',
            },
            {
                key: 'ROO',
                name: {
                    default: 'Quintana Roo',
                },
                zip: '77',
            },
            {
                key: 'SLP',
                name: {
                    default: 'San Luis Potosí',
                },
                zip: '7[89]',
            },
            {
                key: 'SIN',
                name: {
                    default: 'Sinaloa',
                },
                zip: '8[0-2]',
            },
            {
                key: 'SON',
                name: {
                    default: 'Sonora',
                },
                zip: '8[3-5]',
            },
            {
                key: 'TAB',
                name: {
                    default: 'Tabasco',
                },
                zip: '86',
            },
            {
                key: 'TAM',
                name: {
                    default: 'Tamaulipas',
                },
                zip: '8[7-9]',
            },
            {
                key: 'TLA',
                name: {
                    default: 'Tlaxcala',
                },
                zip: '90',
            },
            {
                key: 'VER',
                name: {
                    default: 'Veracruz',
                },
                zip: '9[1-6]',
            },
            {
                key: 'YUC',
                name: {
                    default: 'Yucatán',
                },
                zip: '97',
            },
            {
                key: 'ZAC',
                name: {
                    default: 'Zacatecas',
                },
                zip: '9[89]',
            },
        ],
    },
    {
        id: 'data/MY',
        key: 'MY',
        name: 'MALAYSIA',
        fmt: '%N%n%O%n%A%n%D%n%Z %C%n%S',
        zip: '\\d{5}',
        zipex: '43000,50754,88990,50670',
        upper: 'CS',
        require: 'ACZ',
        sub_regions: [
            {
                key: '01',
                name: {
                    default: 'Johor',
                },
                zip: '79|8[0-6]',
            },
            {
                key: '02',
                name: {
                    default: 'Kedah',
                },
                zip: '0[5-9]|34950',
            },
            {
                key: '03',
                name: {
                    default: 'Kelantan',
                },
                zip: '1[5-9]',
            },
            {
                key: '14',
                name: {
                    default: 'Kuala Lumpur',
                },
                zip: '5|60',
            },
            {
                key: '15',
                name: {
                    default: 'Labuan',
                },
                zip: '87',
            },
            {
                key: '04',
                name: {
                    default: 'Melaka',
                },
                zip: '7[5-8]',
            },
            {
                key: '05',
                name: {
                    default: 'Negeri Sembilan',
                },
                zip: '7[0-4]',
            },
            {
                key: '06',
                name: {
                    default: 'Pahang',
                },
                zip: '2[5-8]|[346]9',
            },
            {
                key: '08',
                name: {
                    default: 'Perak',
                },
                zip: '3[0-6]|39000',
            },
            {
                key: '09',
                name: {
                    default: 'Perlis',
                },
                zip: '0[12]',
            },
            {
                key: '07',
                name: {
                    default: 'Pulau Pinang',
                },
                zip: '1[0-4]',
            },
            {
                key: '16',
                name: {
                    default: 'Putrajaya',
                },
                zip: '62',
            },
            {
                key: '12',
                name: {
                    default: 'Sabah',
                },
                zip: '8[89]|9[01]',
            },
            {
                key: '13',
                name: {
                    default: 'Sarawak',
                },
                zip: '9[3-8]',
            },
            {
                key: '10',
                name: {
                    default: 'Selangor',
                },
                zip: '4[0-8]|6[3-8]',
            },
            {
                key: '11',
                name: {
                    default: 'Terengganu',
                },
                zip: '2[0-4]',
            },
        ],
    },
    {
        id: 'data/MZ',
        key: 'MZ',
        name: 'MOZAMBIQUE',
        fmt: '%N%n%O%n%A%n%Z %C%S',
        zip: '\\d{4}',
        zipex: '1102,1119,3212',
        sub_regions: [
            {
                key: 'P',
                name: {
                    default: 'Cabo Delgado',
                },
            },
            {
                key: 'MPM',
                name: {
                    default: 'Cidade de Maputo',
                },
            },
            {
                key: 'G',
                name: {
                    default: 'Gaza',
                },
            },
            {
                key: 'I',
                name: {
                    default: 'Inhambane',
                },
            },
            {
                key: 'B',
                name: {
                    default: 'Manica',
                },
            },
            {
                key: 'L',
                name: {
                    default: 'Maputo',
                },
            },
            {
                key: 'N',
                name: {
                    default: 'Nampula',
                },
            },
            {
                key: 'A',
                name: {
                    default: 'Niassa',
                },
            },
            {
                key: 'S',
                name: {
                    default: 'Sofala',
                },
            },
            {
                key: 'T',
                name: {
                    default: 'Tete',
                },
            },
            {
                key: 'Q',
                name: {
                    default: 'Zambezia',
                },
            },
        ],
    },
    {
        id: 'data/NA',
        key: 'NA',
        name: 'NAMIBIA',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: '\\d{5}',
        zipex: '10001,10017',
    },
    {
        id: 'data/NC',
        key: 'NC',
        name: 'NEW CALEDONIA',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '988\\d{2}',
        zipex: '98814,98800,98810',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/NE',
        key: 'NE',
        name: 'NIGER',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '8001',
    },
    {
        id: 'data/NF',
        key: 'NF',
        name: 'NORFOLK ISLAND',
        fmt: '%O%n%N%n%A%n%C %S %Z',
        zip: '2899',
        zipex: '2899',
        upper: 'CS',
    },
    {
        id: 'data/NG',
        key: 'NG',
        name: 'NIGERIA',
        fmt: '%N%n%O%n%A%n%D%n%C %Z%n%S',
        zip: '\\d{6}',
        zipex: '930283,300001,931104',
        upper: 'CS',
        sub_regions: [
            {
                key: 'AB',
                name: {
                    default: 'Abia',
                },
            },
            {
                key: 'AD',
                name: {
                    default: 'Adamawa',
                },
            },
            {
                key: 'AK',
                name: {
                    default: 'Akwa Ibom',
                },
            },
            {
                key: 'AN',
                name: {
                    default: 'Anambra',
                },
            },
            {
                key: 'BA',
                name: {
                    default: 'Bauchi',
                },
            },
            {
                key: 'BY',
                name: {
                    default: 'Bayelsa',
                },
            },
            {
                key: 'BE',
                name: {
                    default: 'Benue',
                },
            },
            {
                key: 'BO',
                name: {
                    default: 'Borno',
                },
            },
            {
                key: 'CR',
                name: {
                    default: 'Cross River',
                },
            },
            {
                key: 'DE',
                name: {
                    default: 'Delta',
                },
            },
            {
                key: 'EB',
                name: {
                    default: 'Ebonyi',
                },
            },
            {
                key: 'ED',
                name: {
                    default: 'Edo',
                },
            },
            {
                key: 'EK',
                name: {
                    default: 'Ekiti',
                },
            },
            {
                key: 'EN',
                name: {
                    default: 'Enugu',
                },
            },
            {
                key: 'FC',
                name: {
                    default: 'Federal Capital Territory',
                },
            },
            {
                key: 'GO',
                name: {
                    default: 'Gombe',
                },
            },
            {
                key: 'IM',
                name: {
                    default: 'Imo',
                },
            },
            {
                key: 'JI',
                name: {
                    default: 'Jigawa',
                },
            },
            {
                key: 'KD',
                name: {
                    default: 'Kaduna',
                },
            },
            {
                key: 'KN',
                name: {
                    default: 'Kano',
                },
            },
            {
                key: 'KT',
                name: {
                    default: 'Katsina',
                },
            },
            {
                key: 'KE',
                name: {
                    default: 'Kebbi',
                },
            },
            {
                key: 'KO',
                name: {
                    default: 'Kogi',
                },
            },
            {
                key: 'KW',
                name: {
                    default: 'Kwara',
                },
            },
            {
                key: 'LA',
                name: {
                    default: 'Lagos',
                },
            },
            {
                key: 'NA',
                name: {
                    default: 'Nasarawa',
                },
            },
            {
                key: 'NI',
                name: {
                    default: 'Niger',
                },
            },
            {
                key: 'OG',
                name: {
                    default: 'Ogun State',
                },
            },
            {
                key: 'ON',
                name: {
                    default: 'Ondo',
                },
            },
            {
                key: 'OS',
                name: {
                    default: 'Osun',
                },
            },
            {
                key: 'OY',
                name: {
                    default: 'Oyo',
                },
            },
            {
                key: 'PL',
                name: {
                    default: 'Plateau',
                },
            },
            {
                key: 'RI',
                name: {
                    default: 'Rivers',
                },
            },
            {
                key: 'SO',
                name: {
                    default: 'Sokoto',
                },
            },
            {
                key: 'TA',
                name: {
                    default: 'Taraba',
                },
            },
            {
                key: 'YO',
                name: {
                    default: 'Yobe',
                },
            },
            {
                key: 'ZA',
                name: {
                    default: 'Zamfara',
                },
            },
        ],
    },
    {
        id: 'data/NI',
        key: 'NI',
        name: 'NICARAGUA',
        fmt: '%N%n%O%n%A%n%Z%n%C, %S',
        zip: '\\d{5}',
        zipex: '52000',
        upper: 'CS',
        sub_regions: [
            {
                key: 'BO',
                name: {
                    default: 'Boaco',
                },
                zip: '5[12]',
            },
            {
                key: 'CA',
                name: {
                    default: 'Carazo',
                },
                zip: '4[56]',
            },
            {
                key: 'CI',
                name: {
                    default: 'Chinandega',
                },
                zip: '2[5-7]',
            },
            {
                key: 'CO',
                name: {
                    default: 'Chontales',
                },
                zip: '5[56]',
            },
            {
                key: 'ES',
                name: {
                    default: 'Estelí',
                },
                zip: '3[12]',
            },
            {
                key: 'GR',
                name: {
                    default: 'Granada',
                },
                zip: '4[34]',
            },
            {
                key: 'JI',
                name: {
                    default: 'Jinotega',
                },
                zip: '6[56]',
            },
            {
                key: 'LE',
                name: {
                    default: 'León',
                },
                zip: '2[12]',
            },
            {
                key: 'MD',
                name: {
                    default: 'Madriz',
                },
                zip: '3[45]',
            },
            {
                key: 'MN',
                name: {
                    default: 'Managua',
                },
                zip: '1[0-6]',
            },
            {
                key: 'MS',
                name: {
                    default: 'Masaya',
                },
                zip: '4[12]',
            },
            {
                key: 'MT',
                name: {
                    default: 'Matagalpa',
                },
                zip: '6[1-3]',
            },
            {
                key: 'NS',
                name: {
                    default: 'Nueva Segovia',
                },
                zip: '3[7-9]',
            },
            {
                key: 'AN',
                name: {
                    default: 'Región Autónoma de la Costa Caribe Norte',
                },
                zip: '7[12]',
            },
            {
                key: 'AS',
                name: {
                    default: 'Región Autónoma de la Costa Caribe Sur',
                },
                zip: '8[1-3]',
            },
            {
                key: 'SJ',
                name: {
                    default: 'Río San Juan',
                },
                zip: '9[12]',
            },
            {
                key: 'RI',
                name: {
                    default: 'Rivas',
                },
                zip: '4[78]',
            },
        ],
    },
    {
        id: 'data/NL',
        key: 'NL',
        name: 'NETHERLANDS',
        fmt: '%O%n%N%n%A%n%Z %C',
        zip: '[1-9]\\d{3} ?(?:[A-RT-Z][A-Z]|S[BCE-RT-Z])',
        zipex: '1234 AB,2490 AA',
        require: 'ACZ',
    },
    {
        id: 'data/NO',
        key: 'NO',
        name: 'NORWAY',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '0025,0107,6631',
        require: 'ACZ',
    },
    {
        id: 'data/NP',
        key: 'NP',
        name: 'NEPAL',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '\\d{5}',
        zipex: '44601',
    },
    {
        id: 'data/NR',
        key: 'NR',
        name: 'NAURU CENTRAL PACIFIC',
        fmt: '%N%n%O%n%A%n%S',
        require: 'AS',
        sub_regions: [
            {
                key: '01',
                name: {
                    default: 'Aiwo District',
                },
            },
            {
                key: '02',
                name: {
                    default: 'Anabar District',
                },
            },
            {
                key: '03',
                name: {
                    default: 'Anetan District',
                },
            },
            {
                key: '04',
                name: {
                    default: 'Anibare District',
                },
            },
            {
                key: '05',
                name: {
                    default: 'Baiti District',
                },
            },
            {
                key: '06',
                name: {
                    default: 'Boe District',
                },
            },
            {
                key: '07',
                name: {
                    default: 'Buada District',
                },
            },
            {
                key: '08',
                name: {
                    default: 'Denigomodu District',
                },
            },
            {
                key: '09',
                name: {
                    default: 'Ewa District',
                },
            },
            {
                key: '10',
                name: {
                    default: 'Ijuw District',
                },
            },
            {
                key: '11',
                name: {
                    default: 'Meneng District',
                },
            },
            {
                key: '12',
                name: {
                    default: 'Nibok District',
                },
            },
            {
                key: '13',
                name: {
                    default: 'Uaboe District',
                },
            },
            {
                key: '14',
                name: {
                    default: 'Yaren District',
                },
            },
        ],
    },
    {
        id: 'data/NU',
        key: 'NU',
        name: 'NIUE',
    },
    {
        id: 'data/NZ',
        key: 'NZ',
        name: 'NEW ZEALAND',
        fmt: '%N%n%O%n%A%n%D%n%C %Z',
        zip: '\\d{4}',
        zipex: '6001,6015,6332,8252,1030',
        require: 'ACZ',
    },
    {
        id: 'data/OM',
        key: 'OM',
        name: 'OMAN',
        fmt: '%N%n%O%n%A%n%Z%n%C',
        zip: '(?:PC )?\\d{3}',
        zipex: '133,112,111',
    },
    {
        id: 'data/PA',
        key: 'PA',
        name: 'PANAMA (REP.)',
        fmt: '%N%n%O%n%A%n%C%n%S',
        upper: 'CS',
    },
    {
        id: 'data/PE',
        key: 'PE',
        name: 'PERU',
        fmt: '%N%n%O%n%A%n%C %Z%n%S',
        zip: '(?:LIMA \\d{1,2}|CALLAO 0?\\d)|[0-2]\\d{4}',
        zipex: 'LIMA 23,LIMA 42,CALLAO 2,02001',
        sub_regions: [
            {
                key: 'AMA',
                name: {
                    default: 'Amazonas',
                },
            },
            {
                key: 'ANC',
                name: {
                    default: 'Áncash',
                },
            },
            {
                key: 'APU',
                name: {
                    default: 'Apurímac',
                },
            },
            {
                key: 'ARE',
                name: {
                    default: 'Arequipa',
                },
            },
            {
                key: 'AYA',
                name: {
                    default: 'Ayacucho',
                },
            },
            {
                key: 'CAJ',
                name: {
                    default: 'Cajamarca',
                },
            },
            {
                key: 'CAL',
                name: {
                    default: 'Callao',
                },
            },
            {
                key: 'CUS',
                name: {
                    default: 'Cuzco',
                },
            },
            {
                key: 'LIM',
                name: {
                    default: 'Gobierno Regional de Lima',
                },
            },
            {
                key: 'HUV',
                name: {
                    default: 'Huancavelica',
                },
            },
            {
                key: 'HUC',
                name: {
                    default: 'Huánuco',
                },
            },
            {
                key: 'ICA',
                name: {
                    default: 'Ica',
                },
            },
            {
                key: 'JUN',
                name: {
                    default: 'Junín',
                },
            },
            {
                key: 'LAL',
                name: {
                    default: 'La Libertad',
                },
            },
            {
                key: 'LAM',
                name: {
                    default: 'Lambayeque',
                },
            },
            {
                key: 'LOR',
                name: {
                    default: 'Loreto',
                },
            },
            {
                key: 'MDD',
                name: {
                    default: 'Madre de Dios',
                },
            },
            {
                key: 'MOQ',
                name: {
                    default: 'Moquegua',
                },
            },
            {
                key: 'LMA',
                name: {
                    default: 'Municipalidad Metropolitana de Lima',
                },
            },
            {
                key: 'PAS',
                name: {
                    default: 'Pasco',
                },
            },
            {
                key: 'PIU',
                name: {
                    default: 'Piura',
                },
            },
            {
                key: 'PUN',
                name: {
                    default: 'Puno',
                },
            },
            {
                key: 'SAM',
                name: {
                    default: 'San Martín',
                },
            },
            {
                key: 'TAC',
                name: {
                    default: 'Tacna',
                },
            },
            {
                key: 'TUM',
                name: {
                    default: 'Tumbes',
                },
            },
            {
                key: 'UCA',
                name: {
                    default: 'Ucayali',
                },
            },
        ],
    },
    {
        id: 'data/PF',
        key: 'PF',
        name: 'FRENCH POLYNESIA',
        fmt: '%N%n%O%n%A%n%Z %C %S',
        zip: '987\\d{2}',
        zipex: '98709',
        upper: 'CS',
        require: 'ACSZ',
    },
    {
        id: 'data/PG',
        key: 'PG',
        name: 'PAPUA NEW GUINEA',
        fmt: '%N%n%O%n%A%n%C %Z %S',
        zip: '\\d{3}',
        zipex: '111',
        require: 'ACS',
    },
    {
        id: 'data/PH',
        key: 'PH',
        name: 'PHILIPPINES',
        fmt: '%N%n%O%n%A%n%D, %C%n%Z %S',
        zip: '\\d{4}',
        zipex: '1008,1050,1135,1207,2000,1000',
        sub_regions: [
            {
                key: 'ABR',
                name: {
                    default: 'Abra',
                },
                zip: '28[0-2]',
            },
            {
                key: 'AGN',
                name: {
                    default: 'Agusan del Norte',
                },
                zip: '86[01]',
            },
            {
                key: 'AGS',
                name: {
                    default: 'Agusan del Sur',
                },
                zip: '85[01]',
            },
            {
                key: 'AKL',
                name: {
                    default: 'Aklan',
                },
                zip: '56[01]',
            },
            {
                key: 'ALB',
                name: {
                    default: 'Albay',
                },
                zip: '45[01]',
            },
            {
                key: 'ANT',
                name: {
                    default: 'Antique',
                },
                zip: '57[01]',
            },
            {
                key: 'APA',
                name: {
                    default: 'Apayao',
                },
                zip: '380[0-68]',
            },
            {
                key: 'AUR',
                name: {
                    default: 'Aurora',
                },
                zip: '320',
            },
            {
                key: 'BAS',
                name: {
                    default: 'Basilan',
                },
                zip: '730',
            },
            {
                key: 'BAN',
                name: {
                    default: 'Bataan',
                },
                zip: '21[01]',
            },
            {
                key: 'BTN',
                name: {
                    default: 'Batanes',
                },
                zip: '390',
            },
            {
                key: 'BTG',
                name: {
                    default: 'Batangas',
                },
                zip: '42[0-3]',
            },
            {
                key: 'BEN',
                name: {
                    default: 'Benguet',
                },
                zip: '26(0|1[0-5])',
            },
            {
                key: 'BIL',
                name: {
                    default: 'Biliran',
                },
                zip: '65(4[3-9]|5)',
            },
            {
                key: 'BOH',
                name: {
                    default: 'Bohol',
                },
                zip: '63[0-3]',
            },
            {
                key: 'BUK',
                name: {
                    default: 'Bukidnon',
                },
                zip: '87[0-2]',
            },
            {
                key: 'BUL',
                name: {
                    default: 'Bulacan',
                },
                zip: '30[0-2]',
            },
            {
                key: 'CAG',
                name: {
                    default: 'Cagayan',
                },
                zip: '35[0-2]',
            },
            {
                key: 'CAN',
                name: {
                    default: 'Camarines Norte',
                },
                zip: '46[01]',
            },
            {
                key: 'CAS',
                name: {
                    default: 'Camarines Sur',
                },
                zip: '44[0-3]',
            },
            {
                key: 'CAM',
                name: {
                    default: 'Camiguin',
                },
                zip: '910',
            },
            {
                key: 'CAP',
                name: {
                    default: 'Capiz',
                },
                zip: '58[01]',
            },
            {
                key: 'CAT',
                name: {
                    default: 'Catanduanes',
                },
                zip: '48[01]',
            },
            {
                key: 'CAV',
                name: {
                    default: 'Cavite',
                },
                zip: '41[0-2]',
            },
            {
                key: 'CEB',
                name: {
                    default: 'Cebu',
                },
                zip: '60[0-5]',
            },
            {
                key: 'COM',
                name: {
                    default: 'Compostela Valley',
                },
                zip: '88[01]',
            },
            {
                key: 'NCO',
                name: {
                    default: 'Cotabato',
                },
                zip: '94[01]',
            },
            {
                key: 'DAV',
                name: {
                    default: 'Davao del Norte',
                },
                zip: '81[0-2]',
            },
            {
                key: 'DAS',
                name: {
                    default: 'Davao del Sur',
                },
                zip: '80[01]',
            },
            {
                key: 'DVO',
                name: {
                    default: 'Davao Occidental',
                },
                zip: '801[1-5]',
            },
            {
                key: 'DAO',
                name: {
                    default: 'Davao Oriental',
                },
                zip: '82[01]',
            },
            {
                key: 'DIN',
                name: {
                    default: 'Dinagat Islands',
                },
                zip: '84[12]',
            },
            {
                key: 'EAS',
                name: {
                    default: 'Eastern Samar',
                },
                zip: '68[0-2]',
            },
            {
                key: 'GUI',
                name: {
                    default: 'Guimaras',
                },
                zip: '504[4-6]',
            },
            {
                key: 'IFU',
                name: {
                    default: 'Ifugao',
                },
                zip: '36[01]',
            },
            {
                key: 'ILN',
                name: {
                    default: 'Ilocos Norte',
                },
                zip: '29[0-2]',
            },
            {
                key: 'ILS',
                name: {
                    default: 'Ilocos Sur',
                },
                zip: '27[0-3]',
            },
            {
                key: 'ILI',
                name: {
                    default: 'Iloilo',
                },
                zip: '50([0-3]|4[0-3])',
            },
            {
                key: 'ISA',
                name: {
                    default: 'Isabela',
                },
                zip: '33[0-3]',
            },
            {
                key: 'KAL',
                name: {
                    default: 'Kalinga',
                },
                zip: '38(0[79]|1[0-4])',
            },
            {
                key: 'LUN',
                name: {
                    default: 'La Union',
                },
                zip: '25[0-2]',
            },
            {
                key: 'LAG',
                name: {
                    default: 'Laguna',
                },
                zip: '40[0-3]',
            },
            {
                key: 'LAN',
                name: {
                    default: 'Lanao del Norte',
                },
                zip: '92[0-2]',
            },
            {
                key: 'LAS',
                name: {
                    default: 'Lanao del Sur',
                },
                zip: '9(3[0-2]|7[01])',
            },
            {
                key: 'LEY',
                name: {
                    default: 'Leyte',
                },
                zip: '65([0-3]|4[0-2])',
            },
            {
                key: 'MAG',
                name: {
                    default: 'Maguindanao',
                },
                zip: '96[01]',
            },
            {
                key: 'MAD',
                name: {
                    default: 'Marinduque',
                },
                zip: '490',
            },
            {
                key: 'MAS',
                name: {
                    default: 'Masbate',
                },
                zip: '54[0-2]',
            },
            {
                key: '00',
                name: {
                    default: 'Metro Manila',
                },
            },
            {
                key: 'MDC',
                name: {
                    default: 'Mindoro Occidental',
                },
                zip: '51[01]',
            },
            {
                key: 'MDR',
                name: {
                    default: 'Mindoro Oriental',
                },
                zip: '52[01]',
            },
            {
                key: 'MSC',
                name: {
                    default: 'Misamis Occidental',
                },
                zip: '72[01]',
            },
            {
                key: 'MSR',
                name: {
                    default: 'Misamis Oriental',
                },
                zip: '90[0-2]',
            },
            {
                key: 'MOU',
                name: {
                    default: 'Mountain Province',
                },
                zip: '26(1[6-9]|2[0-5])',
            },
            {
                key: 'NEC',
                name: {
                    default: 'Negros Occidental',
                },
                zip: '61[0-3]',
            },
            {
                key: 'NER',
                name: {
                    default: 'Negros Oriental',
                },
                zip: '62[0-2]',
            },
            {
                key: 'NSA',
                name: {
                    default: 'Northern Samar',
                },
                zip: '64[0-2]',
            },
            {
                key: 'NUE',
                name: {
                    default: 'Nueva Ecija',
                },
                zip: '31[0-3]',
            },
            {
                key: 'NUV',
                name: {
                    default: 'Nueva Vizcaya',
                },
                zip: '37[01]',
            },
            {
                key: 'PLW',
                name: {
                    default: 'Palawan',
                },
                zip: '53[0-2]',
            },
            {
                key: 'PAM',
                name: {
                    default: 'Pampanga',
                },
                zip: '20[0-2]',
            },
            {
                key: 'PAN',
                name: {
                    default: 'Pangasinan',
                },
                zip: '24[0-4]',
            },
            {
                key: 'QUE',
                name: {
                    default: 'Quezon Province',
                },
                zip: '43[0-4]',
            },
            {
                key: 'QUI',
                name: {
                    default: 'Quirino',
                },
                zip: '340',
            },
            {
                key: 'RIZ',
                name: {
                    default: 'Rizal',
                },
                zip: '1[89]',
            },
            {
                key: 'ROM',
                name: {
                    default: 'Romblon',
                },
                zip: '55[01]',
            },
            {
                key: 'WSA',
                name: {
                    default: 'Samar',
                },
                zip: '67[0-2]',
            },
            {
                key: 'SAR',
                name: {
                    default: 'Sarangani',
                },
                zip: '8015',
            },
            {
                key: 'SIG',
                name: {
                    default: 'Siquijor',
                },
                zip: '62(2[5-9]|30)',
            },
            {
                key: 'SOR',
                name: {
                    default: 'Sorsogon',
                },
                zip: '47[01]',
            },
            {
                key: 'SCO',
                name: {
                    default: 'South Cotabato',
                },
                zip: '95[01]',
            },
            {
                key: 'SLE',
                name: {
                    default: 'Southern Leyte',
                },
                zip: '66[10]',
            },
            {
                key: 'SUK',
                name: {
                    default: 'Sultan Kudarat',
                },
                zip: '98[01]',
            },
            {
                key: 'SLU',
                name: {
                    default: 'Sulu',
                },
                zip: '74[01]',
            },
            {
                key: 'SUN',
                name: {
                    default: 'Surigao del Norte',
                },
                zip: '84[0-2]',
            },
            {
                key: 'SUR',
                name: {
                    default: 'Surigao del Sur',
                },
                zip: '83[01]',
            },
            {
                key: 'TAR',
                name: {
                    default: 'Tarlac',
                },
                zip: '23[01]',
            },
            {
                key: 'TAW',
                name: {
                    default: 'Tawi-Tawi',
                },
                zip: '750',
            },
            {
                key: 'ZMB',
                name: {
                    default: 'Zambales',
                },
                zip: '22[01]',
            },
            {
                key: 'ZAN',
                name: {
                    default: 'Zamboanga del Norte',
                },
                zip: '71[0-2]',
            },
            {
                key: 'ZAS',
                name: {
                    default: 'Zamboanga del Sur',
                },
                zip: '70[0-4]',
            },
            {
                key: 'ZSI',
                name: {
                    default: 'Zamboanga Sibuguey',
                },
                zip: '70[0-4]',
            },
        ],
    },
    {
        id: 'data/PK',
        key: 'PK',
        name: 'PAKISTAN',
        fmt: '%N%n%O%n%A%n%D%n%C-%Z',
        zip: '\\d{5}',
        zipex: '44000',
    },
    {
        id: 'data/PL',
        key: 'PL',
        name: 'POLAND',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{2}-\\d{3}',
        zipex: '00-950,05-470,48-300,32-015,00-940',
        require: 'ACZ',
    },
    {
        id: 'data/PM',
        key: 'PM',
        name: 'ST. PIERRE AND MIQUELON',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '9[78]5\\d{2}',
        zipex: '97500',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/PN',
        key: 'PN',
        name: 'PITCAIRN',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: 'PCRN 1ZZ',
        zipex: 'PCRN 1ZZ',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/PR',
        key: 'PR',
        name: 'PUERTO RICO',
        fmt: '%N%n%O%n%A%n%C PR %Z',
        zip: '(00[679]\\d{2})(?:[ \\-](\\d{4}))?',
        zipex: '00930',
        upper: 'ACNO',
        require: 'ACZ',
    },
    {
        id: 'data/PS',
        key: 'PS',
        name: 'PALESTINIAN TERRITORY',
    },
    {
        id: 'data/PT',
        key: 'PT',
        name: 'PORTUGAL',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}-\\d{3}',
        zipex: '2725-079,1250-096,1201-950,2860-571,1208-148',
        require: 'ACZ',
    },
    {
        id: 'data/PW',
        key: 'PW',
        name: 'PALAU',
        fmt: '%N%n%O%n%A%n%C %S %Z',
        zip: '(969(?:39|40))(?:[ \\-](\\d{4}))?',
        zipex: '96940',
        upper: 'ACNOS',
        require: 'ACSZ',
    },
    {
        id: 'data/PY',
        key: 'PY',
        name: 'PARAGUAY',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '1536,1538,1209',
    },
    {
        id: 'data/QA',
        key: 'QA',
        name: 'QATAR',
        upper: 'AC',
    },
    {
        id: 'data/RE',
        key: 'RE',
        name: 'REUNION',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '9[78]4\\d{2}',
        zipex: '97400',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/RO',
        key: 'RO',
        name: 'ROMANIA',
        fmt: '%N%n%O%n%A%n%Z %S %C',
        zip: '\\d{6}',
        zipex: '060274,061357,200716',
        upper: 'AC',
        require: 'ACZ',
    },
    {
        id: 'data/RS',
        key: 'RS',
        name: 'REPUBLIC OF SERBIA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5,6}',
        zipex: '106314',
    },
    {
        id: 'data/RU',
        key: 'RU',
        name: 'RUSSIAN FEDERATION',
        fmt: '%N%n%O%n%A%n%C%n%S%n%Z',
        lfmt: '%N%n%O%n%A%n%C%n%S%n%Z',
        zip: '\\d{6}',
        zipex: '247112,103375,188300',
        upper: 'AC',
        require: 'ACSZ',
        sub_regions: [
            {
                key: 'ALT',
                name: {
                    default: 'Алтайский край',
                    latin: 'Altayskiy kray',
                },
                zip: '65[6-9]',
            },
            {
                key: 'AMU',
                name: {
                    default: 'Амурская область',
                    latin: 'Amurskaya oblast\'',
                },
                zip: '67[56]',
            },
            {
                key: 'ARK',
                name: {
                    default: 'Архангельская область',
                    latin: 'Arkhangelskaya oblast\'',
                },
                zip: '16[3-5]',
            },
            {
                key: 'AST',
                name: {
                    default: 'Астраханская область',
                    latin: 'Astrakhanskaya oblast\'',
                },
                zip: '41[4-6]',
            },
            {
                key: 'BEL',
                name: {
                    default: 'Белгородская область',
                    latin: 'Belgorodskaya oblast\'',
                },
                zip: '30[89]',
            },
            {
                key: 'BRY',
                name: {
                    default: 'Брянская область',
                    latin: 'Bryanskaya oblast\'',
                },
                zip: '24[1-3]',
            },
            {
                key: 'VLA',
                name: {
                    default: 'Владимирская область',
                    latin: 'Vladimirskaya oblast\'',
                },
                zip: '60[0-2]',
            },
            {
                key: 'VGG',
                name: {
                    default: 'Волгоградская область',
                    latin: 'Volgogradskaya oblast\'',
                },
                zip: '40[0-4]',
            },
            {
                key: 'VLG',
                name: {
                    default: 'Вологодская область',
                    latin: 'Vologodskaya oblast\'',
                },
                zip: '16[0-2]',
            },
            {
                key: 'VOR',
                name: {
                    default: 'Воронежская область',
                    latin: 'Voronezhskaya oblast\'',
                },
                zip: '39[4-7]',
            },
            {
                key: 'YEV',
                name: {
                    default: 'Еврейская автономная область',
                    latin: 'Evreyskaya avtonomnaya oblast\'',
                },
                zip: '679',
            },
            {
                key: 'ZAB',
                name: {
                    default: 'Забайкальский край',
                    latin: 'Zabaykalskiy kray',
                },
                zip: '6(?:7[2-4]|87)',
            },
            {
                key: 'IVA',
                name: {
                    default: 'Ивановская область',
                    latin: 'Ivanovskaya oblast\'',
                },
                zip: '15[3-5]',
            },
            {
                key: 'IRK',
                name: {
                    default: 'Иркутская область',
                    latin: 'Irkutskaya oblast\'',
                },
                zip: '66[4-9]',
            },
            {
                key: 'KB',
                name: {
                    default: 'Кабардино-Балкарская Республика',
                    latin: 'Kabardino-Balkarskaya Republits',
                },
                zip: '36[01]',
            },
            {
                key: 'KGD',
                name: {
                    default: 'Калининградская область',
                    latin: 'Kaliningradskaya oblast\'',
                },
                zip: '23[6-8]',
            },
            {
                key: 'KLU',
                name: {
                    default: 'Калужская область',
                    latin: 'Kaluzhskaya oblast\'',
                },
                zip: '24[89]',
            },
            {
                key: 'KAM',
                name: {
                    default: 'Камчатский край',
                    latin: 'Kamchatskiy kray',
                },
                zip: '68[348]',
            },
            {
                key: 'KC',
                name: {
                    default: 'Карачаево-Черкесская Республика',
                    latin: 'Karachaevo-Cherkesskaya Republits',
                },
                zip: '369',
            },
            {
                key: 'KEM',
                name: {
                    default: 'Кемеровская область',
                    latin: 'Kemerovskaya oblast\'',
                },
                zip: '65[0-4]',
            },
            {
                key: 'KIR',
                name: {
                    default: 'Кировская область',
                    latin: 'Kirovskaya oblast\'',
                },
                zip: '61[0-3]',
            },
            {
                key: 'KOS',
                name: {
                    default: 'Костромская область',
                    latin: 'Kostromskaya oblast\'',
                },
                zip: '15[67]',
            },
            {
                key: 'KDA',
                name: {
                    default: 'Краснодарский край',
                    latin: 'Krasnodarskiy kray',
                },
                zip: '35[0-4]',
            },
            {
                key: 'KYA',
                name: {
                    default: 'Красноярский край',
                    latin: 'Krasnoyarskiy kray',
                },
                zip: '6(?:6[0-3]|4[78])',
            },
            {
                key: 'KGN',
                name: {
                    default: 'Курганская область',
                    latin: 'Kurganskaya oblast\'',
                },
                zip: '64[01]',
            },
            {
                key: 'KRS',
                name: {
                    default: 'Курская область',
                    latin: 'Kurskaya oblast\'',
                },
                zip: '30[5-7]',
            },
            {
                key: 'LEN',
                name: {
                    default: 'Ленинградская область',
                    latin: 'Leningradskaya oblast\'',
                },
                zip: '18[78]',
            },
            {
                key: 'LIP',
                name: {
                    default: 'Липецкая область',
                    latin: 'Lipetskaya oblast\'',
                },
                zip: '39[89]',
            },
            {
                key: 'MAG',
                name: {
                    default: 'Магаданская область',
                    latin: 'Magadanskaya oblast\'',
                },
                zip: '68[56]',
            },
            {
                key: 'MOW',
                name: {
                    default: 'Москва',
                    latin: 'Moskva',
                },
                zip: '1(?:0[1-9]|1|2|3[0-5]|4[0-4])',
            },
            {
                key: 'MOS',
                name: {
                    default: 'Московская область',
                    latin: 'Moskovskaya oblast\'',
                },
                zip: '14[0-4]',
            },
            {
                key: 'MUR',
                name: {
                    default: 'Мурманская область',
                    latin: 'Murmanskaya oblast\'',
                },
                zip: '18[34]',
            },
            {
                key: 'NEN',
                name: {
                    default: 'Ненецкий автономный округ',
                    latin: 'Nenetskiy',
                },
                zip: '166',
            },
            {
                key: 'NIZ',
                name: {
                    default: 'Нижегородская область',
                    latin: 'Nizhegorodskaya oblast\'',
                },
                zip: '60[3-7]',
            },
            {
                key: 'NGR',
                name: {
                    default: 'Новгородская область',
                    latin: 'Novgorodskaya oblast\'',
                },
                zip: '17[3-5]',
            },
            {
                key: 'NVS',
                name: {
                    default: 'Новосибирская область',
                    latin: 'Novosibirskaya oblast\'',
                },
                zip: '63[0-3]',
            },
            {
                key: 'OMS',
                name: {
                    default: 'Омская область',
                    latin: 'Omskaya oblast\'',
                },
                zip: '64[4-6]',
            },
            {
                key: 'ORE',
                name: {
                    default: 'Оренбургская область',
                    latin: 'Orenburgskaya oblast\'',
                },
                zip: '46[0-2]',
            },
            {
                key: 'ORL',
                name: {
                    default: 'Орловская область',
                    latin: 'Orlovskaya oblast\'',
                },
                zip: '30[23]',
            },
            {
                key: 'PNZ',
                name: {
                    default: 'Пензенская область',
                    latin: 'Penzenskaya oblast\'',
                },
                zip: '44[0-2]',
            },
            {
                key: 'PER',
                name: {
                    default: 'Пермский край',
                    latin: 'Permskiy kray',
                },
                zip: '61[4-9]',
            },
            {
                key: 'PRI',
                name: {
                    default: 'Приморский край',
                    latin: 'Primorskiy kray',
                },
                zip: '69[0-2]',
            },
            {
                key: 'PSK',
                name: {
                    default: 'Псковская область',
                    latin: 'Pskovskaya oblast\'',
                },
                zip: '18[0-2]',
            },
            {
                key: 'AD',
                name: {
                    default: 'Республика Адыгея',
                    latin: 'Respublika Adygeya',
                },
                zip: '385',
            },
            {
                key: 'AL',
                name: {
                    default: 'Республика Алтай',
                    latin: 'Altay Republits',
                },
                zip: '649',
            },
            {
                key: 'BA',
                name: {
                    default: 'Республика Башкортостан',
                    latin: 'Bashkortostan Republits',
                },
                zip: '45[0-3]',
            },
            {
                key: 'BU',
                name: {
                    default: 'Республика Бурятия',
                    latin: 'Buryatiya Republits',
                },
                zip: '67[01]',
            },
            {
                key: 'DA',
                name: {
                    default: 'Республика Дагестан',
                    latin: 'Dagestan Republits',
                },
                zip: '36[78]',
            },
            {
                key: 'IN',
                name: {
                    default: 'Республика Ингушетия',
                    latin: 'Ingushetiya Republits',
                },
                zip: '386',
            },
            {
                key: 'KL',
                name: {
                    default: 'Республика Калмыкия',
                    latin: 'Respublika Kalmykiya',
                },
                zip: '35[89]',
            },
            {
                key: 'KR',
                name: {
                    default: 'Республика Карелия',
                    latin: 'Kareliya Republits',
                },
                zip: '18[56]',
            },
            {
                key: 'KO',
                name: {
                    default: 'Республика Коми',
                    latin: 'Komi Republits',
                },
                zip: '16[7-9]',
            },
            {
                key: 'Автономна Республіка Крим',
                name: {
                    default: 'Республика Крым',
                    latin: 'Respublika Krym',
                },
                zip: '29[5-8]',
            },
            {
                key: 'ME',
                name: {
                    default: 'Республика Марий Эл',
                    latin: 'Respublika Mariy El',
                },
                zip: '42[45]',
            },
            {
                key: 'MO',
                name: {
                    default: 'Республика Мордовия',
                    latin: 'Respublika Mordoviya',
                },
                zip: '43[01]',
            },
            {
                key: 'SA',
                name: {
                    default: 'Республика Саха (Якутия)',
                    latin: 'Sakha (Yakutiya) Republits',
                },
                zip: '67[78]',
            },
            {
                key: 'SE',
                name: {
                    default: 'Республика Северная Осетия-Алания',
                    latin: 'Respublika Severnaya Osetiya-Alaniya',
                },
                zip: '36[23]',
            },
            {
                key: 'TA',
                name: {
                    default: 'Республика Татарстан',
                    latin: 'Respublika Tatarstan',
                },
                zip: '42[0-3]',
            },
            {
                key: 'TY',
                name: {
                    default: 'Республика Тыва',
                    latin: 'Tyva Republits',
                },
                zip: '66[78]',
            },
            {
                key: 'UD',
                name: {
                    default: 'Республика Удмуртия',
                    latin: 'Udmurtskaja Respublika',
                },
                zip: '42[67]',
            },
            {
                key: 'KK',
                name: {
                    default: 'Республика Хакасия',
                    latin: 'Khakasiya Republits',
                },
                zip: '655',
            },
            {
                key: 'ROS',
                name: {
                    default: 'Ростовская область',
                    latin: 'Rostovskaya oblast\'',
                },
                zip: '34[4-7]',
            },
            {
                key: 'RYA',
                name: {
                    default: 'Рязанская область',
                    latin: 'Ryazanskaya oblast\'',
                },
                zip: '39[01]',
            },
            {
                key: 'SAM',
                name: {
                    default: 'Самарская область',
                    latin: 'Samarskaya oblast\'',
                },
                zip: '44[3-6]',
            },
            {
                key: 'SPE',
                name: {
                    default: 'Санкт-Петербург',
                    latin: 'Sankt-Peterburg',
                },
                zip: '19',
            },
            {
                key: 'SAR',
                name: {
                    default: 'Саратовская область',
                    latin: 'Saratovskaya oblast\'',
                },
                zip: '41[0-3]',
            },
            {
                key: 'SAK',
                name: {
                    default: 'Сахалинская область',
                    latin: 'Sakhalinskaya oblast\'',
                },
                zip: '69[34]',
            },
            {
                key: 'SVE',
                name: {
                    default: 'Свердловская область',
                    latin: 'Sverdlovskaya oblast\'',
                },
                zip: '62[0-4]',
            },
            {
                key: 'Севастополь',
                name: {
                    default: 'Севастополь',
                    latin: 'Sevastopol\'',
                },
                zip: '299',
            },
            {
                key: 'SMO',
                name: {
                    default: 'Смоленская область',
                    latin: 'Smolenskaya oblast\'',
                },
                zip: '21[4-6]',
            },
            {
                key: 'STA',
                name: {
                    default: 'Ставропольский край',
                    latin: 'Stavropolskiy kray',
                },
                zip: '35[5-7]',
            },
            {
                key: 'TAM',
                name: {
                    default: 'Тамбовская область',
                    latin: 'Tambovskaya oblast\'',
                },
                zip: '39[23]',
            },
            {
                key: 'TVE',
                name: {
                    default: 'Тверская область',
                    latin: 'Tverskaya oblast\'',
                },
                zip: '17[0-2]',
            },
            {
                key: 'TOM',
                name: {
                    default: 'Томская область',
                    latin: 'Tomskaya oblast\'',
                },
                zip: '63[4-6]',
            },
            {
                key: 'TUL',
                name: {
                    default: 'Тульская область',
                    latin: 'Tulskaya oblast\'',
                },
                zip: '30[01]',
            },
            {
                key: 'TYU',
                name: {
                    default: 'Тюменская область',
                    latin: 'Tyumenskaya oblast\'',
                },
                zip: '62[5-7]',
            },
            {
                key: 'ULY',
                name: {
                    default: 'Ульяновская область',
                    latin: 'Ulyanovskaya oblast\'',
                },
                zip: '43[23]',
            },
            {
                key: 'KHA',
                name: {
                    default: 'Хабаровский край',
                    latin: 'Khabarovskiy kray',
                },
                zip: '68[0-2]',
            },
            {
                key: 'KHM',
                name: {
                    default: 'Ханты-Мансийский автономный округ',
                    latin: 'Khanty-Mansiyskiy avtonomnyy okrug',
                },
                zip: '628',
            },
            {
                key: 'CHE',
                name: {
                    default: 'Челябинская область',
                    latin: 'Chelyabinskaya oblast\'',
                },
                zip: '45[4-7]',
            },
            {
                key: 'CE',
                name: {
                    default: 'Чеченская Республика',
                    latin: 'Chechenskaya Republits',
                },
                zip: '36[4-6]',
            },
            {
                key: 'CU',
                name: {
                    default: 'Чувашская Республика',
                    latin: 'Chuvashia',
                },
                zip: '42[89]',
            },
            {
                key: 'CHU',
                name: {
                    default: 'Чукотский автономный округ',
                    latin: 'Chukotskiy',
                },
                zip: '689',
            },
            {
                key: 'YAN',
                name: {
                    default: 'Ямало-Ненецкий автономный округ',
                    latin: 'Yamalo-Nenetskiy',
                },
                zip: '629',
            },
            {
                key: 'YAR',
                name: {
                    default: 'Ярославская область',
                    latin: 'Yaroslavskaya oblast\'',
                },
                zip: '15[0-2]',
            },
        ],
    },
    {
        id: 'data/RW',
        key: 'RW',
        name: 'RWANDA',
        upper: 'AC',
    },
    {
        id: 'data/SA',
        key: 'SA',
        name: 'SAUDI ARABIA',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: '\\d{5}',
        zipex: '11564,11187,11142',
    },
    {
        id: 'data/SB',
        key: 'SB',
        name: 'SOLOMON ISLANDS',
    },
    {
        id: 'data/SC',
        key: 'SC',
        name: 'SEYCHELLES',
        fmt: '%N%n%O%n%A%n%C%n%S',
        upper: 'S',
    },
    {
        id: 'data/SD',
        key: 'SD',
        name: 'SUDAN',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: '\\d{5}',
        zipex: '11042,11113',
    },
    {
        id: 'data/SE',
        key: 'SE',
        name: 'SWEDEN',
        fmt: '%O%n%N%n%A%nSE-%Z %C',
        zip: '\\d{3} ?\\d{2}',
        zipex: '11455,12345,10500',
        require: 'ACZ',
    },
    {
        id: 'data/SG',
        key: 'SG',
        name: 'REP. OF SINGAPORE',
        fmt: '%N%n%O%n%A%nSINGAPORE %Z',
        zip: '\\d{6}',
        zipex: '546080,308125,408600',
        require: 'AZ',
    },
    {
        id: 'data/SH',
        key: 'SH',
        name: 'SAINT HELENA',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: '(?:ASCN|STHL) 1ZZ',
        zipex: 'STHL 1ZZ',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/SI',
        key: 'SI',
        name: 'SLOVENIA',
        fmt: '%N%n%O%n%A%nSI-%Z %C',
        zip: '\\d{4}',
        zipex: '4000,1001,2500',
    },
    {
        id: 'data/SJ',
        key: 'SJ',
        name: 'SVALBARD AND JAN MAYEN ISLANDS',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '9170',
        require: 'ACZ',
    },
    {
        id: 'data/SK',
        key: 'SK',
        name: 'SLOVAKIA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{3} ?\\d{2}',
        zipex: '010 01,023 14,972 48,921 01,975 99',
        require: 'ACZ',
    },
    {
        id: 'data/SL',
        key: 'SL',
        name: 'SIERRA LEONE',
    },
    {
        id: 'data/SM',
        key: 'SM',
        name: 'SAN MARINO',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '4789\\d',
        zipex: '47890,47891,47895,47899',
        require: 'AZ',
    },
    {
        id: 'data/SN',
        key: 'SN',
        name: 'SENEGAL',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '12500,46024,16556,10000',
    },
    {
        id: 'data/SO',
        key: 'SO',
        name: 'SOMALIA',
        fmt: '%N%n%O%n%A%n%C, %S %Z',
        zip: '[A-Z]{2} ?\\d{5}',
        zipex: 'JH 09010,AD 11010',
        upper: 'ACS',
        require: 'ACS',
        sub_regions: [
            {
                key: 'AW',
                name: {
                    default: 'Awdal',
                },
            },
            {
                key: 'BK',
                name: {
                    default: 'Bakool',
                },
            },
            {
                key: 'BN',
                name: {
                    default: 'Banaadir',
                },
            },
            {
                key: 'BR',
                name: {
                    default: 'Bari',
                },
            },
            {
                key: 'BY',
                name: {
                    default: 'Bay',
                },
            },
            {
                key: 'GA',
                name: {
                    default: 'Galguduud',
                },
            },
            {
                key: 'GE',
                name: {
                    default: 'Gedo',
                },
            },
            {
                key: 'HI',
                name: {
                    default: 'Hiiraan',
                },
            },
            {
                key: 'JD',
                name: {
                    default: 'Jubbada Dhexe',
                },
            },
            {
                key: 'JH',
                name: {
                    default: 'Jubbada Hoose',
                },
            },
            {
                key: 'MU',
                name: {
                    default: 'Mudug',
                },
            },
            {
                key: 'NU',
                name: {
                    default: 'Nugaal',
                },
            },
            {
                key: 'SA',
                name: {
                    default: 'Sanaag',
                },
            },
            {
                key: 'SD',
                name: {
                    default: 'Shabeellaha Dhexe',
                },
            },
            {
                key: 'SH',
                name: {
                    default: 'Shabeellaha Hoose',
                },
            },
            {
                key: 'SO',
                name: {
                    default: 'Sool',
                },
            },
            {
                key: 'TO',
                name: {
                    default: 'Togdheer',
                },
            },
            {
                key: 'WO',
                name: {
                    default: 'Woqooyi Galbeed',
                },
            },
        ],
    },
    {
        id: 'data/SR',
        key: 'SR',
        name: 'SURINAME',
        fmt: '%N%n%O%n%A%n%C%n%S',
        upper: 'AS',
        sub_regions: [
            {
                key: 'BR',
                name: {
                    default: 'Brokopondo',
                },
            },
            {
                key: 'CM',
                name: {
                    default: 'Commewijne',
                },
            },
            {
                key: 'CR',
                name: {
                    default: 'Coronie',
                },
            },
            {
                key: 'MA',
                name: {
                    default: 'Marowijne',
                },
            },
            {
                key: 'NI',
                name: {
                    default: 'Nickerie',
                },
            },
            {
                key: 'PR',
                name: {
                    default: 'Para',
                },
            },
            {
                key: 'PM',
                name: {
                    default: 'Paramaribo',
                },
            },
            {
                key: 'SA',
                name: {
                    default: 'Saramacca',
                },
            },
            {
                key: 'SI',
                name: {
                    default: 'Sipaliwini',
                },
            },
            {
                key: 'WA',
                name: {
                    default: 'Wanica',
                },
            },
        ],
    },
    {
        id: 'data/SS',
        key: 'SS',
        name: 'SOUTH SUDAN',
    },
    {
        id: 'data/ST',
        key: 'ST',
        name: 'SAO TOME AND PRINCIPE',
    },
    {
        id: 'data/SV',
        key: 'SV',
        name: 'EL SALVADOR',
        fmt: '%N%n%O%n%A%n%Z-%C%n%S',
        zip: 'CP [1-3][1-7][0-2]\\d',
        zipex: 'CP 1101',
        upper: 'CSZ',
        require: 'ACS',
        sub_regions: [
            {
                key: 'AH',
                name: {
                    default: 'Ahuachapán',
                },
                zip: 'CP 21',
            },
            {
                key: 'CA',
                name: {
                    default: 'Cabañas',
                },
                zip: 'CP 12',
            },
            {
                key: 'CH',
                name: {
                    default: 'Chalatenango',
                },
                zip: 'CP 13',
            },
            {
                key: 'CU',
                name: {
                    default: 'Cuscatlán',
                },
                zip: 'CP 14',
            },
            {
                key: 'LI',
                name: {
                    default: 'La Libertad',
                },
                zip: 'CP 15',
            },
            {
                key: 'PA',
                name: {
                    default: 'La Paz',
                },
                zip: 'CP 16',
            },
            {
                key: 'UN',
                name: {
                    default: 'La Unión',
                },
                zip: 'CP 31',
            },
            {
                key: 'MO',
                name: {
                    default: 'Morazán',
                },
                zip: 'CP 32',
            },
            {
                key: 'SM',
                name: {
                    default: 'San Miguel',
                },
                zip: 'CP 33',
            },
            {
                key: 'SS',
                name: {
                    default: 'San Salvador',
                },
                zip: 'CP 11',
            },
            {
                key: 'SV',
                name: {
                    default: 'San Vicente',
                },
                zip: 'CP 17',
            },
            {
                key: 'SA',
                name: {
                    default: 'Santa Ana',
                },
                zip: 'CP 22',
            },
            {
                key: 'SO',
                name: {
                    default: 'Sonsonate',
                },
                zip: 'CP 23',
            },
            {
                key: 'US',
                name: {
                    default: 'Usulután',
                },
                zip: 'CP 34',
            },
        ],
    },
    {
        id: 'data/SX',
        key: 'SX',
        name: 'SINT MAARTEN',
    },
    {
        id: 'data/SY',
        key: 'SY',
        name: 'SYRIA',
    },
    {
        id: 'data/SZ',
        key: 'SZ',
        name: 'SWAZILAND',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: '[HLMS]\\d{3}',
        zipex: 'H100',
        upper: 'ACZ',
    },
    {
        id: 'data/TA',
        key: 'TA',
        name: 'TRISTAN DA CUNHA',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: 'TDCU 1ZZ',
        zipex: 'TDCU 1ZZ',
    },
    {
        id: 'data/TC',
        key: 'TC',
        name: 'TURKS AND CAICOS ISLANDS',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: 'TKCA 1ZZ',
        zipex: 'TKCA 1ZZ',
        upper: 'CZ',
        require: 'ACZ',
    },
    {
        id: 'data/TD',
        key: 'TD',
        name: 'CHAD',
    },
    {
        id: 'data/TF',
        key: 'TF',
        name: 'FRENCH SOUTHERN TERRITORIES',
    },
    {
        id: 'data/TG',
        key: 'TG',
        name: 'TOGO',
    },
    {
        id: 'data/TH',
        key: 'TH',
        name: 'THAILAND',
        fmt: '%N%n%O%n%A%n%D %C%n%S %Z',
        lfmt: '%N%n%O%n%A%n%D, %C%n%S %Z',
        zip: '\\d{5}',
        zipex: '10150,10210',
        upper: 'S',
        sub_regions: [
            {
                key: '81',
                name: {
                    default: 'กระบี่',
                    latin: 'Krabi',
                },
                zip: '81',
            },
            {
                key: '10',
                name: {
                    default: 'กรุงเทพมหานคร',
                    latin: 'Bangkok',
                },
                zip: '10',
            },
            {
                key: '71',
                name: {
                    default: 'กาญจนบุรี',
                    latin: 'Kanchanaburi',
                },
                zip: '71',
            },
            {
                key: '46',
                name: {
                    default: 'กาฬสินธุ์',
                    latin: 'Kalasin',
                },
                zip: '46',
            },
            {
                key: '62',
                name: {
                    default: 'กำแพงเพชร',
                    latin: 'Kamphaeng Phet',
                },
                zip: '62',
            },
            {
                key: '40',
                name: {
                    default: 'ขอนแก่น',
                    latin: 'Khon Kaen',
                },
                zip: '40',
            },
            {
                key: '38',
                name: {
                    default: 'จังหวัด บึงกาฬ',
                    latin: 'Bueng Kan',
                },
            },
            {
                key: '22',
                name: {
                    default: 'จันทบุรี',
                    latin: 'Chanthaburi',
                },
                zip: '22',
            },
            {
                key: '24',
                name: {
                    default: 'ฉะเชิงเทรา',
                    latin: 'Chachoengsao',
                },
                zip: '24',
            },
            {
                key: '20',
                name: {
                    default: 'ชลบุรี',
                    latin: 'Chon Buri',
                },
                zip: '20',
            },
            {
                key: '18',
                name: {
                    default: 'ชัยนาท',
                    latin: 'Chai Nat',
                },
                zip: '17',
            },
            {
                key: '36',
                name: {
                    default: 'ชัยภูมิ',
                    latin: 'Chaiyaphum',
                },
                zip: '36',
            },
            {
                key: '86',
                name: {
                    default: 'ชุมพร',
                    latin: 'Chumpon',
                },
                zip: '86',
            },
            {
                key: '57',
                name: {
                    default: 'เชียงราย',
                    latin: 'Chiang Rai',
                },
                zip: '57',
            },
            {
                key: '50',
                name: {
                    default: 'เชียงใหม่',
                    latin: 'Chiang Mai',
                },
                zip: '50',
            },
            {
                key: '92',
                name: {
                    default: 'ตรัง',
                    latin: 'Trang',
                },
                zip: '92',
            },
            {
                key: '23',
                name: {
                    default: 'ตราด',
                    latin: 'Trat',
                },
                zip: '23',
            },
            {
                key: '63',
                name: {
                    default: 'ตาก',
                    latin: 'Tak',
                },
                zip: '63',
            },
            {
                key: '26',
                name: {
                    default: 'นครนายก',
                    latin: 'Nakhon Nayok',
                },
                zip: '26',
            },
            {
                key: '73',
                name: {
                    default: 'นครปฐม',
                    latin: 'Nakhon Pathom',
                },
                zip: '73',
            },
            {
                key: '48',
                name: {
                    default: 'นครพนม',
                    latin: 'Nakhon Phanom',
                },
                zip: '48',
            },
            {
                key: '30',
                name: {
                    default: 'นครราชสีมา',
                    latin: 'Nakhon Ratchasima',
                },
                zip: '30',
            },
            {
                key: '80',
                name: {
                    default: 'นครศรีธรรมราช',
                    latin: 'Nakhon Si Thammarat',
                },
                zip: '80',
            },
            {
                key: '60',
                name: {
                    default: 'นครสวรรค์',
                    latin: 'Nakhon Sawan',
                },
                zip: '60',
            },
            {
                key: '12',
                name: {
                    default: 'นนทบุรี',
                    latin: 'Nonthaburi',
                },
                zip: '11',
            },
            {
                key: '96',
                name: {
                    default: 'นราธิวาส',
                    latin: 'Narathiwat',
                },
                zip: '96',
            },
            {
                key: '55',
                name: {
                    default: 'น่าน',
                    latin: 'Nan',
                },
                zip: '55',
            },
            {
                key: '31',
                name: {
                    default: 'บุรีรัมย์',
                    latin: 'Buri Ram',
                },
                zip: '31',
            },
            {
                key: '13',
                name: {
                    default: 'ปทุมธานี',
                    latin: 'Pathum Thani',
                },
                zip: '12',
            },
            {
                key: '77',
                name: {
                    default: 'ประจวบคีรีขันธ์',
                    latin: 'Prachuap Khiri Khan',
                },
                zip: '77',
            },
            {
                key: '25',
                name: {
                    default: 'ปราจีนบุรี',
                    latin: 'Prachin Buri',
                },
                zip: '25',
            },
            {
                key: '94',
                name: {
                    default: 'ปัตตานี',
                    latin: 'Pattani',
                },
                zip: '94',
            },
            {
                key: '14',
                name: {
                    default: 'พระนครศรีอยุธยา',
                    latin: 'Phra Nakhon Si Ayutthaya',
                },
                zip: '13',
            },
            {
                key: '56',
                name: {
                    default: 'พะเยา',
                    latin: 'Phayao',
                },
                zip: '56',
            },
            {
                key: '82',
                name: {
                    default: 'พังงา',
                    latin: 'Phang Nga',
                },
                zip: '82',
            },
            {
                key: '93',
                name: {
                    default: 'พัทลุง',
                    latin: 'Phattalung',
                },
                zip: '93',
            },
            {
                key: '66',
                name: {
                    default: 'พิจิตร',
                    latin: 'Phichit',
                },
                zip: '66',
            },
            {
                key: '65',
                name: {
                    default: 'พิษณุโลก',
                    latin: 'Phitsanulok',
                },
                zip: '65',
            },
            {
                key: '76',
                name: {
                    default: 'เพชรบุรี',
                    latin: 'Phetchaburi',
                },
                zip: '76',
            },
            {
                key: '67',
                name: {
                    default: 'เพชรบูรณ์',
                    latin: 'Phetchabun',
                },
                zip: '67',
            },
            {
                key: '54',
                name: {
                    default: 'แพร่',
                    latin: 'Phrae',
                },
                zip: '54',
            },
            {
                key: '83',
                name: {
                    default: 'ภูเก็ต',
                    latin: 'Phuket',
                },
                zip: '83',
            },
            {
                key: '44',
                name: {
                    default: 'มหาสารคาม',
                    latin: 'Maha Sarakham',
                },
                zip: '44',
            },
            {
                key: '49',
                name: {
                    default: 'มุกดาหาร',
                    latin: 'Mukdahan',
                },
                zip: '49',
            },
            {
                key: '58',
                name: {
                    default: 'แม่ฮ่องสอน',
                    latin: 'Mae Hong Son',
                },
                zip: '58',
            },
            {
                key: '35',
                name: {
                    default: 'ยโสธร',
                    latin: 'Yasothon',
                },
                zip: '35',
            },
            {
                key: '95',
                name: {
                    default: 'ยะลา',
                    latin: 'Yala',
                },
                zip: '95',
            },
            {
                key: '45',
                name: {
                    default: 'ร้อยเอ็ด',
                    latin: 'Roi Et',
                },
                zip: '45',
            },
            {
                key: '85',
                name: {
                    default: 'ระนอง',
                    latin: 'Ranong',
                },
                zip: '85',
            },
            {
                key: '21',
                name: {
                    default: 'ระยอง',
                    latin: 'Rayong',
                },
                zip: '21',
            },
            {
                key: '70',
                name: {
                    default: 'ราชบุรี',
                    latin: 'Ratchaburi',
                },
                zip: '70',
            },
            {
                key: '16',
                name: {
                    default: 'ลพบุรี',
                    latin: 'Lop Buri',
                },
                zip: '15',
            },
            {
                key: '52',
                name: {
                    default: 'ลำปาง',
                    latin: 'Lampang',
                },
                zip: '52',
            },
            {
                key: '51',
                name: {
                    default: 'ลำพูน',
                    latin: 'Lamphun',
                },
                zip: '51',
            },
            {
                key: '42',
                name: {
                    default: 'เลย',
                    latin: 'Loei',
                },
                zip: '42',
            },
            {
                key: '33',
                name: {
                    default: 'ศรีสะเกษ',
                    latin: 'Si Sa Ket',
                },
                zip: '33',
            },
            {
                key: '47',
                name: {
                    default: 'สกลนคร',
                    latin: 'Sakon Nakhon',
                },
                zip: '47',
            },
            {
                key: '90',
                name: {
                    default: 'สงขลา',
                    latin: 'Songkhla',
                },
                zip: '90',
            },
            {
                key: '91',
                name: {
                    default: 'สตูล',
                    latin: 'Satun',
                },
                zip: '91',
            },
            {
                key: '11',
                name: {
                    default: 'สมุทรปราการ',
                    latin: 'Samut Prakan',
                },
                zip: '10',
            },
            {
                key: '75',
                name: {
                    default: 'สมุทรสงคราม',
                    latin: 'Samut Songkhram',
                },
                zip: '75',
            },
            {
                key: '74',
                name: {
                    default: 'สมุทรสาคร',
                    latin: 'Samut Sakhon',
                },
                zip: '74',
            },
            {
                key: '27',
                name: {
                    default: 'สระแก้ว',
                    latin: 'Sa Kaeo',
                },
                zip: '27',
            },
            {
                key: '19',
                name: {
                    default: 'สระบุรี',
                    latin: 'Saraburi',
                },
                zip: '18',
            },
            {
                key: '17',
                name: {
                    default: 'สิงห์บุรี',
                    latin: 'Sing Buri',
                },
                zip: '16',
            },
            {
                key: '64',
                name: {
                    default: 'สุโขทัย',
                    latin: 'Sukhothai',
                },
                zip: '64',
            },
            {
                key: '72',
                name: {
                    default: 'สุพรรณบุรี',
                    latin: 'Suphanburi',
                },
                zip: '72',
            },
            {
                key: '84',
                name: {
                    default: 'สุราษฎร์ธานี',
                    latin: 'Surat Thani',
                },
                zip: '84',
            },
            {
                key: '32',
                name: {
                    default: 'สุรินทร์',
                    latin: 'Surin',
                },
                zip: '32',
            },
            {
                key: '43',
                name: {
                    default: 'หนองคาย',
                    latin: 'Nong Khai',
                },
                zip: '43',
            },
            {
                key: '39',
                name: {
                    default: 'หนองบัวลำภู',
                    latin: 'Nong Bua Lam Phu',
                },
                zip: '39',
            },
            {
                key: '15',
                name: {
                    default: 'อ่างทอง',
                    latin: 'Ang Thong',
                },
                zip: '14',
            },
            {
                key: '37',
                name: {
                    default: 'อำนาจเจริญ',
                    latin: 'Amnat Charoen',
                },
                zip: '37',
            },
            {
                key: '41',
                name: {
                    default: 'อุดรธานี',
                    latin: 'Udon Thani',
                },
                zip: '41',
            },
            {
                key: '53',
                name: {
                    default: 'อุตรดิตถ์',
                    latin: 'Uttaradit',
                },
                zip: '53',
            },
            {
                key: '61',
                name: {
                    default: 'อุทัยธานี',
                    latin: 'Uthai Thani',
                },
                zip: '61',
            },
            {
                key: '34',
                name: {
                    default: 'อุบลราชธานี',
                    latin: 'Ubon Ratchathani',
                },
                zip: '34',
            },
        ],
    },
    {
        id: 'data/TJ',
        key: 'TJ',
        name: 'TAJIKISTAN',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{6}',
        zipex: '735450,734025',
    },
    {
        id: 'data/TK',
        key: 'TK',
        name: 'TOKELAU',
    },
    {
        id: 'data/TL',
        key: 'TL',
        name: 'TIMOR-LESTE',
    },
    {
        id: 'data/TM',
        key: 'TM',
        name: 'TURKMENISTAN',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{6}',
        zipex: '744000',
    },
    {
        id: 'data/TN',
        key: 'TN',
        name: 'TUNISIA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4}',
        zipex: '1002,8129,3100,1030',
    },
    {
        id: 'data/TO',
        key: 'TO',
        name: 'TONGA',
    },
    {
        id: 'data/TR',
        key: 'TR',
        name: 'TURKEY',
        fmt: '%N%n%O%n%A%n%Z %C/%S',
        zip: '\\d{5}',
        zipex: '01960,06101',
        require: 'ACZ',
        sub_regions: [
            {
                key: '01',
                name: {
                    default: 'Adana',
                },
                zip: '01',
            },
            {
                key: '02',
                name: {
                    default: 'Adıyaman',
                },
                zip: '02',
            },
            {
                key: '03',
                name: {
                    default: 'Afyon',
                },
                zip: '03',
            },
            {
                key: '04',
                name: {
                    default: 'Ağrı',
                },
                zip: '04',
            },
            {
                key: '68',
                name: {
                    default: 'Aksaray',
                },
                zip: '68',
            },
            {
                key: '05',
                name: {
                    default: 'Amasya',
                },
                zip: '05',
            },
            {
                key: '06',
                name: {
                    default: 'Ankara',
                },
                zip: '06',
            },
            {
                key: '07',
                name: {
                    default: 'Antalya',
                },
                zip: '07',
            },
            {
                key: '75',
                name: {
                    default: 'Ardahan',
                },
                zip: '75',
            },
            {
                key: '08',
                name: {
                    default: 'Artvin',
                },
                zip: '08',
            },
            {
                key: '09',
                name: {
                    default: 'Aydın',
                },
                zip: '09',
            },
            {
                key: '10',
                name: {
                    default: 'Balıkesir',
                },
                zip: '10',
            },
            {
                key: '74',
                name: {
                    default: 'Bartın',
                },
                zip: '74',
            },
            {
                key: '72',
                name: {
                    default: 'Batman',
                },
                zip: '72',
            },
            {
                key: '69',
                name: {
                    default: 'Bayburt',
                },
                zip: '69',
            },
            {
                key: '11',
                name: {
                    default: 'Bilecik',
                },
                zip: '11',
            },
            {
                key: '12',
                name: {
                    default: 'Bingöl',
                },
                zip: '12',
            },
            {
                key: '13',
                name: {
                    default: 'Bitlis',
                },
                zip: '13',
            },
            {
                key: '14',
                name: {
                    default: 'Bolu',
                },
                zip: '14',
            },
            {
                key: '15',
                name: {
                    default: 'Burdur',
                },
                zip: '15',
            },
            {
                key: '16',
                name: {
                    default: 'Bursa',
                },
                zip: '16',
            },
            {
                key: '17',
                name: {
                    default: 'Çanakkale',
                },
                zip: '17',
            },
            {
                key: '18',
                name: {
                    default: 'Çankırı',
                },
                zip: '18',
            },
            {
                key: '19',
                name: {
                    default: 'Çorum',
                },
                zip: '19',
            },
            {
                key: '20',
                name: {
                    default: 'Denizli',
                },
                zip: '20',
            },
            {
                key: '21',
                name: {
                    default: 'Diyarbakır',
                },
                zip: '21',
            },
            {
                key: '81',
                name: {
                    default: 'Düzce',
                },
                zip: '81',
            },
            {
                key: '22',
                name: {
                    default: 'Edirne',
                },
                zip: '22',
            },
            {
                key: '23',
                name: {
                    default: 'Elazığ',
                },
                zip: '23',
            },
            {
                key: '24',
                name: {
                    default: 'Erzincan',
                },
                zip: '24',
            },
            {
                key: '25',
                name: {
                    default: 'Erzurum',
                },
                zip: '25',
            },
            {
                key: '26',
                name: {
                    default: 'Eskişehir',
                },
                zip: '26',
            },
            {
                key: '27',
                name: {
                    default: 'Gaziantep',
                },
                zip: '27',
            },
            {
                key: '28',
                name: {
                    default: 'Giresun',
                },
                zip: '28',
            },
            {
                key: '29',
                name: {
                    default: 'Gümüşhane',
                },
                zip: '29',
            },
            {
                key: '30',
                name: {
                    default: 'Hakkari',
                },
                zip: '30',
            },
            {
                key: '31',
                name: {
                    default: 'Hatay',
                },
                zip: '31',
            },
            {
                key: '76',
                name: {
                    default: 'Iğdır',
                },
                zip: '76',
            },
            {
                key: '32',
                name: {
                    default: 'Isparta',
                },
                zip: '32',
            },
            {
                key: '34',
                name: {
                    default: 'İstanbul',
                },
                zip: '34',
            },
            {
                key: '35',
                name: {
                    default: 'İzmir',
                },
                zip: '35',
            },
            {
                key: '46',
                name: {
                    default: 'Kahramanmaraş',
                },
                zip: '46',
            },
            {
                key: '78',
                name: {
                    default: 'Karabük',
                },
                zip: '78',
            },
            {
                key: '70',
                name: {
                    default: 'Karaman',
                },
                zip: '70',
            },
            {
                key: '36',
                name: {
                    default: 'Kars',
                },
                zip: '36',
            },
            {
                key: '37',
                name: {
                    default: 'Kastamonu',
                },
                zip: '37',
            },
            {
                key: '38',
                name: {
                    default: 'Kayseri',
                },
                zip: '38',
            },
            {
                key: '71',
                name: {
                    default: 'Kırıkkale',
                },
                zip: '71',
            },
            {
                key: '39',
                name: {
                    default: 'Kırklareli',
                },
                zip: '39',
            },
            {
                key: '40',
                name: {
                    default: 'Kırşehir',
                },
                zip: '40',
            },
            {
                key: '79',
                name: {
                    default: 'Kilis',
                },
                zip: '79',
            },
            {
                key: '41',
                name: {
                    default: 'Kocaeli',
                },
                zip: '41',
            },
            {
                key: '42',
                name: {
                    default: 'Konya',
                },
                zip: '42',
            },
            {
                key: '43',
                name: {
                    default: 'Kütahya',
                },
                zip: '43',
            },
            {
                key: '44',
                name: {
                    default: 'Malatya',
                },
                zip: '44',
            },
            {
                key: '45',
                name: {
                    default: 'Manisa',
                },
                zip: '45',
            },
            {
                key: '47',
                name: {
                    default: 'Mardin',
                },
                zip: '47',
            },
            {
                key: '33',
                name: {
                    default: 'Mersin',
                },
                zip: '33',
            },
            {
                key: '48',
                name: {
                    default: 'Muğla',
                },
                zip: '48',
            },
            {
                key: '49',
                name: {
                    default: 'Muş',
                },
                zip: '49',
            },
            {
                key: '50',
                name: {
                    default: 'Nevşehir',
                },
                zip: '50',
            },
            {
                key: '51',
                name: {
                    default: 'Niğde',
                },
                zip: '51',
            },
            {
                key: '52',
                name: {
                    default: 'Ordu',
                },
                zip: '52',
            },
            {
                key: '80',
                name: {
                    default: 'Osmaniye',
                },
                zip: '80',
            },
            {
                key: '53',
                name: {
                    default: 'Rize',
                },
                zip: '53',
            },
            {
                key: '54',
                name: {
                    default: 'Sakarya',
                },
                zip: '54',
            },
            {
                key: '55',
                name: {
                    default: 'Samsun',
                },
                zip: '55',
            },
            {
                key: '56',
                name: {
                    default: 'Siirt',
                },
                zip: '56',
            },
            {
                key: '57',
                name: {
                    default: 'Sinop',
                },
                zip: '57',
            },
            {
                key: '58',
                name: {
                    default: 'Sivas',
                },
                zip: '58',
            },
            {
                key: '63',
                name: {
                    default: 'Şanlıurfa',
                },
                zip: '63',
            },
            {
                key: '73',
                name: {
                    default: 'Şırnak',
                },
                zip: '73',
            },
            {
                key: '59',
                name: {
                    default: 'Tekirdağ',
                },
                zip: '59',
            },
            {
                key: '60',
                name: {
                    default: 'Tokat',
                },
                zip: '60',
            },
            {
                key: '61',
                name: {
                    default: 'Trabzon',
                },
                zip: '61',
            },
            {
                key: '62',
                name: {
                    default: 'Tunceli',
                },
                zip: '62',
            },
            {
                key: '64',
                name: {
                    default: 'Uşak',
                },
                zip: '64',
            },
            {
                key: '65',
                name: {
                    default: 'Van',
                },
                zip: '65',
            },
            {
                key: '77',
                name: {
                    default: 'Yalova',
                },
                zip: '77',
            },
            {
                key: '66',
                name: {
                    default: 'Yozgat',
                },
                zip: '66',
            },
            {
                key: '67',
                name: {
                    default: 'Zonguldak',
                },
                zip: '67',
            },
        ],
    },
    {
        id: 'data/TT',
        key: 'TT',
        name: 'TRINIDAD AND TOBAGO',
    },
    {
        id: 'data/TV',
        key: 'TV',
        name: 'TUVALU',
        fmt: '%N%n%O%n%A%n%C%n%S',
        upper: 'ACS',
        sub_regions: [
            {
                key: 'FUN',
                name: {
                    default: 'Funafuti',
                },
            },
            {
                key: 'NMG',
                name: {
                    default: 'Nanumanga',
                },
            },
            {
                key: 'NMA',
                name: {
                    default: 'Nanumea',
                },
            },
            {
                key: 'Niulakita',
                name: {
                    default: 'Niulakita',
                },
            },
            {
                key: 'NIT',
                name: {
                    default: 'Niutao',
                },
            },
            {
                key: 'NUI',
                name: {
                    default: 'Nui',
                },
            },
            {
                key: 'NKF',
                name: {
                    default: 'Nukufetau',
                },
            },
            {
                key: 'NKL',
                name: {
                    default: 'Nukulaelae',
                },
            },
            {
                key: 'VAI',
                name: {
                    default: 'Vaitupu',
                },
            },
        ],
    },
    {
        id: 'data/TW',
        key: 'TW',
        name: 'TAIWAN',
        fmt: '%Z%n%S%C%n%A%n%O%n%N',
        lfmt: '%N%n%O%n%A%n%C, %S %Z',
        zip: '\\d{3}(?:\\d{2,3})?',
        zipex: '104,106,10603,40867',
        require: 'ACSZ',
        sub_regions: [
            {
                key: 'TXG',
                name: {
                    default: '台中市',
                    latin: 'Taichung City',
                },
                zip: '4[0-3]',
            },
            {
                key: 'TPE',
                name: {
                    default: '台北市',
                    latin: 'Taipei City',
                },
                zip: '1[01]',
            },
            {
                key: 'TTT',
                name: {
                    default: '台東縣',
                    latin: 'Taitung County',
                },
                zip: '9[56]',
            },
            {
                key: 'TNN',
                name: {
                    default: '台南市',
                    latin: 'Tainan City',
                },
                zip: '7[0-4]',
            },
            {
                key: 'ILA',
                name: {
                    default: '宜蘭縣',
                    latin: 'Yilan County',
                },
                zip: '2[67]',
            },
            {
                key: 'HUA',
                name: {
                    default: '花蓮縣',
                    latin: 'Hualien County',
                },
                zip: '9[78]',
            },
            {
                key: '金門縣',
                name: {
                    default: '金門縣',
                    latin: 'Kinmen County',
                },
                zip: '89',
            },
            {
                key: 'NAN',
                name: {
                    default: '南投縣',
                    latin: 'Nantou County',
                },
                zip: '5[45]',
            },
            {
                key: 'PIF',
                name: {
                    default: '屏東縣',
                    latin: 'Pingtung County',
                },
                zip: '9[0-4]',
            },
            {
                key: 'MIA',
                name: {
                    default: '苗栗縣',
                    latin: 'Miaoli County',
                },
                zip: '3[56]',
            },
            {
                key: 'TAO',
                name: {
                    default: '桃園市',
                    latin: 'Taoyuan City',
                },
                zip: '3[23]',
            },
            {
                key: 'KHH',
                name: {
                    default: '高雄市',
                    latin: 'Kaohsiung City',
                },
                zip: '8[02-5]|81[1-579]',
            },
            {
                key: 'KEE',
                name: {
                    default: '基隆市',
                    latin: 'Keelung City',
                },
                zip: '20[0-6]',
            },
            {
                key: '連江縣',
                name: {
                    default: '連江縣',
                    latin: 'Lienchiang County',
                },
                zip: '209|21[012]',
            },
            {
                key: 'YUN',
                name: {
                    default: '雲林縣',
                    latin: 'Yunlin County',
                },
                zip: '6[3-5]',
            },
            {
                key: 'NWT',
                name: {
                    default: '新北市',
                    latin: 'New Taipei City',
                },
                zip: '20[78]|2[2345]',
            },
            {
                key: 'HSZ',
                name: {
                    default: '新竹市',
                    latin: 'Hsinchu City',
                },
                zip: '300',
            },
            {
                key: 'HSQ',
                name: {
                    default: '新竹縣',
                    latin: 'Hsinchu County',
                },
                zip: '30[2-8]|31',
            },
            {
                key: 'CYI',
                name: {
                    default: '嘉義市',
                    latin: 'Chiayi City',
                },
                zip: '600',
            },
            {
                key: 'CYQ',
                name: {
                    default: '嘉義縣',
                    latin: 'Chiayi County',
                },
                zip: '60[1-9]|6[12]',
            },
            {
                key: 'CHA',
                name: {
                    default: '彰化縣',
                    latin: 'Changhua County',
                },
                zip: '5[0123]',
            },
            {
                key: 'PEN',
                name: {
                    default: '澎湖縣',
                    latin: 'Penghu County',
                },
                zip: '88',
            },
        ],
    },
    {
        id: 'data/TZ',
        key: 'TZ',
        name: 'TANZANIA (UNITED REP.)',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{4,5}',
        zipex: '6090,34413',
    },
    {
        id: 'data/UA',
        key: 'UA',
        name: 'UKRAINE',
        fmt: '%N%n%O%n%A%n%C%n%S%n%Z',
        lfmt: '%N%n%O%n%A%n%C%n%S%n%Z',
        zip: '\\d{5}',
        zipex: '15432,01055,01001',
        require: 'ACZ',
        sub_regions: [
            {
                key: '43',
                name: {
                    default: 'Автономна Республіка Крим',
                    latin: 'Crimea',
                },
                zip: '9[5-8]',
            },
            {
                key: '05',
                name: {
                    default: 'Вінницька область',
                    latin: 'Vinnyts\'ka oblast',
                },
                zip: '2[1-4]',
            },
            {
                key: '07',
                name: {
                    default: 'Волинська область',
                    latin: 'Volyns\'ka oblast',
                },
                zip: '4[3-5]',
            },
            {
                key: '12',
                name: {
                    default: 'Дніпропетровська область',
                    latin: 'Dnipropetrovsk oblast',
                },
                zip: '49|5[0-3]',
            },
            {
                key: '14',
                name: {
                    default: 'Донецька область',
                    latin: 'Donetsk oblast',
                },
                zip: '8[3-7]',
            },
            {
                key: '18',
                name: {
                    default: 'Житомирська область',
                    latin: 'Zhytomyrs\'ka oblast',
                },
                zip: '1[0-3]',
            },
            {
                key: '21',
                name: {
                    default: 'Закарпатська область',
                    latin: 'Zakarpats\'ka oblast',
                },
                zip: '8[89]|90',
            },
            {
                key: '23',
                name: {
                    default: 'Запорізька область',
                    latin: 'Zaporiz\'ka oblast',
                },
                zip: '69|7[0-2]',
            },
            {
                key: '26',
                name: {
                    default: 'Івано-Франківська область',
                    latin: 'Ivano-Frankivs\'ka oblast',
                },
                zip: '7[6-8]',
            },
            {
                key: '30',
                name: {
                    default: 'Київ',
                    latin: 'Kyiv city',
                },
                zip: '0[1-6]',
            },
            {
                key: '32',
                name: {
                    default: 'Київська область',
                    latin: 'Kiev oblast',
                },
                zip: '0[7-9]',
            },
            {
                key: '35',
                name: {
                    default: 'Кіровоградська область',
                    latin: 'Kirovohrads\'ka oblast',
                },
                zip: '2[5-8]',
            },
            {
                key: '09',
                name: {
                    default: 'Луганська область',
                    latin: 'Luhans\'ka oblast',
                },
                zip: '9[1-4]',
            },
            {
                key: '46',
                name: {
                    default: 'Львівська область',
                    latin: 'Lviv oblast',
                },
                zip: '79|8[0-2]',
            },
            {
                key: '48',
                name: {
                    default: 'Миколаївська область',
                    latin: 'Mykolaivs\'ka oblast',
                },
                zip: '5[4-7]',
            },
            {
                key: '51',
                name: {
                    default: 'Одеська область',
                    latin: 'Odessa oblast',
                },
                zip: '6[5-8]',
            },
            {
                key: '53',
                name: {
                    default: 'Полтавська область',
                    latin: 'Poltavs\'ka oblast',
                },
                zip: '3[6-9]',
            },
            {
                key: '56',
                name: {
                    default: 'Рівненська область',
                    latin: 'Rivnens\'ka oblast',
                },
                zip: '3[3-5]',
            },
            {
                key: '40',
                name: {
                    default: 'Севастополь',
                    latin: 'Sevastopol\' city',
                },
                zip: '99',
            },
            {
                key: '59',
                name: {
                    default: 'Сумська область',
                    latin: 'Sums\'ka oblast',
                },
                zip: '4[0-2]',
            },
            {
                key: '61',
                name: {
                    default: 'Тернопільська область',
                    latin: 'Ternopil\'s\'ka oblast',
                },
                zip: '4[6-8]',
            },
            {
                key: '63',
                name: {
                    default: 'Харківська область',
                    latin: 'Kharkiv oblast',
                },
                zip: '6[1-4]',
            },
            {
                key: '65',
                name: {
                    default: 'Херсонська область',
                    latin: 'Khersons\'ka oblast',
                },
                zip: '7[3-5]',
            },
            {
                key: '68',
                name: {
                    default: 'Хмельницька область',
                    latin: 'Khmel\'nyts\'ka oblast',
                },
                zip: '29|3[0-2]',
            },
            {
                key: '71',
                name: {
                    default: 'Черкаська область',
                    latin: 'Cherkas\'ka oblast',
                },
                zip: '1[89]|20',
            },
            {
                key: '77',
                name: {
                    default: 'Чернівецька область',
                    latin: 'Chernivets\'ka oblast',
                },
                zip: '5[89]|60',
            },
            {
                key: '74',
                name: {
                    default: 'Чернігівська область',
                    latin: 'Chernihivs\'ka oblast',
                },
                zip: '1[4-7]',
            },
        ],
    },
    {
        id: 'data/UG',
        key: 'UG',
        name: 'UGANDA',
    },
    {
        id: 'data/UM',
        key: 'UM',
        name: 'UNITED STATES MINOR OUTLYING ISLANDS',
        fmt: '%N%n%O%n%A%n%C %S %Z',
        zip: '96898',
        zipex: '96898',
        upper: 'ACNOS',
        require: 'ACS',
    },
    {
        id: 'data/US',
        key: 'US',
        name: 'UNITED STATES',
        fmt: '%N%n%O%n%A%n%C, %S %Z',
        zip: '(\\d{5})(?:[ \\-](\\d{4}))?',
        zipex: '95014,22162-1010',
        upper: 'CS',
        require: 'ACSZ',
        sub_regions: [
            {
                key: 'AL',
                name: {
                    default: 'Alabama',
                },
                zip: '3[56]',
            },
            {
                key: 'AK',
                name: {
                    default: 'Alaska',
                },
                zip: '99[5-9]',
            },
            {
                key: 'AS',
                name: {
                    default: 'American Samoa',
                },
                zip: '96799',
            },
            {
                key: 'AZ',
                name: {
                    default: 'Arizona',
                },
                zip: '8[56]',
            },
            {
                key: 'AR',
                name: {
                    default: 'Arkansas',
                },
                zip: '71[6-9]|72',
            },
            {
                key: 'AA',
                name: {
                    default: 'Armed Forces (AA)',
                },
                zip: '340',
            },
            {
                key: 'AE',
                name: {
                    default: 'Armed Forces (AE)',
                },
                zip: '09',
            },
            {
                key: 'AP',
                name: {
                    default: 'Armed Forces (AP)',
                },
                zip: '96[2-6]',
            },
            {
                key: 'CA',
                name: {
                    default: 'California',
                },
                zip: '9[0-5]|96[01]',
            },
            {
                key: 'CO',
                name: {
                    default: 'Colorado',
                },
                zip: '8[01]',
            },
            {
                key: 'CT',
                name: {
                    default: 'Connecticut',
                },
                zip: '06',
            },
            {
                key: 'DE',
                name: {
                    default: 'Delaware',
                },
                zip: '19[7-9]',
            },
            {
                key: 'DC',
                name: {
                    default: 'District of Columbia',
                },
                zip: '20[02-5]|569',
            },
            {
                key: 'FL',
                name: {
                    default: 'Florida',
                },
                zip: '3[23]|34[1-9]',
            },
            {
                key: 'GA',
                name: {
                    default: 'Georgia',
                },
                zip: '3[01]|398|39901',
            },
            {
                key: 'GU',
                name: {
                    default: 'Guam',
                },
                zip: '969([1-2]\\d|3[12])',
            },
            {
                key: 'HI',
                name: {
                    default: 'Hawaii',
                },
                zip: '967[0-8]|9679[0-8]|968',
            },
            {
                key: 'ID',
                name: {
                    default: 'Idaho',
                },
                zip: '83[2-9]',
            },
            {
                key: 'IL',
                name: {
                    default: 'Illinois',
                },
                zip: '6[0-2]',
            },
            {
                key: 'IN',
                name: {
                    default: 'Indiana',
                },
                zip: '4[67]',
            },
            {
                key: 'IA',
                name: {
                    default: 'Iowa',
                },
                zip: '5[0-2]',
            },
            {
                key: 'KS',
                name: {
                    default: 'Kansas',
                },
                zip: '6[67]',
            },
            {
                key: 'KY',
                name: {
                    default: 'Kentucky',
                },
                zip: '4[01]|42[0-7]',
            },
            {
                key: 'LA',
                name: {
                    default: 'Louisiana',
                },
                zip: '70|71[0-5]',
            },
            {
                key: 'ME',
                name: {
                    default: 'Maine',
                },
                zip: '039|04',
            },
            {
                key: 'MH',
                name: {
                    default: 'Marshall Islands',
                },
                zip: '969[67]',
            },
            {
                key: 'MD',
                name: {
                    default: 'Maryland',
                },
                zip: '20[6-9]|21',
            },
            {
                key: 'MA',
                name: {
                    default: 'Massachusetts',
                },
                zip: '01|02[0-7]|05501|05544',
            },
            {
                key: 'MI',
                name: {
                    default: 'Michigan',
                },
                zip: '4[89]',
            },
            {
                key: 'FM',
                name: {
                    default: 'Micronesia',
                },
                zip: '9694[1-4]',
            },
            {
                key: 'MN',
                name: {
                    default: 'Minnesota',
                },
                zip: '55|56[0-7]',
            },
            {
                key: 'MS',
                name: {
                    default: 'Mississippi',
                },
                zip: '38[6-9]|39[0-7]',
            },
            {
                key: 'MO',
                name: {
                    default: 'Missouri',
                },
                zip: '6[3-5]',
            },
            {
                key: 'MT',
                name: {
                    default: 'Montana',
                },
                zip: '59',
            },
            {
                key: 'NE',
                name: {
                    default: 'Nebraska',
                },
                zip: '6[89]',
            },
            {
                key: 'NV',
                name: {
                    default: 'Nevada',
                },
                zip: '889|89',
            },
            {
                key: 'NH',
                name: {
                    default: 'New Hampshire',
                },
                zip: '03[0-8]',
            },
            {
                key: 'NJ',
                name: {
                    default: 'New Jersey',
                },
                zip: '0[78]',
            },
            {
                key: 'NM',
                name: {
                    default: 'New Mexico',
                },
                zip: '87|88[0-4]',
            },
            {
                key: 'NY',
                name: {
                    default: 'New York',
                },
                zip: '1[0-4]|06390|00501|00544',
            },
            {
                key: 'NC',
                name: {
                    default: 'North Carolina',
                },
                zip: '2[78]',
            },
            {
                key: 'ND',
                name: {
                    default: 'North Dakota',
                },
                zip: '58',
            },
            {
                key: 'MP',
                name: {
                    default: 'Northern Mariana Islands',
                },
                zip: '9695[0-2]',
            },
            {
                key: 'OH',
                name: {
                    default: 'Ohio',
                },
                zip: '4[3-5]',
            },
            {
                key: 'OK',
                name: {
                    default: 'Oklahoma',
                },
                zip: '7[34]',
            },
            {
                key: 'OR',
                name: {
                    default: 'Oregon',
                },
                zip: '97',
            },
            {
                key: 'PW',
                name: {
                    default: 'Palau',
                },
                zip: '969(39|40)',
            },
            {
                key: 'PA',
                name: {
                    default: 'Pennsylvania',
                },
                zip: '1[5-8]|19[0-6]',
            },
            {
                key: 'PR',
                name: {
                    default: 'Puerto Rico',
                },
                zip: '00[679]',
            },
            {
                key: 'RI',
                name: {
                    default: 'Rhode Island',
                },
                zip: '02[89]',
            },
            {
                key: 'SC',
                name: {
                    default: 'South Carolina',
                },
                zip: '29',
            },
            {
                key: 'SD',
                name: {
                    default: 'South Dakota',
                },
                zip: '57',
            },
            {
                key: 'TN',
                name: {
                    default: 'Tennessee',
                },
                zip: '37|38[0-5]',
            },
            {
                key: 'TX',
                name: {
                    default: 'Texas',
                },
                zip: '7[5-9]|885|73301|73344',
            },
            {
                key: 'UT',
                name: {
                    default: 'Utah',
                },
                zip: '84',
            },
            {
                key: 'VT',
                name: {
                    default: 'Vermont',
                },
                zip: '05',
            },
            {
                key: 'VI',
                name: {
                    default: 'Virgin Islands',
                },
                zip: '008',
            },
            {
                key: 'VA',
                name: {
                    default: 'Virginia',
                },
                zip: '201|2[23]|24[0-6]',
            },
            {
                key: 'WA',
                name: {
                    default: 'Washington',
                },
                zip: '98|99[0-4]',
            },
            {
                key: 'WV',
                name: {
                    default: 'West Virginia',
                },
                zip: '24[7-9]|2[56]',
            },
            {
                key: 'WI',
                name: {
                    default: 'Wisconsin',
                },
                zip: '5[34]',
            },
            {
                key: 'WY',
                name: {
                    default: 'Wyoming',
                },
                zip: '82|83[01]|83414',
            },
        ],
    },
    {
        id: 'data/UY',
        key: 'UY',
        name: 'URUGUAY',
        fmt: '%N%n%O%n%A%n%Z %C %S',
        zip: '\\d{5}',
        zipex: '11600',
        upper: 'CS',
        sub_regions: [
            {
                key: 'AR',
                name: {
                    default: 'Artigas',
                },
                zip: '55',
            },
            {
                key: 'CA',
                name: {
                    default: 'Canelones',
                },
                zip: '9[01]|1[456]',
            },
            {
                key: 'CL',
                name: {
                    default: 'Cerro Largo',
                },
                zip: '37',
            },
            {
                key: 'CO',
                name: {
                    default: 'Colonia',
                },
                zip: '70|75204',
            },
            {
                key: 'DU',
                name: {
                    default: 'Durazno',
                },
                zip: '97',
            },
            {
                key: 'FS',
                name: {
                    default: 'Flores',
                },
                zip: '85',
            },
            {
                key: 'FD',
                name: {
                    default: 'Florida',
                },
                zip: '94|9060|97005',
            },
            {
                key: 'LA',
                name: {
                    default: 'Lavalleja',
                },
                zip: '30',
            },
            {
                key: 'MA',
                name: {
                    default: 'Maldonado',
                },
                zip: '20',
            },
            {
                key: 'MO',
                name: {
                    default: 'Montevideo',
                },
                zip: '1|91600',
            },
            {
                key: 'PA',
                name: {
                    default: 'Paysandú',
                },
                zip: '60',
            },
            {
                key: 'RN',
                name: {
                    default: 'Río Negro',
                },
                zip: '65|60002',
            },
            {
                key: 'RV',
                name: {
                    default: 'Rivera',
                },
                zip: '40',
            },
            {
                key: 'RO',
                name: {
                    default: 'Rocha',
                },
                zip: '27',
            },
            {
                key: 'SA',
                name: {
                    default: 'Salto',
                },
                zip: '50',
            },
            {
                key: 'SJ',
                name: {
                    default: 'San José',
                },
                zip: '80',
            },
            {
                key: 'SO',
                name: {
                    default: 'Soriano',
                },
                zip: '75|70003',
            },
            {
                key: 'TA',
                name: {
                    default: 'Tacuarembó',
                },
                zip: '45',
            },
            {
                key: 'TT',
                name: {
                    default: 'Treinta y Tres',
                },
                zip: '33|30203|30204|30302|37007',
            },
        ],
    },
    {
        id: 'data/UZ',
        key: 'UZ',
        name: 'UZBEKISTAN',
        fmt: '%N%n%O%n%A%n%Z %C%n%S',
        zip: '\\d{6}',
        zipex: '702100,700000',
        upper: 'CS',
    },
    {
        id: 'data/VA',
        key: 'VA',
        name: 'VATICAN',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '00120',
        zipex: '00120',
    },
    {
        id: 'data/VC',
        key: 'VC',
        name: 'SAINT VINCENT AND THE GRENADINES (ANTILLES)',
        fmt: '%N%n%O%n%A%n%C %Z',
        zip: 'VC\\d{4}',
        zipex: 'VC0100,VC0110,VC0400',
    },
    {
        id: 'data/VE',
        key: 'VE',
        name: 'VENEZUELA',
        fmt: '%N%n%O%n%A%n%C %Z, %S',
        zip: '\\d{4}',
        zipex: '1010,3001,8011,1020',
        upper: 'CS',
        require: 'ACS',
        sub_regions: [
            {
                key: 'Z',
                name: {
                    default: 'Amazonas',
                },
            },
            {
                key: 'B',
                name: {
                    default: 'Anzoátegui',
                },
            },
            {
                key: 'C',
                name: {
                    default: 'Apure',
                },
            },
            {
                key: 'D',
                name: {
                    default: 'Aragua',
                },
            },
            {
                key: 'E',
                name: {
                    default: 'Barinas',
                },
            },
            {
                key: 'F',
                name: {
                    default: 'Bolívar',
                },
            },
            {
                key: 'G',
                name: {
                    default: 'Carabobo',
                },
            },
            {
                key: 'H',
                name: {
                    default: 'Cojedes',
                },
            },
            {
                key: 'Y',
                name: {
                    default: 'Delta Amacuro',
                },
            },
            {
                key: 'W',
                name: {
                    default: 'Dependencias Federales',
                },
            },
            {
                key: 'A',
                name: {
                    default: 'Distrito Federal',
                },
            },
            {
                key: 'I',
                name: {
                    default: 'Falcón',
                },
            },
            {
                key: 'J',
                name: {
                    default: 'Guárico',
                },
            },
            {
                key: 'K',
                name: {
                    default: 'Lara',
                },
            },
            {
                key: 'L',
                name: {
                    default: 'Mérida',
                },
            },
            {
                key: 'M',
                name: {
                    default: 'Miranda',
                },
            },
            {
                key: 'N',
                name: {
                    default: 'Monagas',
                },
            },
            {
                key: 'O',
                name: {
                    default: 'Nueva Esparta',
                },
            },
            {
                key: 'P',
                name: {
                    default: 'Portuguesa',
                },
            },
            {
                key: 'R',
                name: {
                    default: 'Sucre',
                },
            },
            {
                key: 'S',
                name: {
                    default: 'Táchira',
                },
            },
            {
                key: 'T',
                name: {
                    default: 'Trujillo',
                },
            },
            {
                key: 'X',
                name: {
                    default: 'Vargas',
                },
            },
            {
                key: 'U',
                name: {
                    default: 'Yaracuy',
                },
            },
            {
                key: 'V',
                name: {
                    default: 'Zulia',
                },
            },
        ],
    },
    {
        id: 'data/VG',
        key: 'VG',
        name: 'VIRGIN ISLANDS (BRITISH)',
        fmt: '%N%n%O%n%A%n%C%n%Z',
        zip: 'VG\\d{4}',
        zipex: 'VG1110,VG1150,VG1160',
        require: 'A',
    },
    {
        id: 'data/VI',
        key: 'VI',
        name: 'VIRGIN ISLANDS (U.S.)',
        fmt: '%N%n%O%n%A%n%C %S %Z',
        zip: '(008(?:(?:[0-4]\\d)|(?:5[01])))(?:[ \\-](\\d{4}))?',
        zipex: '00802-1222,00850-9802',
        upper: 'ACNOS',
        require: 'ACSZ',
    },
    {
        id: 'data/VN',
        key: 'VN',
        name: 'VIET NAM',
        fmt: '%N%n%O%n%A%n%C%n%S %Z',
        lfmt: '%N%n%O%n%A%n%C%n%S %Z',
        zip: '\\d{5}\\d?',
        zipex: '70010,55999',
        sub_regions: [
            {
                key: '44',
                name: {
                    default: 'An Giang',
                    latin: 'An Giang Province',
                },
            },
            {
                key: '43',
                name: {
                    default: 'Bà Rịa–Vũng Tàu',
                    latin: 'Ba Ria-Vung Tau Province',
                },
            },
            {
                key: '55',
                name: {
                    default: 'Bạc Liêu',
                    latin: 'Bac Lieu Province',
                },
            },
            {
                key: '54',
                name: {
                    default: 'Bắc Giang',
                    latin: 'Bac Giang Province',
                },
            },
            {
                key: '53',
                name: {
                    default: 'Bắc Kạn',
                    latin: 'Bac Kan Province',
                },
            },
            {
                key: '56',
                name: {
                    default: 'Bắc Ninh',
                    latin: 'Bac Ninh Province',
                },
            },
            {
                key: '50',
                name: {
                    default: 'Bến Tre',
                    latin: 'Ben Tre Province',
                },
            },
            {
                key: '57',
                name: {
                    default: 'Bình Dương',
                    latin: 'Binh Duong Province',
                },
            },
            {
                key: '31',
                name: {
                    default: 'Bình Định',
                    latin: 'Binh Dinh Province',
                },
            },
            {
                key: '58',
                name: {
                    default: 'Bình Phước',
                    latin: 'Binh Phuoc Province',
                },
            },
            {
                key: '40',
                name: {
                    default: 'Bình Thuận',
                    latin: 'Binh Thuan Province',
                },
            },
            {
                key: '59',
                name: {
                    default: 'Cà Mau',
                    latin: 'Ca Mau Province',
                },
            },
            {
                key: '04',
                name: {
                    default: 'Cao Bằng',
                    latin: 'Cao Bang Province',
                },
            },
            {
                key: 'CT',
                name: {
                    default: 'Cần Thơ',
                    latin: 'Can Tho City',
                },
            },
            {
                key: 'DN',
                name: {
                    default: 'Đà Nẵng',
                    latin: 'Da Nang City',
                },
            },
            {
                key: '33',
                name: {
                    default: 'Đắk Lắk',
                    latin: 'Dak Lak Province',
                },
            },
            {
                key: '72',
                name: {
                    default: 'Đăk Nông',
                    latin: 'Dak Nong Province',
                },
            },
            {
                key: '71',
                name: {
                    default: 'Điện Biên',
                    latin: 'Dien Bien Province',
                },
            },
            {
                key: '39',
                name: {
                    default: 'Đồng Nai',
                    latin: 'Dong Nai Province',
                },
            },
            {
                key: '45',
                name: {
                    default: 'Đồng Tháp',
                    latin: 'Dong Thap Province',
                },
            },
            {
                key: '30',
                name: {
                    default: 'Gia Lai',
                    latin: 'Gia Lai Province',
                },
            },
            {
                key: '03',
                name: {
                    default: 'Hà Giang',
                    latin: 'Ha Giang Province',
                },
            },
            {
                key: '63',
                name: {
                    default: 'Hà Nam',
                    latin: 'Ha Nam Province',
                },
            },
            {
                key: 'HN',
                name: {
                    default: 'Hà Nội',
                    latin: 'Hanoi City',
                },
            },
            {
                key: '23',
                name: {
                    default: 'Hà Tĩnh',
                    latin: 'Ha Tinh Province',
                },
            },
            {
                key: '61',
                name: {
                    default: 'Hải Dương',
                    latin: 'Hai Duong Province',
                },
            },
            {
                key: 'HP',
                name: {
                    default: 'Hải Phòng',
                    latin: 'Haiphong City',
                },
            },
            {
                key: '73',
                name: {
                    default: 'Hậu Giang',
                    latin: 'Hau Giang Province',
                },
            },
            {
                key: '14',
                name: {
                    default: 'Hòa Bình',
                    latin: 'Hoa Binh Province',
                },
            },
            {
                key: '66',
                name: {
                    default: 'Hưng Yên',
                    latin: 'Hung Yen Province',
                },
            },
            {
                key: '34',
                name: {
                    default: 'Khánh Hòa',
                    latin: 'Khanh Hoa Province',
                },
            },
            {
                key: '47',
                name: {
                    default: 'Kiên Giang',
                    latin: 'Kien Giang Province',
                },
            },
            {
                key: '28',
                name: {
                    default: 'Kon Tum',
                    latin: 'Kon Tum Province',
                },
            },
            {
                key: '01',
                name: {
                    default: 'Lai Châu',
                    latin: 'Lai Chau Province',
                },
            },
            {
                key: '09',
                name: {
                    default: 'Lạng Sơn',
                    latin: 'Lang Song Province',
                },
            },
            {
                key: '02',
                name: {
                    default: 'Lào Cai',
                    latin: 'Lao Cai Province',
                },
            },
            {
                key: '35',
                name: {
                    default: 'Lâm Đồng',
                    latin: 'Lam Dong Province',
                },
            },
            {
                key: '41',
                name: {
                    default: 'Long An',
                    latin: 'Long An Province',
                },
            },
            {
                key: '67',
                name: {
                    default: 'Nam Định',
                    latin: 'Nam Dinh Province',
                },
            },
            {
                key: '22',
                name: {
                    default: 'Nghệ An',
                    latin: 'Nghe An Province',
                },
            },
            {
                key: '18',
                name: {
                    default: 'Ninh Bình',
                    latin: 'Ninh Binh Province',
                },
            },
            {
                key: '36',
                name: {
                    default: 'Ninh Thuận',
                    latin: 'Ninh Thuan Province',
                },
            },
            {
                key: '68',
                name: {
                    default: 'Phú Thọ',
                    latin: 'Phu Tho Province',
                },
            },
            {
                key: '32',
                name: {
                    default: 'Phú Yên',
                    latin: 'Phu Yen Province',
                },
            },
            {
                key: '24',
                name: {
                    default: 'Quảng Bình',
                    latin: 'Quang Binh Province',
                },
            },
            {
                key: '27',
                name: {
                    default: 'Quảng Nam',
                    latin: 'Quang Nam Province',
                },
            },
            {
                key: '29',
                name: {
                    default: 'Quảng Ngãi',
                    latin: 'Quang Ngai Province',
                },
            },
            {
                key: '13',
                name: {
                    default: 'Quảng Ninh',
                    latin: 'Quang Ninh Province',
                },
            },
            {
                key: '25',
                name: {
                    default: 'Quảng Trị',
                    latin: 'Quang Tri Province',
                },
            },
            {
                key: '52',
                name: {
                    default: 'Sóc Trăng',
                    latin: 'Soc Trang Province',
                },
            },
            {
                key: '05',
                name: {
                    default: 'Sơn La',
                    latin: 'Son La Province',
                },
            },
            {
                key: '37',
                name: {
                    default: 'Tây Ninh',
                    latin: 'Tay Ninh Province',
                },
            },
            {
                key: '20',
                name: {
                    default: 'Thái Bình',
                    latin: 'Thai Binh Province',
                },
            },
            {
                key: '69',
                name: {
                    default: 'Thái Nguyên',
                    latin: 'Thai Nguyen Province',
                },
            },
            {
                key: '21',
                name: {
                    default: 'Thanh Hóa',
                    latin: 'Thanh Hoa Province',
                },
            },
            {
                key: 'SG',
                name: {
                    default: 'Thành phố Hồ Chí Minh',
                    latin: 'Ho Chi Minh City',
                },
            },
            {
                key: '26',
                name: {
                    default: 'Thừa Thiên–Huế',
                    latin: 'Thua Thien-Hue Province',
                },
            },
            {
                key: '46',
                name: {
                    default: 'Tiền Giang',
                    latin: 'Tien Giang Province',
                },
            },
            {
                key: '51',
                name: {
                    default: 'Trà Vinh',
                    latin: 'Tra Vinh Province',
                },
            },
            {
                key: '07',
                name: {
                    default: 'Tuyên Quang',
                    latin: 'Tuyen Quang Province',
                },
            },
            {
                key: '49',
                name: {
                    default: 'Vĩnh Long',
                    latin: 'Vinh Long Province',
                },
            },
            {
                key: '70',
                name: {
                    default: 'Vĩnh Phúc',
                    latin: 'Vinh Phuc Province',
                },
            },
            {
                key: '06',
                name: {
                    default: 'Yên Bái',
                    latin: 'Yen Bai Province',
                },
            },
        ],
    },
    {
        id: 'data/VU',
        key: 'VU',
        name: 'VANUATU',
    },
    {
        id: 'data/WF',
        key: 'WF',
        name: 'WALLIS AND FUTUNA ISLANDS',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '986\\d{2}',
        zipex: '98600',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/WS',
        key: 'WS',
        name: 'SAMOA',
    },
    {
        id: 'data/XK',
        key: 'XK',
        name: 'KOSOVO',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '[1-7]\\d{4}',
        zipex: '10000',
    },
    {
        id: 'data/YE',
        key: 'YE',
        name: 'YEMEN',
    },
    {
        id: 'data/YT',
        key: 'YT',
        name: 'MAYOTTE',
        fmt: '%O%n%N%n%A%n%Z %C %X',
        zip: '976\\d{2}',
        zipex: '97600',
        upper: 'ACX',
        require: 'ACZ',
    },
    {
        id: 'data/ZA',
        key: 'ZA',
        name: 'SOUTH AFRICA',
        fmt: '%N%n%O%n%A%n%D%n%C%n%Z',
        zip: '\\d{4}',
        zipex: '0083,1451,0001',
        require: 'ACZ',
    },
    {
        id: 'data/ZM',
        key: 'ZM',
        name: 'ZAMBIA',
        fmt: '%N%n%O%n%A%n%Z %C',
        zip: '\\d{5}',
        zipex: '50100,50101',
    },
    {
        id: 'data/ZW',
        key: 'ZW',
        name: 'ZIMBABWE',
    },
] satisfies CountryData[]

let addressCountriesRegistered = false

export const registerAddressCountries = () => {
    if (addressCountriesRegistered) {
        return
    }

    addressCountries.forEach((country) => registerCountry(country))
    addressCountriesRegistered = true
}
